import { NodeModel, NodeConstraints } from '@syncfusion/ej2-diagrams';

export class FloorplanShapes {

    public getFloorPlans(): NodeModel[] {

        let floorPlanShapes: NodeModel[] = [
            {
                "id": "Artboard2copy502VoWOOh",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 10
                },
                "style": {
                    "fill": "#a2a2a3"
                },
                "width": 137,
                "height": 137,
                "offsetX": 80.5,
                "offsetY": 78.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy50309Dl2Td",
                "shape": {
                    "type": "Path",
                    "data": "M50.5,65A20.5,20.5,0,1,1,71,44.5,20.53,20.53,0,0,1,50.5,65Zm0-38A17.5,17.5,0,1,0,68,44.5,17.52,17.52,0,0,0,50.5,27Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 40.999996185302734,
                "height": 41.000003814697266,
                "offsetX": 50.4999942779541,
                "offsetY": 44.49999809265137,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5031QHKZfj",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 25,
                "height": 25,
                "offsetX": 50.5,
                "offsetY": 44.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5040C4QNsM",
                "shape": {
                    "type": "Path",
                    "data": "M110.5,65A20.5,20.5,0,1,1,131,44.5,20.53,20.53,0,0,1,110.5,65Zm0-38A17.5,17.5,0,1,0,128,44.5,17.52,17.52,0,0,0,110.5,27Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 41.00000762939453,
                "height": 41.000003814697266,
                "offsetX": 110.49999618530273,
                "offsetY": 44.49999809265137,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5041jwHXUP",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 25,
                "height": 25,
                "offsetX": 110.5,
                "offsetY": 44.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5050BmOpN7",
                "shape": {
                    "type": "Path",
                    "data": "M50.5,120A20.5,20.5,0,1,1,71,99.5,20.53,20.53,0,0,1,50.5,120Zm0-38A17.5,17.5,0,1,0,68,99.5,17.52,17.52,0,0,0,50.5,82Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 40.999996185302734,
                "height": 41.00000762939453,
                "offsetX": 50.4999942779541,
                "offsetY": 99.49999618530273,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5051to4C8k",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 25,
                "height": 25,
                "offsetX": 50.5,
                "offsetY": 99.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5060zsMylX",
                "shape": {
                    "type": "Path",
                    "data": "M110.5,120A20.5,20.5,0,1,1,131,99.5,20.53,20.53,0,0,1,110.5,120Zm0-38A17.5,17.5,0,1,0,128,99.5,17.52,17.52,0,0,0,110.5,82Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 41.00000762939453,
                "height": 41.00000762939453,
                "offsetX": 110.49999618530273,
                "offsetY": 99.49999618530273,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5061tFRZxi",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 25,
                "height": 25,
                "offsetX": 110.5,
                "offsetY": 99.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5073Ca993",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 19,
                "height": 19,
                "offsetX": 50.5,
                "offsetY": 44.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy508OPRnNN",
                "shape": {
                    "type": "Path",
                    "data": "M51 24 50 24 50 35 50.5 35 51 35 51 24"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 1,
                "height": 11,
                "offsetX": 50.5,
                "offsetY": 29.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy509UPtCjH",
                "shape": {
                    "type": "Path",
                    "data": "M50 65 51 65 51 54 50.5 54 50 54 50 65"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 1,
                "height": 11,
                "offsetX": 50.5,
                "offsetY": 59.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5010tkE8E4",
                "shape": {
                    "type": "Path",
                    "data": "M30 44 30 45 41 45 41 44.5 41 44 30 44"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 11,
                "height": 1,
                "offsetX": 35.5,
                "offsetY": 44.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5011fxfxbI",
                "shape": {
                    "type": "Path",
                    "data": "M60 44 60 44.5 60 45 71 45 71 44 60 44"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 11,
                "height": 1,
                "offsetX": 65.5,
                "offsetY": 44.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5012StYDyA",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 19,
                "height": 19,
                "offsetX": 110.5,
                "offsetY": 44.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5013FTAvIZ",
                "shape": {
                    "type": "Path",
                    "data": "M111 24 110 24 110 35 110.5 35 111 35 111 24"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 1,
                "height": 11,
                "offsetX": 110.5,
                "offsetY": 29.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5014ZFxw9j",
                "shape": {
                    "type": "Path",
                    "data": "M110 65 111 65 111 54 110.5 54 110 54 110 65"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 1,
                "height": 11,
                "offsetX": 110.5,
                "offsetY": 59.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5015w1runT",
                "shape": {
                    "type": "Path",
                    "data": "M90 44 90 45 101 45 101 44.5 101 44 90 44"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 11,
                "height": 1,
                "offsetX": 95.5,
                "offsetY": 44.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5016WN9BYt",
                "shape": {
                    "type": "Path",
                    "data": "M120 44 120 44.5 120 45 131 45 131 44 120 44"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 11,
                "height": 1,
                "offsetX": 125.5,
                "offsetY": 44.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy50175RJCbW",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 19,
                "height": 19,
                "offsetX": 50.5,
                "offsetY": 99.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5018p4MBjX",
                "shape": {
                    "type": "Path",
                    "data": "M51 79 50 79 50 90 50.5 90 51 90 51 79"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 1,
                "height": 11,
                "offsetX": 50.5,
                "offsetY": 84.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5019eWh8wd",
                "shape": {
                    "type": "Path",
                    "data": "M50 120 51 120 51 109 50.5 109 50 109 50 120"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 1,
                "height": 11,
                "offsetX": 50.5,
                "offsetY": 114.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5020nbIzOI",
                "shape": {
                    "type": "Path",
                    "data": "M30 99 30 100 41 100 41 99.5 41 99 30 99"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 11,
                "height": 1,
                "offsetX": 35.5,
                "offsetY": 99.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5021Mqsk2t",
                "shape": {
                    "type": "Path",
                    "data": "M60 99 60 99.5 60 100 71 100 71 99 60 99"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 11,
                "height": 1,
                "offsetX": 65.5,
                "offsetY": 99.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5022lQbJP6",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 19,
                "height": 19,
                "offsetX": 110.5,
                "offsetY": 99.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy50237vXMEB",
                "shape": {
                    "type": "Path",
                    "data": "M111 79 110 79 110 90 110.5 90 111 90 111 79"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 1,
                "height": 11,
                "offsetX": 110.5,
                "offsetY": 84.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5024nW23ne",
                "shape": {
                    "type": "Path",
                    "data": "M110 120 111 120 111 109 110.5 109 110 109 110 120"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 1,
                "height": 11,
                "offsetX": 110.5,
                "offsetY": 114.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5025GQ3Sl7",
                "shape": {
                    "type": "Path",
                    "data": "M90 99 90 100 101 100 101 99.5 101 99 90 99"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 11,
                "height": 1,
                "offsetX": 95.5,
                "offsetY": 99.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5026eoX2Ln",
                "shape": {
                    "type": "Path",
                    "data": "M120 99 120 99.5 120 100 131 100 131 99 120 99"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 11,
                "height": 1,
                "offsetX": 125.5,
                "offsetY": 99.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5027b97sAo",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#6b6c6d"
                },
                "width": 10,
                "height": 10,
                "offsetX": 57,
                "offsetY": 136,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy50284nkNMj",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#6b6c6d"
                },
                "width": 10,
                "height": 10,
                "offsetX": 74,
                "offsetY": 136,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy5029ajb6nw",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#6b6c6d"
                },
                "width": 10,
                "height": 10,
                "offsetX": 91,
                "offsetY": 136,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy50307mLgw3",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#6b6c6d"
                },
                "width": 10,
                "height": 10,
                "offsetX": 108,
                "offsetY": 136,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard2copy50",
                "children": ["Artboard2copy502VoWOOh", "Artboard2copy50309Dl2Td", "Artboard2copy5031QHKZfj", "Artboard2copy5040C4QNsM", "Artboard2copy5041jwHXUP", "Artboard2copy5050BmOpN7", "Artboard2copy5051to4C8k", "Artboard2copy5060zsMylX", "Artboard2copy5061tFRZxi", "Artboard2copy5073Ca993", "Artboard2copy508OPRnNN", "Artboard2copy509UPtCjH", "Artboard2copy5010tkE8E4", "Artboard2copy5011fxfxbI", "Artboard2copy5012StYDyA", "Artboard2copy5013FTAvIZ", "Artboard2copy5014ZFxw9j", "Artboard2copy5015w1runT", "Artboard2copy5016WN9BYt", "Artboard2copy50175RJCbW", "Artboard2copy5018p4MBjX", "Artboard2copy5019eWh8wd", "Artboard2copy5020nbIzOI", "Artboard2copy5021Mqsk2t", "Artboard2copy5022lQbJP6", "Artboard2copy50237vXMEB", "Artboard2copy5024nW23ne", "Artboard2copy5025GQ3Sl7", "Artboard2copy5026eoX2Ln", "Artboard2copy5027b97sAo", "Artboard2copy50284nkNMj", "Artboard2copy5029ajb6nw", "Artboard2copy50307mLgw3"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96200iZDjCQ",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1.8299999237060547,
                "height": 38.36000061035156,
                "offsetX": 50.1949987411499,
                "offsetY": 68.45999908447266,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96201SNRs2d",
                "shape": {
                    "type": "Path",
                    "data": "M51.11,88V49.28h0a34.1,34.1,0,0,1,34.1,34.1V88"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747",
                    "strokeWidth": 0
                },
                "width": 34.100006103515625,
                "height": 38.720001220703125,
                "offsetX": 68.16000366210938,
                "offsetY": 68.63999938964844,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96202z1TvRU",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1.8299999237060547,
                "height": 38.36000061035156,
                "offsetX": 122.305006980896,
                "offsetY": 68.45999908447266,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962034HyXHU",
                "shape": {
                    "type": "Path",
                    "data": "M123.22,88V49.28h0a34.1,34.1,0,0,1,34.09,34.1V88"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747",
                    "strokeWidth": 0
                },
                "width": 34.089996337890625,
                "height": 38.720001220703125,
                "offsetX": 140.26499938964844,
                "offsetY": 68.63999938964844,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204yiq8vH",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1.8299999237060547,
                "height": 38.36000061035156,
                "offsetX": 192.32498836517334,
                "offsetY": 68.45999908447266,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96205gt2kyV",
                "shape": {
                    "type": "Path",
                    "data": "M191.41,88V49.28h0a34.1,34.1,0,0,0-34.1,34.1V88"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747",
                    "strokeWidth": 0
                },
                "width": 34.100006103515625,
                "height": 38.720001220703125,
                "offsetX": 174.36000061035156,
                "offsetY": 68.63999938964844,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96206ziGm9D",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.290000915527344,
                "height": 1.8200000524520874,
                "offsetX": 243.72500228881836,
                "offsetY": 70.28999727964401,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962073KiKTM",
                "shape": {
                    "type": "Path",
                    "data": "M257.91,57.4l.84.94A33.41,33.41,0,0,1,267,83.5l-.09,1"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747",
                    "strokeWidth": 0
                },
                "width": 9.22698974609375,
                "height": 27.099998474121094,
                "offsetX": 262.52349853515625,
                "offsetY": 70.95000076293945,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96208Qo1qWp",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 3.0399999618530273,
                "height": 38.36000061035156,
                "offsetX": 321.5700182914734,
                "offsetY": 73.93999862670898,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96209v2RpAZ",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 3.0399999618530273,
                "height": 38.36000061035156,
                "offsetX": 346.5300097465515,
                "offsetY": 76.98999786376953,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962010mx4Go3",
                "shape": {
                    "type": "Path",
                    "data": "M446.3 72.42 407.63 72.42 407.63 79.12 446.3 79.12"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.66998291015625,
                "height": 6.700004577636719,
                "offsetX": 426.9649963378906,
                "offsetY": 75.77000045776367,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962011Gmn478",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 3.0399999618530273,
                "height": 38.36000061035156,
                "offsetX": 451.7800097465515,
                "offsetY": 75.77000045776367,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962012dpQYJ8",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff",
                    "strokeColor": "#464747"
                },
                "width": 71.30999755859375,
                "height": 34.290000915527344,
                "offsetX": 65.99499702453613,
                "offsetY": 195.48501205444336,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962013bmOIJE",
                "shape": {
                    "type": "Path",
                    "data": "M 35.83 , 178.69 L 35.83 , 212.97"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 34.279998779296875,
                "offsetX": 36.33000183105469,
                "offsetY": 195.8300018310547,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962014MmVQFx",
                "shape": {
                    "type": "Path",
                    "data": "M 41.31 , 178.69 L 41.31 , 212.97"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 34.279998779296875,
                "offsetX": 41.810001373291016,
                "offsetY": 195.8300018310547,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620154TllUm",
                "shape": {
                    "type": "Path",
                    "data": "M 46.8 , 178.69 L 46.8 , 212.97"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 34.279998779296875,
                "offsetX": 47.29999923706055,
                "offsetY": 195.8300018310547,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962016wiRCDb",
                "shape": {
                    "type": "Path",
                    "data": "M 57.77 , 178.69 L 57.77 , 212.97"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 34.279998779296875,
                "offsetX": 58.27000045776367,
                "offsetY": 195.8300018310547,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620178N4Ebc",
                "shape": {
                    "type": "Path",
                    "data": "M 52.29 , 178.69 L 52.29 , 212.97"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 34.279998779296875,
                "offsetX": 52.790000915527344,
                "offsetY": 195.8300018310547,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962018CZ8CAc",
                "shape": {
                    "type": "Path",
                    "data": "M 63.26 , 178.69 L 63.26 , 212.97"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 34.279998779296875,
                "offsetX": 63.7599983215332,
                "offsetY": 195.8300018310547,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962019qcRxqv",
                "shape": {
                    "type": "Path",
                    "data": "M 68.74 , 178.69 L 68.74 , 212.97"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 34.279998779296875,
                "offsetX": 69.23999786376953,
                "offsetY": 195.8300018310547,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962020L2F2up",
                "shape": {
                    "type": "Path",
                    "data": "M 74.23 , 178.69 L 74.23 , 212.97"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 34.279998779296875,
                "offsetX": 74.7300033569336,
                "offsetY": 195.8300018310547,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962021Kjn7G3",
                "shape": {
                    "type": "Path",
                    "data": "M 79.71 , 178.69 L 79.71 , 212.97"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 34.279998779296875,
                "offsetX": 80.20999908447266,
                "offsetY": 195.8300018310547,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962022Otbuay",
                "shape": {
                    "type": "Path",
                    "data": "M 85.2 , 178.69 L 85.2 , 212.97"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 34.279998779296875,
                "offsetX": 85.69999694824219,
                "offsetY": 195.8300018310547,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962023M8DeX6",
                "shape": {
                    "type": "Path",
                    "data": "M 90.69 , 178.69 L 90.69 , 212.97"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 34.279998779296875,
                "offsetX": 91.19000244140625,
                "offsetY": 195.8300018310547,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962024T5X6g4",
                "shape": {
                    "type": "Path",
                    "data": "M 96.17 , 178.69 L 96.17 , 212.97"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 34.279998779296875,
                "offsetX": 96.66999816894531,
                "offsetY": 195.8300018310547,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962025XMSIYx",
                "shape": {
                    "type": "Path",
                    "data": "M162.06 180.54 162.06 270.57 140.6 270.57 119.98 270.57 119.98 180.54 210.01 180.54 210.01 222.61 119.98 222.61"
                },
                "style": {
                    "fill": "#fff",
                    "strokeColor": "#464747"
                },
                "width": 90.02999114990234,
                "height": 90.03001403808594,
                "offsetX": 164.99499893188477,
                "offsetY": 225.55500030517578,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962026yl5ydP",
                "shape": {
                    "type": "Path",
                    "data": "M 169.35 , 180.54 L 169.35 , 222.61"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 42.07000732421875,
                "offsetX": 169.85000610351562,
                "offsetY": 201.5749969482422,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962027srWUy6",
                "shape": {
                    "type": "Path",
                    "data": "M 176.22 , 180.54 L 176.22 , 222.61"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 42.07000732421875,
                "offsetX": 176.72000122070312,
                "offsetY": 201.5749969482422,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962028d3zxbO",
                "shape": {
                    "type": "Path",
                    "data": "M 183.09 , 180.54 L 183.09 , 222.61"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 42.07000732421875,
                "offsetX": 183.58999633789062,
                "offsetY": 201.5749969482422,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962029qpxXn9",
                "shape": {
                    "type": "Path",
                    "data": "M 189.96 , 180.54 L 189.96 , 222.61"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 42.07000732421875,
                "offsetX": 190.4600067138672,
                "offsetY": 201.5749969482422,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962030ORVLeK",
                "shape": {
                    "type": "Path",
                    "data": "M 196.83 , 180.54 L 196.83 , 222.61"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 42.07000732421875,
                "offsetX": 197.3300018310547,
                "offsetY": 201.5749969482422,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962031Jymwap",
                "shape": {
                    "type": "Path",
                    "data": "M 203.7 , 180.54 L 203.7 , 222.61"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 42.07000732421875,
                "offsetX": 204.1999969482422,
                "offsetY": 201.5749969482422,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962032ms8kYQ",
                "shape": {
                    "type": "Path",
                    "data": "M 162.06 , 229.9 L 119.99 , 229.9"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 42.06999969482422,
                "height": 1,
                "offsetX": 141.02499771118164,
                "offsetY": 230.39999389648438,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962033LrXN24",
                "shape": {
                    "type": "Path",
                    "data": "M 162.06 , 236.77 L 119.99 , 236.77"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 42.06999969482422,
                "height": 1,
                "offsetX": 141.02499771118164,
                "offsetY": 237.27000427246094,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962034GLJDsu",
                "shape": {
                    "type": "Path",
                    "data": "M 162.06 , 243.65 L 119.99 , 243.65"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 42.06999969482422,
                "height": 1,
                "offsetX": 141.02499771118164,
                "offsetY": 244.14999389648438,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962035F5KivE",
                "shape": {
                    "type": "Path",
                    "data": "M 162.06 , 250.52 L 119.99 , 250.52"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 42.06999969482422,
                "height": 1,
                "offsetX": 141.02499771118164,
                "offsetY": 251.02000427246094,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962036TheFvq",
                "shape": {
                    "type": "Path",
                    "data": "M 162.06 , 257.39 L 119.99 , 257.39"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 42.06999969482422,
                "height": 1,
                "offsetX": 141.02499771118164,
                "offsetY": 257.8900146484375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962037fBpETg",
                "shape": {
                    "type": "Path",
                    "data": "M 162.06 , 264.26 L 119.99 , 264.26"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 42.06999969482422,
                "height": 1,
                "offsetX": 141.02499771118164,
                "offsetY": 264.760009765625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962038H4eNMd",
                "shape": {
                    "type": "Path",
                    "data": "M114.98 378.62 95.44 378.62 76.66 378.62 76.66 335.7 66.7 335.7 66.7 378.62 47.16 378.62 28.38 378.62 28.38 297.38 114.98 297.38 114.98 378.62"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 86.60000610351562,
                "height": 81.239990234375,
                "offsetX": 71.68000221252441,
                "offsetY": 338,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962039TpBB3s",
                "shape": {
                    "type": "Path",
                    "data": "M 66.7 , 335.7 L 28.38 , 335.7"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999969482422,
                "height": 1,
                "offsetX": 47.53999900817871,
                "offsetY": 336.20001220703125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962040JWRQgv",
                "shape": {
                    "type": "Path",
                    "data": "M 66.7 , 341.83 L 28.38 , 341.83"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999969482422,
                "height": 1,
                "offsetX": 47.53999900817871,
                "offsetY": 342.3299865722656,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962041JWInEv",
                "shape": {
                    "type": "Path",
                    "data": "M 66.7 , 347.96 L 28.38 , 347.96"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999969482422,
                "height": 1,
                "offsetX": 47.53999900817871,
                "offsetY": 348.4599914550781,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962042RP8UTz",
                "shape": {
                    "type": "Path",
                    "data": "M 66.7 , 354.09 L 28.38 , 354.09"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999969482422,
                "height": 1,
                "offsetX": 47.53999900817871,
                "offsetY": 354.5899963378906,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620436WsSlc",
                "shape": {
                    "type": "Path",
                    "data": "M 66.7 , 360.22 L 28.38 , 360.22"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999969482422,
                "height": 1,
                "offsetX": 47.53999900817871,
                "offsetY": 360.7200012207031,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962044weH4bg",
                "shape": {
                    "type": "Path",
                    "data": "M 66.7 , 366.36 L 28.38 , 366.36"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999969482422,
                "height": 1,
                "offsetX": 47.53999900817871,
                "offsetY": 366.8599853515625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962045isavtl",
                "shape": {
                    "type": "Path",
                    "data": "M 114.98 , 335.7 L 76.66 , 335.7"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999969482422,
                "height": 1,
                "offsetX": 95.82000350952148,
                "offsetY": 336.20001220703125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962046LGjRgq",
                "shape": {
                    "type": "Path",
                    "data": "M 114.98 , 341.83 L 76.66 , 341.83"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999969482422,
                "height": 1,
                "offsetX": 95.82000350952148,
                "offsetY": 342.3299865722656,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047VP8pbC",
                "shape": {
                    "type": "Path",
                    "data": "M 114.98 , 347.96 L 76.66 , 347.96"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999969482422,
                "height": 1,
                "offsetX": 95.82000350952148,
                "offsetY": 348.4599914550781,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962048SkLSqQ",
                "shape": {
                    "type": "Path",
                    "data": "M 114.98 , 354.09 L 76.66 , 354.09"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999969482422,
                "height": 1,
                "offsetX": 95.82000350952148,
                "offsetY": 354.5899963378906,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962049QNTFnv",
                "shape": {
                    "type": "Path",
                    "data": "M 114.98 , 360.22 L 76.66 , 360.22"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999969482422,
                "height": 1,
                "offsetX": 95.82000350952148,
                "offsetY": 360.7200012207031,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620502LMhwe",
                "shape": {
                    "type": "Path",
                    "data": "M 114.98 , 366.36 L 76.66 , 366.36"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999969482422,
                "height": 1,
                "offsetX": 95.82000350952148,
                "offsetY": 366.8599853515625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962051rOcpkE",
                "shape": {
                    "type": "Path",
                    "data": "M 115.36 , 372.49 L 77.05 , 372.49"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.30999755859375,
                "height": 1,
                "offsetX": 96.20500183105469,
                "offsetY": 372.989990234375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620525aeDuF",
                "shape": {
                    "type": "Path",
                    "data": "M 66.32 , 372.49 L 28 , 372.49"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999969482422,
                "height": 1,
                "offsetX": 47.15999984741211,
                "offsetY": 372.989990234375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962053dO7KFd",
                "shape": {
                    "type": "Path",
                    "data": "M286.02 179.5 286.02 270.57 264.32 270.57 243.46 270.57 243.46 179.5 334.54 179.5 334.54 222.06 243.46 222.06"
                },
                "style": {
                    "fill": "#fff",
                    "strokeColor": "#464747"
                },
                "width": 91.08000183105469,
                "height": 91.07000732421875,
                "offsetX": 289.00000762939453,
                "offsetY": 225.03500366210938,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962054NZgs9k",
                "shape": {
                    "type": "Path",
                    "data": "M 293.4 , 179.5 L 293.4 , 222.06"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 42.55999755859375,
                "offsetX": 293.8999938964844,
                "offsetY": 200.77999877929688,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962055rVvGTj",
                "shape": {
                    "type": "Path",
                    "data": "M 300.35 , 179.5 L 300.35 , 222.06"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 42.55999755859375,
                "offsetX": 300.8500061035156,
                "offsetY": 200.77999877929688,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962056qmBNrw",
                "shape": {
                    "type": "Path",
                    "data": "M 307.3 , 179.5 L 307.3 , 222.06"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 42.55999755859375,
                "offsetX": 307.79998779296875,
                "offsetY": 200.77999877929688,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962057FkTGFe",
                "shape": {
                    "type": "Path",
                    "data": "M 314.25 , 179.5 L 314.25 , 222.06"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 42.55999755859375,
                "offsetX": 314.75,
                "offsetY": 200.77999877929688,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962058o5lGqt",
                "shape": {
                    "type": "Path",
                    "data": "M 321.2 , 179.5 L 321.2 , 222.06"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 42.55999755859375,
                "offsetX": 321.70001220703125,
                "offsetY": 200.77999877929688,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962059KK9FAH",
                "shape": {
                    "type": "Path",
                    "data": "M 328.15 , 179.5 L 328.15 , 222.06"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 42.55999755859375,
                "offsetX": 328.6499938964844,
                "offsetY": 200.77999877929688,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620604ryNJf",
                "shape": {
                    "type": "Path",
                    "data": "M 286.02 , 229.43 L 243.46 , 229.43"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 42.55998229980469,
                "height": 1,
                "offsetX": 264.73999786376953,
                "offsetY": 229.92999267578125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962061elwdXr",
                "shape": {
                    "type": "Path",
                    "data": "M 286.02 , 236.39 L 243.46 , 236.39"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 42.55998229980469,
                "height": 1,
                "offsetX": 264.73999786376953,
                "offsetY": 236.88999938964844,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962062yFkYoF",
                "shape": {
                    "type": "Path",
                    "data": "M 286.02 , 243.34 L 243.46 , 243.34"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 42.55998229980469,
                "height": 1,
                "offsetX": 264.73999786376953,
                "offsetY": 243.83999633789062,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962063VGau5n",
                "shape": {
                    "type": "Path",
                    "data": "M 286.02 , 250.29 L 243.46 , 250.29"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 42.55998229980469,
                "height": 1,
                "offsetX": 264.73999786376953,
                "offsetY": 250.7899932861328,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962064UKc5CI",
                "shape": {
                    "type": "Path",
                    "data": "M 286.02 , 257.24 L 243.46 , 257.24"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 42.55998229980469,
                "height": 1,
                "offsetX": 264.73999786376953,
                "offsetY": 257.739990234375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962065egus4B",
                "shape": {
                    "type": "Path",
                    "data": "M 286.02 , 264.19 L 243.46 , 264.19"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 42.55998229980469,
                "height": 1,
                "offsetX": 264.73999786376953,
                "offsetY": 264.69000244140625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962066i6ZyjJ",
                "shape": {
                    "type": "Path",
                    "data": "M243.46 198.37 285.77 222.06 262.79 179.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 42.30998229980469,
                "height": 42.55999755859375,
                "offsetX": 264.61499786376953,
                "offsetY": 200.77999877929688,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962067gJt5VC",
                "shape": {
                    "type": "Path",
                    "data": "M416.89,176.44v95.12H372.44V196A19.56,19.56,0,0,1,392,176.44h75.56v44.45H372.44"
                },
                "style": {
                    "fill": "#fff",
                    "strokeColor": "#464747",
                    "strokeWidth": 0
                },
                "width": 95.1199951171875,
                "height": 95.12001037597656,
                "offsetX": 420,
                "offsetY": 223.99999237060547,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962068kphZ3C",
                "shape": {
                    "type": "Path",
                    "data": "M 424.59 , 176.44 L 424.59 , 220.89"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 44.44999694824219,
                "offsetX": 425.0899963378906,
                "offsetY": 198.66500091552734,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962069EK27sE",
                "shape": {
                    "type": "Path",
                    "data": "M 431.85 , 176.44 L 431.85 , 220.89"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 44.44999694824219,
                "offsetX": 432.3500061035156,
                "offsetY": 198.66500091552734,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962070xRPN1q",
                "shape": {
                    "type": "Path",
                    "data": "M 439.11 , 176.44 L 439.11 , 220.89"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 44.44999694824219,
                "offsetX": 439.6099853515625,
                "offsetY": 198.66500091552734,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962071NagQ7V",
                "shape": {
                    "type": "Path",
                    "data": "M 446.37 , 176.44 L 446.37 , 220.89"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 44.44999694824219,
                "offsetX": 446.8699951171875,
                "offsetY": 198.66500091552734,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962072psLZKX",
                "shape": {
                    "type": "Path",
                    "data": "M 453.63 , 176.44 L 453.63 , 220.89"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 44.44999694824219,
                "offsetX": 454.1300048828125,
                "offsetY": 198.66500091552734,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620730kLWOi",
                "shape": {
                    "type": "Path",
                    "data": "M 460.89 , 176.44 L 460.89 , 220.89"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 44.44999694824219,
                "offsetX": 461.3900146484375,
                "offsetY": 198.66500091552734,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962074P0GIfn",
                "shape": {
                    "type": "Path",
                    "data": "M 416.89 , 228.59 L 372.44 , 228.59"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 44.45001220703125,
                "height": 1,
                "offsetX": 394.6650085449219,
                "offsetY": 229.08999633789062,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962075q7FORE",
                "shape": {
                    "type": "Path",
                    "data": "M 416.89 , 235.85 L 372.44 , 235.85"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 44.45001220703125,
                "height": 1,
                "offsetX": 394.6650085449219,
                "offsetY": 236.35000610351562,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962076pMg6xF",
                "shape": {
                    "type": "Path",
                    "data": "M 416.89 , 243.11 L 372.44 , 243.11"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 44.45001220703125,
                "height": 1,
                "offsetX": 394.6650085449219,
                "offsetY": 243.61000061035156,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962077PJ36qO",
                "shape": {
                    "type": "Path",
                    "data": "M 416.89 , 250.37 L 372.44 , 250.37"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 44.45001220703125,
                "height": 1,
                "offsetX": 394.6650085449219,
                "offsetY": 250.8699951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962078sEk7qe",
                "shape": {
                    "type": "Path",
                    "data": "M 416.89 , 257.63 L 372.44 , 257.63"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 44.45001220703125,
                "height": 1,
                "offsetX": 394.6650085449219,
                "offsetY": 258.1300048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962079Y2FSRV",
                "shape": {
                    "type": "Path",
                    "data": "M 416.89 , 264.89 L 372.44 , 264.89"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 44.45001220703125,
                "height": 1,
                "offsetX": 394.6650085449219,
                "offsetY": 265.3900146484375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962080i42UEN",
                "shape": {
                    "type": "Path",
                    "data": "M372.44 196.15 416.63 220.89 392.63 176.44"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 44.19000244140625,
                "height": 44.44999694824219,
                "offsetX": 394.5350036621094,
                "offsetY": 198.66500091552734,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962081oBNq2R",
                "shape": {
                    "type": "Path",
                    "data": "M 204.7 , 336.47 L 166.38 , 336.47"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999206542969,
                "height": 1,
                "offsetX": 185.54000091552734,
                "offsetY": 336.9700012207031,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962082xrS6c9",
                "shape": {
                    "type": "Path",
                    "data": "M 204.7 , 342.6 L 166.38 , 342.6"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999206542969,
                "height": 1,
                "offsetX": 185.54000091552734,
                "offsetY": 343.1000061035156,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962083uHGcMY",
                "shape": {
                    "type": "Path",
                    "data": "M 204.7 , 348.73 L 166.38 , 348.73"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999206542969,
                "height": 1,
                "offsetX": 185.54000091552734,
                "offsetY": 349.2300109863281,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962084zivYKX",
                "shape": {
                    "type": "Path",
                    "data": "M 204.7 , 354.86 L 166.38 , 354.86"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999206542969,
                "height": 1,
                "offsetX": 185.54000091552734,
                "offsetY": 355.3599853515625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962085hwfkho",
                "shape": {
                    "type": "Path",
                    "data": "M 204.7 , 360.99 L 166.38 , 360.99"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999206542969,
                "height": 1,
                "offsetX": 185.54000091552734,
                "offsetY": 361.489990234375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962086DnmLcW",
                "shape": {
                    "type": "Path",
                    "data": "M 204.7 , 367.12 L 166.38 , 367.12"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999206542969,
                "height": 1,
                "offsetX": 185.54000091552734,
                "offsetY": 367.6199951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962087yPH0Dr",
                "shape": {
                    "type": "Path",
                    "data": "M 204.7 , 373.25 L 166.38 , 373.25"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.31999206542969,
                "height": 1,
                "offsetX": 185.54000091552734,
                "offsetY": 373.75,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962088XXINhR",
                "shape": {
                    "type": "Path",
                    "data": "M 258.35 , 373.25 L 220.03 , 373.25"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.32000732421875,
                "height": 1,
                "offsetX": 239.19000244140625,
                "offsetY": 373.75,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962089ndhmWY",
                "shape": {
                    "type": "Path",
                    "data": "M204.7 336.47 204.7 378.62 185.16 378.62 166.38 378.62 166.38 297.38 258.35 297.38 258.35 378.62 238.8 378.62 220.03 378.62 220.03 336.47 204.7 336.47"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 91.97000122070312,
                "height": 81.239990234375,
                "offsetX": 212.36500549316406,
                "offsetY": 338,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620901Rt54V",
                "shape": {
                    "type": "Path",
                    "data": "M 258.35 , 336.47 L 220.03 , 336.47"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.32000732421875,
                "height": 1,
                "offsetX": 239.19000244140625,
                "offsetY": 336.9700012207031,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962091DtDfyt",
                "shape": {
                    "type": "Path",
                    "data": "M 258.35 , 342.6 L 220.03 , 342.6"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.32000732421875,
                "height": 1,
                "offsetX": 239.19000244140625,
                "offsetY": 343.1000061035156,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962092kLKeOD",
                "shape": {
                    "type": "Path",
                    "data": "M 258.35 , 348.73 L 220.03 , 348.73"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.32000732421875,
                "height": 1,
                "offsetX": 239.19000244140625,
                "offsetY": 349.2300109863281,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962093uy2HBZ",
                "shape": {
                    "type": "Path",
                    "data": "M 258.35 , 354.86 L 220.03 , 354.86"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.32000732421875,
                "height": 1,
                "offsetX": 239.19000244140625,
                "offsetY": 355.3599853515625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962094o30Rdg",
                "shape": {
                    "type": "Path",
                    "data": "M 258.35 , 360.99 L 220.03 , 360.99"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.32000732421875,
                "height": 1,
                "offsetX": 239.19000244140625,
                "offsetY": 361.489990234375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620955PL4Jr",
                "shape": {
                    "type": "Path",
                    "data": "M 258.35 , 367.12 L 220.03 , 367.12"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 38.32000732421875,
                "height": 1,
                "offsetX": 239.19000244140625,
                "offsetY": 367.6199951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962096uw558J",
                "shape": {
                    "type": "Path",
                    "data": "M 210.07 , 336.47 L 210.07 , 297.38"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 39.089996337890625,
                "offsetX": 210.57000732421875,
                "offsetY": 316.9250030517578,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962097Da2HCF",
                "shape": {
                    "type": "Path",
                    "data": "M 220.03 , 336.47 L 220.03 , 297.38"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 39.089996337890625,
                "offsetX": 220.52999877929688,
                "offsetY": 316.9250030517578,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620982kzi7X",
                "shape": {
                    "type": "Path",
                    "data": "M 215.43 , 336.47 L 215.43 , 297.38"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 39.089996337890625,
                "offsetX": 215.92999267578125,
                "offsetY": 316.9250030517578,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962099FPFodq",
                "shape": {
                    "type": "Path",
                    "data": "M 204.7 , 336.47 L 204.7 , 297.38"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 39.089996337890625,
                "offsetX": 205.1999969482422,
                "offsetY": 316.9250030517578,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620100L9ESaY",
                "shape": {
                    "type": "Path",
                    "data": "M331.31,507.89a7.07,7.07,0,0,0,7.05,6.59h0a7.06,7.06,0,0,0,7-6.59Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 14.04998779296875,
                "height": 6.59002685546875,
                "offsetX": 338.3349914550781,
                "offsetY": 511.1850280761719,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620101kp4nY6",
                "shape": {
                    "type": "Path",
                    "data": "M331.31,453.13a7.07,7.07,0,0,1,7.05-6.59h0a7.06,7.06,0,0,1,7,6.59Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 14.04998779296875,
                "height": 6.59002685546875,
                "offsetX": 338.3349914550781,
                "offsetY": 449.83502197265625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620102ESWDlG",
                "shape": {
                    "type": "Path",
                    "data": "M316.73,473.25a7.07,7.07,0,0,0-6.59,7.05h0a7.06,7.06,0,0,0,6.59,7Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 6.589996337890625,
                "height": 14.049957275390625,
                "offsetX": 313.4350128173828,
                "offsetY": 480.2749786376953,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96201032AZdLJ",
                "shape": {
                    "type": "Path",
                    "data": "M360.41,473.25A7.07,7.07,0,0,1,367,480.3h0a7.06,7.06,0,0,1-6.59,7Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 6.589996337890625,
                "height": 14.049957275390625,
                "offsetX": 363.7050018310547,
                "offsetY": 480.2749786376953,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620104NCkAEN",
                "shape": {
                    "type": "Path",
                    "data": "M360.54,489.14a7.05,7.05,0,0,1,5,8.22h0a7.06,7.06,0,0,1-7.86,5.59Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 8.006927490234375,
                "height": 13.873046875,
                "offsetX": 361.68348693847656,
                "offsetY": 496.0765380859375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620105gpAmjA",
                "shape": {
                    "type": "Path",
                    "data": "M360.54,471.48a7.05,7.05,0,0,0,5-8.22h0a7.06,7.06,0,0,0-7.86-5.59Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 8.006927490234375,
                "height": 13.87298583984375,
                "offsetX": 361.68348693847656,
                "offsetY": 464.54351806640625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620106TUcITH",
                "shape": {
                    "type": "Path",
                    "data": "M317,489.14a7.07,7.07,0,0,0-5.05,8.22h0a7.07,7.07,0,0,0,7.86,5.59Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 8.000823974609375,
                "height": 13.871978759765625,
                "offsetX": 315.80958557128906,
                "offsetY": 496.0760040283203,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620107gxp5mz",
                "shape": {
                    "type": "Path",
                    "data": "M317,471.48a7.07,7.07,0,0,1-5.05-8.22h0a7.07,7.07,0,0,1,7.86-5.59Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 8.000823974609375,
                "height": 13.87188720703125,
                "offsetX": 315.80958557128906,
                "offsetY": 464.5440673828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620109vpsaDg",
                "shape": {
                    "type": "Path",
                    "data": "M348.68,500H328.49l0-.09a53.4,53.4,0,0,1,0-39l0-.09h20.19l0,.09a53.4,53.4,0,0,1,0,39Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 27.5654296875,
                "height": 39.17999267578125,
                "offsetX": 338.5849914550781,
                "offsetY": 480.4100036621094,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620110MVHknA",
                "shape": {
                    "type": "Path",
                    "data": "M245.69,499.59l-.45-2.22a.16.16,0,0,1,.16-.19h.89a.15.15,0,0,1,.15.19l-.44,2.22A.16.16,0,0,1,245.69,499.59Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 1.2083282470703125,
                "height": 2.5303955078125,
                "offsetX": 245.84131622314453,
                "offsetY": 498.4450988769531,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620111Qv3GyO",
                "shape": {
                    "type": "Path",
                    "data": "M229.57,483.47l2.22.45a.16.16,0,0,0,.19-.16v-.89a.16.16,0,0,0-.19-.16l-2.22.45A.16.16,0,0,0,229.57,483.47Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 2.530364990234375,
                "height": 1.2156982421875,
                "offsetX": 230.71485900878906,
                "offsetY": 483.31500244140625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620112zC1y40",
                "shape": {
                    "type": "Path",
                    "data": "M266.86,478.42l-2.41-.49v1.28l2.41-.48A.16.16,0,0,0,266.86,478.42Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 2.530303955078125,
                "height": 1.279998779296875,
                "offsetX": 265.7151336669922,
                "offsetY": 478.5700225830078,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620113Mkt4CI",
                "shape": {
                    "type": "Path",
                    "data": "M250.52,462.08l.48,2.41h-1.28l.49-2.41A.16.16,0,0,1,250.52,462.08Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 1.279998779296875,
                "height": 2.530303955078125,
                "offsetX": 250.36000061035156,
                "offsetY": 463.22483825683594,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620114rfG3ky",
                "shape": {
                    "type": "Path",
                    "data": "M271.72,469.88a8.66,8.66,0,0,0-.53-11.81h0a8.68,8.68,0,0,0-11.82-.54Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 14.422393798828125,
                "height": 14.415130615234375,
                "offsetX": 266.58119201660156,
                "offsetY": 462.6724395751953,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620115xBerD1",
                "shape": {
                    "type": "Path",
                    "data": "M237.63,504a8.68,8.68,0,0,1-11.82-.54h0a8.66,8.66,0,0,1-.53-11.81Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 14.422348022460938,
                "height": 14.415130615234375,
                "offsetX": 230.41883087158203,
                "offsetY": 498.85755920410156,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620116v58jzw",
                "shape": {
                    "type": "Path",
                    "data": "M237.28,457a8.68,8.68,0,0,0-11.82.54h0a8.67,8.67,0,0,0-.54,11.81Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 14.424118041992188,
                "height": 14.4151611328125,
                "offsetX": 230.06793975830078,
                "offsetY": 462.1424255371094,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96201179bOiDu",
                "shape": {
                    "type": "Path",
                    "data": "M272.08,491.38a8.67,8.67,0,0,1-.54,11.81h0a8.68,8.68,0,0,1-11.82.54Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 14.42413330078125,
                "height": 14.4151611328125,
                "offsetX": 266.9320373535156,
                "offsetY": 498.58758544921875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620118X1dzqz",
                "shape": {
                    "type": "Path",
                    "data": "M265.1,457.13h0a7,7,0,0,1,7,7v6.31a.72.72,0,0,1-.72.72H258.79a.72.72,0,0,1-.72-.72v-6.31A7,7,0,0,1,265.1,457.13Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 14.029998779296875,
                "height": 14.030029296875,
                "offsetX": 265.0850067138672,
                "offsetY": 464.1449890136719,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620119GNse0c",
                "shape": {
                    "type": "Path",
                    "data": "M225.6,490.32h12.62a.72.72,0,0,1,.72.72v6.31a7,7,0,0,1-7,7h0a7,7,0,0,1-7-7V491a.72.72,0,0,1,.72-.72Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 14.000015258789062,
                "height": 14.070037841796875,
                "offsetX": 231.94001007080078,
                "offsetY": 497.3150177001953,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620120AFj3Lz",
                "shape": {
                    "type": "Path",
                    "data": "M231.55,456.6h0a7,7,0,0,1,7,7v6.31a.72.72,0,0,1-.72.72H225.24a.72.72,0,0,1-.72-.72v-6.31a7,7,0,0,1,7-7Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 14.030014038085938,
                "height": 14.029998779296875,
                "offsetX": 231.5350112915039,
                "offsetY": 463.61500549316406,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620121dCuAlO",
                "shape": {
                    "type": "Path",
                    "data": "M259.14,490.07h12.62a.72.72,0,0,1,.72.72v6.31a7,7,0,0,1-7,7h0a7,7,0,0,1-7-7v-6.31a.72.72,0,0,1,.72-.72Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 14,
                "height": 14.030029296875,
                "offsetX": 265.4800109863281,
                "offsetY": 497.08502197265625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96201220ZBRhr",
                "shape": {
                    "type": "Path",
                    "data": "M79,480.82A20.1,20.1,0,0,0,59,462.08h0a20.11,20.11,0,0,0-20.06,18.74Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 40.05999755859375,
                "height": 18.740020751953125,
                "offsetX": 58.970001220703125,
                "offsetY": 471.4499969482422,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620123mqP3kW",
                "shape": {
                    "type": "Path",
                    "data": "M59,465.48h0A16.62,16.62,0,0,1,75.6,482.1V497a1.7,1.7,0,0,1-1.7,1.7H44.07a1.7,1.7,0,0,1-1.7-1.7V482.1A16.62,16.62,0,0,1,59,465.48Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 33.230003356933594,
                "height": 33.22003173828125,
                "offsetX": 58.9849967956543,
                "offsetY": 482.0899963378906,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620124QI0tKV",
                "shape": {
                    "type": "Path",
                    "data": "M176.72 505.65 176.72 505.65 174.91 504.44 175.51 503.84 176.72 505.65"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 1.80999755859375,
                "height": 1.80999755859375,
                "offsetX": 175.81500244140625,
                "offsetY": 504.7449951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620125leCTRn",
                "shape": {
                    "type": "Path",
                    "data": "M176.72 485.09 176.72 485.09 174.91 486.3 175.51 486.9 176.72 485.09"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 1.80999755859375,
                "height": 1.80999755859375,
                "offsetX": 175.81500244140625,
                "offsetY": 485.9949951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96201263fnFG1",
                "shape": {
                    "type": "Path",
                    "data": "M160.85 505.65 160.85 505.65 162.66 504.44 162.06 503.84 160.85 505.65"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 1.80999755859375,
                "height": 1.80999755859375,
                "offsetX": 161.7550048828125,
                "offsetY": 504.7449951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620127eerptl",
                "shape": {
                    "type": "Path",
                    "data": "M160.43 485.09 160.43 485.09 162.23 486.3 161.63 486.9 160.43 485.09"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 1.8000030517578125,
                "height": 1.80999755859375,
                "offsetX": 161.32999420166016,
                "offsetY": 485.9949951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620128WUzj87",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 23,
                "height": 23,
                "offsetX": 168.72000122070312,
                "offsetY": 495.3100280761719,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620129AvYUUF",
                "shape": {
                    "type": "Path",
                    "data": "M181.08,462.93a13.68,13.68,0,0,0-13.65-12.76h0a13.68,13.68,0,0,0-13.65,12.76Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 27.29998779296875,
                "height": 12.760009765625,
                "offsetX": 167.4300079345703,
                "offsetY": 456.54998779296875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620130EeQe2n",
                "shape": {
                    "type": "Path",
                    "data": "M137.62,482.72a13.69,13.69,0,0,0-12.76,13.65h0A13.69,13.69,0,0,0,137.62,510Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 12.760009765625,
                "height": 27.279998779296875,
                "offsetX": 131.239990234375,
                "offsetY": 496.36000061035156,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620131JvgUWQ",
                "shape": {
                    "type": "Path",
                    "data": "M167.43,452.28h0a11.29,11.29,0,0,1,11.29,11.29V473.7a1.16,1.16,0,0,1-1.16,1.16H157.3a1.16,1.16,0,0,1-1.16-1.16V463.57A11.29,11.29,0,0,1,167.43,452.28Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 22.579986572265625,
                "height": 22.58001708984375,
                "offsetX": 167.42999267578125,
                "offsetY": 463.57000732421875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620132ssPAkV",
                "shape": {
                    "type": "Path",
                    "data": "M138.26,485.08h0a11.29,11.29,0,0,1,11.29,11.29V506.5a1.16,1.16,0,0,1-1.16,1.16H128.13A1.16,1.16,0,0,1,127,506.5V496.37a11.29,11.29,0,0,1,11.29-11.29Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 22.550003051757812,
                "height": 22.58001708984375,
                "offsetX": 138.27498626708984,
                "offsetY": 496.3699951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620133MmDjZg",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 21.30000114440918,
                "height": 21.30000114440918,
                "offsetX": 168.72000789642334,
                "offsetY": 495.3100347518921,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620134Kpevp2",
                "shape": {
                    "type": "Path",
                    "data": "M338.34,501.5h0a5.75,5.75,0,0,1,5.75,5.75v5.16a.59.59,0,0,1-.59.59H333.18a.59.59,0,0,1-.59-.59v-5.16a5.75,5.75,0,0,1,5.75-5.75Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 11.5,
                "height": 11.500030517578125,
                "offsetX": 338.3399963378906,
                "offsetY": 507.24998474121094,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620135AKkDMD",
                "shape": {
                    "type": "Path",
                    "data": "M333.18,448H343.5a.59.59,0,0,1,.59.59v5.16a5.75,5.75,0,0,1-5.75,5.75h0a5.75,5.75,0,0,1-5.75-5.75v-5.16a.59.59,0,0,1,.59-.59Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 11.5,
                "height": 11.500030517578125,
                "offsetX": 338.3399963378906,
                "offsetY": 453.75001525878906,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620136w4AYvk",
                "shape": {
                    "type": "Path",
                    "data": "M317.37,474.53h0a5.75,5.75,0,0,1,5.75,5.75v5.16a.59.59,0,0,1-.59.59H312.2a.59.59,0,0,1-.59-.59v-5.16a5.75,5.75,0,0,1,5.75-5.75Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 11.509979248046875,
                "height": 11.5,
                "offsetX": 317.36500549316406,
                "offsetY": 480.2799987792969,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620137BdzwNX",
                "shape": {
                    "type": "Path",
                    "data": "M354.61,474.53h10.32a.59.59,0,0,1,.59.59v5.16a5.75,5.75,0,0,1-5.75,5.75h0a5.75,5.75,0,0,1-5.75-5.75v-5.16a.59.59,0,0,1,.59-.59Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 11.5,
                "height": 11.5,
                "offsetX": 359.7699890136719,
                "offsetY": 480.2799987792969,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620138L7i1ky",
                "shape": {
                    "type": "Path",
                    "data": "M353.35,490.15h10.32a.59.59,0,0,1,.59.59v5.16a5.75,5.75,0,0,1-5.75,5.75h0a5.75,5.75,0,0,1-5.75-5.75v-5.16A.59.59,0,0,1,353.35,490.15Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 11.5,
                "height": 11.5,
                "offsetX": 358.510009765625,
                "offsetY": 495.8999938964844,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620139Se95VG",
                "shape": {
                    "type": "Path",
                    "data": "M358.52,459h0a5.75,5.75,0,0,1,5.75,5.75v5.16a.59.59,0,0,1-.59.59H353.35a.59.59,0,0,1-.59-.59v-5.16a5.75,5.75,0,0,1,5.75-5.75Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 11.509979248046875,
                "height": 11.5,
                "offsetX": 358.51499938964844,
                "offsetY": 464.75,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620140C48N3l",
                "shape": {
                    "type": "Path",
                    "data": "M319,490.15h0a5.75,5.75,0,0,1,5.75,5.75v5.16a.59.59,0,0,1-.59.59H313.85a.59.59,0,0,1-.59-.59V495.9A5.75,5.75,0,0,1,319,490.15Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 11.489990234375,
                "height": 11.500030517578125,
                "offsetX": 319.0050048828125,
                "offsetY": 495.90000915527344,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620141cRoicr",
                "shape": {
                    "type": "Path",
                    "data": "M313.85,459h10.32a.59.59,0,0,1,.59.59v5.16a5.75,5.75,0,0,1-5.75,5.75h0a5.75,5.75,0,0,1-5.75-5.75v-5.16a.59.59,0,0,1,.59-.59Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 11.5,
                "height": 11.5,
                "offsetX": 319.010009765625,
                "offsetY": 464.75,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620143jI2HOt",
                "shape": {
                    "type": "Path",
                    "data": "M73.08,582.55H52.88l0-.1a53.37,53.37,0,0,1,0-39l0-.1h20.2l0,.1a53.27,53.27,0,0,1,0,39Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 27.587337493896484,
                "height": 39.199951171875,
                "offsetX": 62.983713150024414,
                "offsetY": 562.9500122070312,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620144Bv58NO",
                "shape": {
                    "type": "Path",
                    "data": "M429,468.33h11a.7.7,0,0,0,.7-.7l-.08-10.37H428.27v10.37A.7.7,0,0,0,429,468.33Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 12.430023193359375,
                "height": 11.070648193359375,
                "offsetX": 434.48500061035156,
                "offsetY": 462.79530334472656,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620145fR87VQ",
                "shape": {
                    "type": "Path",
                    "data": "M429.4,499.07h11a.69.69,0,0,1,.69.7L441,510.14H428.7V499.77A.7.7,0,0,1,429.4,499.07Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 12.390045166015625,
                "height": 11.07000732421875,
                "offsetX": 434.89503479003906,
                "offsetY": 504.6050109863281,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620146bG0cKE",
                "shape": {
                    "type": "Path",
                    "data": "M418.87,489V478a.69.69,0,0,0-.7-.69l-10.38.08v12.27h10.38A.69.69,0,0,0,418.87,489Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 11.08001708984375,
                "height": 12.35015869140625,
                "offsetX": 413.3299865722656,
                "offsetY": 483.4849853515625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96201474u6hdg",
                "shape": {
                    "type": "Path",
                    "data": "M449.85,489.63a.7.7,0,0,1-.7-.7V478a.7.7,0,0,1,.7-.7l10.38.08v12.27Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 11.08001708984375,
                "height": 12.349945068359375,
                "offsetX": 454.69000244140625,
                "offsetY": 483.47499084472656,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620148JuvI5j",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 32.810001373291016,
                "height": 32.810001373291016,
                "offsetX": 434.11499214172363,
                "offsetY": 483.6750202178955,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620149D4HEUH",
                "shape": {
                    "type": "Path",
                    "data": "M 426.57 , 458.32 L 441.91 , 458.32"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 15.339996337890625,
                "height": 1,
                "offsetX": 434.24000549316406,
                "offsetY": 458.82000732421875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96201503V7oTR",
                "shape": {
                    "type": "Path",
                    "data": "M 441.91 , 457.04 L 426.57 , 457.04"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 15.339996337890625,
                "height": 1,
                "offsetX": 434.24000549316406,
                "offsetY": 457.5400085449219,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620151NXYERq",
                "shape": {
                    "type": "Path",
                    "data": "M 440.41 , 457.07 L 439.99 , 459.17"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 0.420013427734375,
                "height": 2.100006103515625,
                "offsetX": 440.1999969482422,
                "offsetY": 458.12001037597656,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620152GyVqxM",
                "shape": {
                    "type": "Path",
                    "data": "M 428.5 , 457.08 L 428.93 , 459.17"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 0.42999267578125,
                "height": 2.09002685546875,
                "offsetX": 428.7149963378906,
                "offsetY": 458.125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620153V8ROM7",
                "shape": {
                    "type": "Path",
                    "data": "M 427 , 509.08 L 442.33 , 509.08"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 15.329986572265625,
                "height": 1,
                "offsetX": 434.6649932861328,
                "offsetY": 509.5799865722656,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620154gewgDd",
                "shape": {
                    "type": "Path",
                    "data": "M 442.33 , 510.36 L 427 , 510.36"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 15.329986572265625,
                "height": 1,
                "offsetX": 434.6649932861328,
                "offsetY": 510.8599853515625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620155h5FwMQ",
                "shape": {
                    "type": "Path",
                    "data": "M 440.84 , 510.33 L 440.42 , 508.23"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 0.41998291015625,
                "height": 2.0999755859375,
                "offsetX": 440.6300048828125,
                "offsetY": 509.2799987792969,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620156LNgcow",
                "shape": {
                    "type": "Path",
                    "data": "M 428.93 , 510.32 L 429.35 , 508.23"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 0.420013427734375,
                "height": 2.089996337890625,
                "offsetX": 429.13999938964844,
                "offsetY": 509.27500915527344,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620157na9FvG",
                "shape": {
                    "type": "Path",
                    "data": "M 408.86 , 491.37 L 408.86 , 476.03"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 1,
                "height": 15.339996337890625,
                "offsetX": 409.3599853515625,
                "offsetY": 483.6999969482422,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620158Zn6hyD",
                "shape": {
                    "type": "Path",
                    "data": "M 407.58 , 476.03 L 407.58 , 491.37"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 1,
                "height": 15.339996337890625,
                "offsetX": 408.0799865722656,
                "offsetY": 483.6999969482422,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620159Wn19lQ",
                "shape": {
                    "type": "Path",
                    "data": "M 407.61 , 477.52 L 409.71 , 477.95"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 2.100006103515625,
                "height": 0.430023193359375,
                "offsetX": 408.6599884033203,
                "offsetY": 477.73500061035156,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620160nwQ4Ye",
                "shape": {
                    "type": "Path",
                    "data": "M 407.62 , 489.43 L 409.71 , 489.01"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 2.089996337890625,
                "height": 0.41998291015625,
                "offsetX": 408.6649932861328,
                "offsetY": 489.2200012207031,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620161NONr37",
                "shape": {
                    "type": "Path",
                    "data": "M 459.16 , 491.55 L 459.16 , 476.21"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 1,
                "height": 15.339996337890625,
                "offsetX": 459.6600036621094,
                "offsetY": 483.87998962402344,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620162tvDwT8",
                "shape": {
                    "type": "Path",
                    "data": "M 460.44 , 476.21 L 460.44 , 491.55"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 1,
                "height": 15.339996337890625,
                "offsetX": 460.94000244140625,
                "offsetY": 483.87998962402344,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620163R9hpSW",
                "shape": {
                    "type": "Path",
                    "data": "M 460.44 , 477.52 L 458.34 , 477.95"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 2.100006103515625,
                "height": 0.430023193359375,
                "offsetX": 459.38999938964844,
                "offsetY": 477.73500061035156,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620164i0VftP",
                "shape": {
                    "type": "Path",
                    "data": "M 460.43 , 489.43 L 458.34 , 489.01"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 2.089996337890625,
                "height": 0.41998291015625,
                "offsetX": 459.38499450683594,
                "offsetY": 489.2200012207031,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96201659EaB3a",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a",
                    "strokeWidth": 1
                },
                "width": 32.810001373291016,
                "height": 32.810001373291016,
                "offsetX": 434.11499214172363,
                "offsetY": 483.6750202178955,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620166Jx2oYn",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 28.540000915527344,
                "height": 28.540000915527344,
                "offsetX": 434.1099967956543,
                "offsetY": 483.66999435424805,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620167B4VbEy",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 32.810001373291016,
                "height": 32.810001373291016,
                "offsetX": 158.50499153137207,
                "offsetY": 561.6750202178955,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620168VeIJAN",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 28.540000915527344,
                "height": 28.540000915527344,
                "offsetX": 158.49999618530273,
                "offsetY": 561.6699638366699,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620169qRZ1E8",
                "shape": {
                    "type": "Path",
                    "data": "M269.93,577H240.82a1.85,1.85,0,0,1-1.85-1.86l.21-27.54h32.6v27.54A1.85,1.85,0,0,1,269.93,577Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 32.81004333496094,
                "height": 29.39996337890625,
                "offsetX": 255.37500762939453,
                "offsetY": 562.3000183105469,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620170Ns9Q0f",
                "shape": {
                    "type": "Path",
                    "data": "M 276.25 , 550.38 L 235.35 , 550.38"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a",
                    "strokeWidth": 1
                },
                "width": 40.899993896484375,
                "height": 1,
                "offsetX": 255.8000030517578,
                "offsetY": 550.8800048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96201712H05QA",
                "shape": {
                    "type": "Path",
                    "data": "M 235.35 , 546.97 L 276.25 , 546.97"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a",
                    "strokeWidth": 1
                },
                "width": 40.899993896484375,
                "height": 1,
                "offsetX": 255.8000030517578,
                "offsetY": 547.469970703125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620172oz1PV7",
                "shape": {
                    "type": "Path",
                    "data": "M 239.4 , 546.93 L 240.53 , 552.53"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a",
                    "strokeWidth": 1
                },
                "width": 1.1300048828125,
                "height": 5.60003662109375,
                "offsetX": 239.96499633789062,
                "offsetY": 549.7300109863281,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96201732LmNkK",
                "shape": {
                    "type": "Path",
                    "data": "M 271.05 , 546.96 L 269.93 , 552.53"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a",
                    "strokeWidth": 1
                },
                "width": 1.1199951171875,
                "height": 5.57000732421875,
                "offsetX": 270.489990234375,
                "offsetY": 549.7450256347656,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620175cy2GxP",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#3d2009"
                },
                "width": 34.5,
                "height": 34.5,
                "offsetX": 248.3300018310547,
                "offsetY": 480.9300231933594,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620176vNDgJP",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 31.959999084472656,
                "height": 31.959999084472656,
                "offsetX": 248.33000564575195,
                "offsetY": 480.9300117492676,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620184ZnshDS",
                "shape": {
                    "type": "Path",
                    "data": "M33.9 141.32 40.69 129.89 47.47 118.47 54.25 129.89 61.03 141.32 59.57 141.32 52.79 129.89 46 118.47 39.22 129.89 32.44 141.32 33.9 141.32"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747",
                    "strokeWidth": 1
                },
                "width": 28.59000015258789,
                "height": 22.850006103515625,
                "offsetX": 46.73499870300293,
                "offsetY": 129.89500427246094,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620185uAEugT",
                "shape": {
                    "type": "Path",
                    "data": "M78.59 141.32 85.37 129.89 92.15 118.47 98.94 129.89 105.72 141.32 104.25 141.32 97.47 129.89 90.69 118.47 83.91 129.89 77.13 141.32 78.59 141.32"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747",
                    "strokeWidth": 1
                },
                "width": 28.590003967285156,
                "height": 22.850006103515625,
                "offsetX": 91.42499923706055,
                "offsetY": 129.89500427246094,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620186TPPwRz",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 82.33000183105469,
                "height": 10.199999809265137,
                "offsetX": 158.2449951171875,
                "offsetY": 130.33000326156616,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96201870ZkMhh",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 82.33000183105469,
                "height": 2.9099998474121094,
                "offsetX": 158.2449951171875,
                "offsetY": 130.32499504089355,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620188J8se01",
                "shape": {
                    "type": "Path",
                    "data": "M 229.99 , 130.87 L 282.65 , 130.87"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 52.65998840332031,
                "height": 1,
                "offsetX": 256.3199996948242,
                "offsetY": 131.3699951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620189tIig06",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 4,
                "height": 4,
                "offsetX": 227.989990234375,
                "offsetY": 130.8699951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96201908qpIQT",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 4,
                "height": 4,
                "offsetX": 284.6499938964844,
                "offsetY": 130.8699951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620191URCFz5",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 2.6700000762939453,
                "height": 9.329999923706055,
                "offsetX": 287.98499393463135,
                "offsetY": 130.86500453948975,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620192PJdWvo",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 2.6700000762939453,
                "height": 9.329999923706055,
                "offsetX": 224.65500736236572,
                "offsetY": 130.86500453948975,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620193gOGnkD",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#464747"
                },
                "width": 57,
                "height": 7.059999942779541,
                "offsetX": 331.5,
                "offsetY": 131.52999997138977,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620194r2KTtR",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#464747"
                },
                "width": 57,
                "height": 7.059999942779541,
                "offsetX": 383.5,
                "offsetY": 131.52999997138977,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96201953s0bLl",
                "shape": {
                    "type": "Path",
                    "data": "M438,122.92c13.53,0,24.56,11.14,25.06,25.08H468a30,30,0,0,0-60,0h4.94C413.44,134.06,424.47,122.92,438,122.92Z"
                },
                "style": {
                    "fill": "#464747",
                    "strokeWidth": 0
                },
                "width": 60,
                "height": 30,
                "offsetX": 438,
                "offsetY": 133,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620196BwFC7G",
                "shape": {
                    "type": "Path",
                    "data": "M332.16,663.58h18.9a0,0,0,0,1,0,0v22.05a2.1,2.1,0,0,1-2.1,2.1h-14.7a2.1,2.1,0,0,1-2.1-2.1V663.58A0,0,0,0,1,332.16,663.58Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 18.9000244140625,
                "height": 24.14996337890625,
                "offsetX": 341.6099853515625,
                "offsetY": 675.6549987792969,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620197i7FcXV",
                "shape": {
                    "type": "Path",
                    "data": "M352.64,663.58h18.9a0,0,0,0,1,0,0v22.05a2.1,2.1,0,0,1-2.1,2.1h-14.7a2.1,2.1,0,0,1-2.1-2.1V663.58A0,0,0,0,1,352.64,663.58Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 18.9000244140625,
                "height": 24.14996337890625,
                "offsetX": 362.0899963378906,
                "offsetY": 675.6549987792969,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620198bzLn1c",
                "shape": {
                    "type": "Path",
                    "data": "M311.68,663.58h18.9a0,0,0,0,1,0,0v22.05a2.1,2.1,0,0,1-2.1,2.1h-14.7a2.1,2.1,0,0,1-2.1-2.1V663.58A0,0,0,0,1,311.68,663.58Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 18.9000244140625,
                "height": 24.14996337890625,
                "offsetX": 321.1299743652344,
                "offsetY": 675.6549987792969,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620199ncspcl",
                "shape": {
                    "type": "Path",
                    "data": "M302.76,656.68v24.83a1.5,1.5,0,0,0,1.49,1.5h4.36a1.5,1.5,0,0,0,1.5-1.5v-19h63v19a1.5,1.5,0,0,0,1.5,1.5H379a1.5,1.5,0,0,0,1.5-1.5V656.68a1.5,1.5,0,0,0-1.5-1.5H304.25A1.5,1.5,0,0,0,302.76,656.68Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 77.74002075195312,
                "height": 27.83001708984375,
                "offsetX": 341.62998962402344,
                "offsetY": 669.0950012207031,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620200ihxicq",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 2.1
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 19.94999885559082,
                "height": 19.94999885559082,
                "offsetX": 417.9050226211548,
                "offsetY": 697.1849603652954,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620201O37sqU",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 2.1
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 19.94999885559082,
                "height": 19.94999885559082,
                "offsetX": 417.9050226211548,
                "offsetY": 676.1750116348267,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620202NpGFvz",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 2.1
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 19.94999885559082,
                "height": 19.94999885559082,
                "offsetX": 438.9050226211548,
                "offsetY": 676.1750116348267,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620203eUHj33",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 2.1
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 19.94999885559082,
                "height": 19.94999885559082,
                "offsetX": 459.9050226211548,
                "offsetY": 676.1750116348267,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96202048LdJhB",
                "shape": {
                    "type": "Path",
                    "data": "M469.36,657.31l-68.26,0a2.1,2.1,0,0,0-2.1,2.1h0v47.26a2.1,2.1,0,0,0,2.1,2.1h3.68a2.1,2.1,0,0,0,2.1-2.1V665.12l62.48,0a2.1,2.1,0,0,0,2.1-2.1v-3.64A2.1,2.1,0,0,0,469.36,657.31Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 72.46005249023438,
                "height": 51.4599609375,
                "offsetX": 435.22999572753906,
                "offsetY": 683.0399780273438,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620205db0lc2",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 0.72
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 1.440000057220459,
                "height": 5.37000036239624,
                "offsetX": 34.29999804496765,
                "offsetY": 771.0350368022919,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620206AmcX1F",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 0.72
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 1.440000057220459,
                "height": 5.37000036239624,
                "offsetX": 93.6300036907196,
                "offsetY": 771.0350368022919,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620207gbB1pQ",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 3.15
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 70.31999969482422,
                "height": 27.809999465942383,
                "offsetX": 63.97999954223633,
                "offsetY": 755.4950265884399,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620208xtR99e",
                "shape": {
                    "type": "Path",
                    "data": "M374,745.17h-64a3.15,3.15,0,0,0-3.15,3.15v21.51a3.15,3.15,0,0,0,3.15,3.15h.95l0,0,1.36,3.69a.72.72,0,0,0,.92.43.73.73,0,0,0,.43-.93l-1.2-3.23h59l-1.19,3.23a.72.72,0,0,0,.43.93.73.73,0,0,0,.92-.43l1.36-3.69s0,0,0,0h1a3.15,3.15,0,0,0,3.15-3.15V748.32A3.15,3.15,0,0,0,374,745.17Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 70.27999877929688,
                "height": 31.97259521484375,
                "offsetX": 341.98997497558594,
                "offsetY": 761.1562805175781,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620209wWfBUZ",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 7.599999904632568,
                "height": 7.599999904632568,
                "offsetX": 92.50999903678894,
                "offsetY": 750.5300414562225,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620211rp495d",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 6.18
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 12.360000610351562,
                "height": 12.880000114440918,
                "offsetX": 82.05999755859375,
                "offsetY": 750.080014705658,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620212WsObj1",
                "shape": {
                    "type": "Path",
                    "data": "M59.78,749.72V764l.06,0a19.86,19.86,0,0,1,10.38,0l.06,0v-14.3l-.06,0a19.86,19.86,0,0,0-10.38,0Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 10.5,
                "height": 14.99005126953125,
                "offsetX": 65.02999877929688,
                "offsetY": 756.5049743652344,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620213gvLGGB",
                "shape": {
                    "type": "Path",
                    "data": "M59.26,749.72l-.06,0a19.9,19.9,0,0,0-10.39,0l-.05,0V764l.05,0a19.9,19.9,0,0,1,10.39,0l.06,0Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 10.5,
                "height": 14.97015380859375,
                "offsetX": 54.0099983215332,
                "offsetY": 756.5149230957031,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962021420m44Y",
                "shape": {
                    "type": "Path",
                    "data": "M 61.88 , 752.49 L 68.71 , 752.49"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 6.829998016357422,
                "height": 1,
                "offsetX": 65.29500007629395,
                "offsetY": 752.989990234375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620215G83NpD",
                "shape": {
                    "type": "Path",
                    "data": "M 61.88 , 754.07 L 67.13 , 754.07"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 5.249996185302734,
                "height": 1,
                "offsetX": 64.5049991607666,
                "offsetY": 754.5700073242188,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620216w5M5Aw",
                "shape": {
                    "type": "Path",
                    "data": "M 61.88 , 755.64 L 68.71 , 755.64"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 6.829998016357422,
                "height": 1,
                "offsetX": 65.29500007629395,
                "offsetY": 756.1400146484375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620217GQK0RO",
                "shape": {
                    "type": "Path",
                    "data": "M 61.88 , 757.22 L 67.66 , 757.22"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 5.780002593994141,
                "height": 1,
                "offsetX": 64.7700023651123,
                "offsetY": 757.719970703125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620218mp4eSr",
                "shape": {
                    "type": "Path",
                    "data": "M 61.88 , 758.79 L 68.71 , 758.79"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 6.829998016357422,
                "height": 1,
                "offsetX": 65.29500007629395,
                "offsetY": 759.2899780273438,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620219s3nLZX",
                "shape": {
                    "type": "Path",
                    "data": "M 61.88 , 760.37 L 65.03 , 760.37"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 3.1499977111816406,
                "height": 1,
                "offsetX": 63.454999923706055,
                "offsetY": 760.8699951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620220KAKg49",
                "shape": {
                    "type": "Path",
                    "data": "M 50.59 , 752.49 L 57.42 , 752.49"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 6.829998016357422,
                "height": 1,
                "offsetX": 54.0049991607666,
                "offsetY": 752.989990234375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620221KdphPN",
                "shape": {
                    "type": "Path",
                    "data": "M 50.59 , 754.07 L 55.84 , 754.07"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 5.25,
                "height": 1,
                "offsetX": 53.21500015258789,
                "offsetY": 754.5700073242188,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96202226g0RcW",
                "shape": {
                    "type": "Path",
                    "data": "M 50.59 , 755.64 L 57.42 , 755.64"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 6.829998016357422,
                "height": 1,
                "offsetX": 54.0049991607666,
                "offsetY": 756.1400146484375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620223lSJWB7",
                "shape": {
                    "type": "Path",
                    "data": "M 50.59 , 757.22 L 56.37 , 757.22"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 5.779998779296875,
                "height": 1,
                "offsetX": 53.47999954223633,
                "offsetY": 757.719970703125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620224TPUblO",
                "shape": {
                    "type": "Path",
                    "data": "M 50.59 , 758.79 L 57.42 , 758.79"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 6.829998016357422,
                "height": 1,
                "offsetX": 54.0049991607666,
                "offsetY": 759.2899780273438,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620225V3ZNhG",
                "shape": {
                    "type": "Path",
                    "data": "M 50.59 , 760.37 L 53.74 , 760.37"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 3.1500015258789062,
                "height": 1,
                "offsetX": 52.165000915527344,
                "offsetY": 760.8699951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620226GTZ7nv",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#822c0f"
                },
                "width": 43.05999755859375,
                "height": 43.05999755859375,
                "offsetX": 59.55999755859375,
                "offsetY": 816.9300231933594,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620227UXXfvj",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#270805"
                },
                "width": 34.65999984741211,
                "height": 34.65999984741211,
                "offsetX": 59.55999565124512,
                "offsetY": 816.9299755096436,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620228qHUgy4",
                "shape": {
                    "type": "Path",
                    "data": "M60.61,815.88h.2a12.93,12.93,0,0,1,12.93,12.93v.2a0,0,0,0,1,0,0h-.2a12.93,12.93,0,0,1-12.93-12.93v-.2A0,0,0,0,1,60.61,815.88Z"
                },
                "style": {
                    "fill": "#03cd4e",
                    "strokeWidth": 0
                },
                "width": 13.1300048828125,
                "height": 13.1300048828125,
                "offsetX": 67.17500305175781,
                "offsetY": 822.4450073242188,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620229uFx1De",
                "shape": {
                    "type": "Path",
                    "data": "M45.15,807h0a12.93,12.93,0,0,1,12.93,12.93v0a0,0,0,0,1,0,0h0A12.93,12.93,0,0,1,45.15,807v0A0,0,0,0,1,45.15,807Z"
                },
                "style": {
                    "fill": "#04a53a",
                    "strokeWidth": 0
                },
                "width": 12.930004119873047,
                "height": 12.9300537109375,
                "offsetX": 51.614999771118164,
                "offsetY": 813.4649658203125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620230dnnLXO",
                "shape": {
                    "type": "Path",
                    "data": "M44.48,816.43h0A13.53,13.53,0,0,1,58,830v0a0,0,0,0,1,0,0h0a13.53,13.53,0,0,1-13.53-13.53v0A0,0,0,0,1,44.48,816.43Z"
                },
                "style": {
                    "fill": "#03cd4e",
                    "strokeWidth": 0
                },
                "width": 13.530059814453125,
                "height": 13.57000732421875,
                "offsetX": 51.23503112792969,
                "offsetY": 823.2149963378906,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96202319pTZ7h",
                "shape": {
                    "type": "Path",
                    "data": "M59.57,806.62h0A12.93,12.93,0,0,1,72.5,819.55v0a0,0,0,0,1,0,0h0a12.93,12.93,0,0,1-12.93-12.93v0A0,0,0,0,1,59.57,806.62Z"
                },
                "style": {
                    "fill": "#04a53a",
                    "strokeWidth": 0
                },
                "width": 12.930004119873047,
                "height": 12.9300537109375,
                "offsetX": 66.03499794006348,
                "offsetY": 813.0849609375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620232LEUrtR",
                "shape": {
                    "type": "Path",
                    "data": "M51.49,817.6h0a13.93,13.93,0,0,1,13.93,13.93v0a0,0,0,0,1,0,0h0A13.93,13.93,0,0,1,51.49,817.6v0A0,0,0,0,1,51.49,817.6Z"
                },
                "style": {
                    "fill": "#025909",
                    "strokeWidth": 0
                },
                "width": 13.930000305175781,
                "height": 13.92999267578125,
                "offsetX": 58.45499801635742,
                "offsetY": 824.5649719238281,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962023395b3oC",
                "shape": {
                    "type": "Path",
                    "data": "M52.39,799.45h0A13.53,13.53,0,0,1,65.92,813v0a0,0,0,0,1,0,0h0a13.53,13.53,0,0,1-13.53-13.53v0a0,0,0,0,1,0,0Z"
                },
                "style": {
                    "fill": "#04a53a",
                    "strokeWidth": 0
                },
                "width": 13.530021667480469,
                "height": 13.550048828125,
                "offsetX": 59.15501022338867,
                "offsetY": 806.2250366210938,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96202340HABAT",
                "shape": {
                    "type": "Path",
                    "data": "M48,803.28h.2a12.93,12.93,0,0,1,12.93,12.93v.2a0,0,0,0,1,0,0h-.2A12.93,12.93,0,0,1,48,803.47v-.2a0,0,0,0,1,0,0Z"
                },
                "style": {
                    "fill": "#025909",
                    "strokeWidth": 0
                },
                "width": 13.130008697509766,
                "height": 13.14007568359375,
                "offsetX": 54.56499671936035,
                "offsetY": 809.8399963378906,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620235HKssUe",
                "shape": {
                    "type": "Path",
                    "data": "M62.63,808.69h0a12.93,12.93,0,0,1,12.93,12.93v0a0,0,0,0,1,0,0h0a12.93,12.93,0,0,1-12.93-12.93v0a0,0,0,0,1,0,0Z"
                },
                "style": {
                    "fill": "#025909",
                    "strokeWidth": 0
                },
                "width": 12.930000305175781,
                "height": 12.92999267578125,
                "offsetX": 69.09499740600586,
                "offsetY": 815.1549987792969,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620236eQKOFU",
                "shape": {
                    "type": "Path",
                    "data": "M43.08,665.28H88.76a0,0,0,0,1,0,0v43.58a2.1,2.1,0,0,1-2.1,2.1H45.18a2.1,2.1,0,0,1-2.1-2.1V665.28a0,0,0,0,1,0,0Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 45.68000030517578,
                "height": 45.6800537109375,
                "offsetX": 65.92000198364258,
                "offsetY": 688.1200561523438,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620237r8mF1r",
                "shape": {
                    "type": "Path",
                    "data": "M31.53,655.3v42a2.1,2.1,0,0,0,2.1,2.1H39.4a2.1,2.1,0,0,0,2.1-2.1V663.7H90.34v33.61a2.1,2.1,0,0,0,2.1,2.1h6.3a2.1,2.1,0,0,0,2.1-2.1v-42a2.1,2.1,0,0,0-2.1-2.1H33.63A2.1,2.1,0,0,0,31.53,655.3Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 69.31000518798828,
                "height": 46.20001220703125,
                "offsetX": 66.18500328063965,
                "offsetY": 676.3100280761719,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620238gNVbZf",
                "shape": {
                    "type": "Path",
                    "data": "M157.83,664.75h25.62a0,0,0,0,1,0,0v30.14a2,2,0,0,1-2,2h-21.6a2,2,0,0,1-2-2V664.75A0,0,0,0,1,157.83,664.75Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 25.6199951171875,
                "height": 32.1400146484375,
                "offsetX": 170.63999938964844,
                "offsetY": 680.8200073242188,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620239KSU5RZ",
                "shape": {
                    "type": "Path",
                    "data": "M130.7,664.75h25.62a0,0,0,0,1,0,0v30.14a2,2,0,0,1-2,2h-21.6a2,2,0,0,1-2-2V664.75A0,0,0,0,1,130.7,664.75Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 25.6199951171875,
                "height": 32.1400146484375,
                "offsetX": 143.50999450683594,
                "offsetY": 680.8200073242188,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620240dGTKpq",
                "shape": {
                    "type": "Path",
                    "data": "M119.65,655.21v33.15a2,2,0,0,0,2,2h5.53a2,2,0,0,0,2-2V663.25H185v25.11a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V655.21a2,2,0,0,0-2-2H121.66A2,2,0,0,0,119.65,655.21Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 75.35000610351562,
                "height": 37.1500244140625,
                "offsetX": 157.3249969482422,
                "offsetY": 671.7850341796875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620241qjDtsB",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 1.93
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 42.040000915527344,
                "height": 42.040000915527344,
                "offsetX": 248.90000534057617,
                "offsetY": 687.6200370788574,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620242NJrTCM",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 1.93
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 65.72000122070312,
                "height": 9.65999984741211,
                "offsetX": 249.1400146484375,
                "offsetY": 659.829999923706,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96202437Sywn1",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 1.93
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 36.2400016784668,
                "height": 9.65999984741211,
                "offsetX": 276.67999839782715,
                "offsetY": 684.7200145721436,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620244Od2NZ2",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 1.93
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 36.2400016784668,
                "height": 9.65999984741211,
                "offsetX": 221.1099910736084,
                "offsetY": 684.7200145721436,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620245M8TQHF",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 77.70999908447266,
                "height": 19.94999885559082,
                "offsetX": 250.0849952697754,
                "offsetY": 756.1249628067017,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96202462PTvKI",
                "shape": {
                    "type": "Path",
                    "data": "M283.06 771.88 217.12 771.88 211.23 766.11 288.94 766.11 283.06 771.88"
                },
                "style": {
                    "fill": "#442409"
                },
                "width": 77.71000671386719,
                "height": 5.77001953125,
                "offsetX": 250.08499908447266,
                "offsetY": 768.9949951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96202478uaZyO",
                "shape": {
                    "type": "Path",
                    "data": "M284.22 769.36 215.43 769.26 212.67 766.63 287.21 766.63 284.22 769.36"
                },
                "style": {
                    "fill": "#301709"
                },
                "width": 74.53999328613281,
                "height": 2.72998046875,
                "offsetX": 249.93999481201172,
                "offsetY": 767.9949951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620248ur9l2E",
                "shape": {
                    "type": "Path",
                    "data": "M283.89 769.78 215.93 769.78 217.53 771.36 281.93 771.36 283.89 769.78"
                },
                "style": {
                    "fill": "#301709"
                },
                "width": 67.96002197265625,
                "height": 1.5799560546875,
                "offsetX": 249.91000366210938,
                "offsetY": 770.5700073242188,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620249faRVc1",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#a5a5a5"
                },
                "width": 9.460000038146973,
                "height": 9.460000038146973,
                "offsetX": 250.0900158882141,
                "offsetY": 756.1299633979797,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620250SJOBEG",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#cecdcc"
                },
                "width": 48.83000183105469,
                "height": 1.0500000715255737,
                "offsetX": 249.82498931884766,
                "offsetY": 752.975012242794,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620251NFlC2i",
                "shape": {
                    "type": "Path",
                    "data": "M270.13 759.28 229.52 759.28 225.41 753.5 274.24 753.5 270.13 759.28"
                },
                "style": {},
                "width": 48.829986572265625,
                "height": 5.780029296875,
                "offsetX": 249.8249969482422,
                "offsetY": 756.3900146484375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96202520DxkEah",
                "shape": {
                    "type": "Path",
                    "data": "M269.85 758.75 229.79 758.75 226.43 754.03 273.11 754.03 269.85 758.75"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 46.67999267578125,
                "height": 4.719970703125,
                "offsetX": 249.76998901367188,
                "offsetY": 756.3900146484375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620253Dujcor",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 0.07
                },
                "style": {
                    "fill": "#cecdcc"
                },
                "width": 4.710000038146973,
                "height": 1.7699999809265137,
                "offsetX": 279.62498903274536,
                "offsetY": 760.455007314682,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620254Qjbg4m",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 1.0399999618530273,
                "height": 1.0399999618530273,
                "offsetX": 89.72000455856323,
                "offsetY": 750.7999682426453,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620255Brhaz8",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#5e320d"
                },
                "width": 2.140000104904175,
                "height": 2.140000104904175,
                "offsetX": 92.32000005245209,
                "offsetY": 750.7099536657333,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96202569KS3fw",
                "shape": {
                    "type": "Path",
                    "data": "M92.29,751.17h-.07a.27.27,0,0,1-.18-.33l.94-3.2-7.13,1.42a.26.26,0,0,1-.31-.2.26.26,0,0,1,.21-.31L93.3,747a.24.24,0,0,1,.24.08.23.23,0,0,1,.06.25L92.54,751A.26.26,0,0,1,92.29,751.17Z"
                },
                "style": {
                    "fill": "#5e320d",
                    "strokeWidth": 0
                },
                "width": 8.080184936523438,
                "height": 4.176513671875,
                "offsetX": 89.57447052001953,
                "offsetY": 749.081787109375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620257IIzuFT",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#5e320d"
                },
                "width": 5.980000019073486,
                "height": 5.980000019073486,
                "offsetX": 82.930002450943,
                "offsetY": 749.669992685318,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620258bShrha",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 22.579999923706055,
                "height": 22.579999923706055,
                "offsetX": 177.63001155853271,
                "offsetY": 756.4200048446655,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620260Bfr0p9",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 18.12
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 36.2400016784668,
                "height": 37.79999923706055,
                "offsetX": 146.65001487731934,
                "offsetY": 755.1100215911865,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96202617ClESt",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 3.1599998474121094,
                "height": 3.1599998474121094,
                "offsetX": 169.49000358581543,
                "offsetY": 757.2099437713623,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620262RnUFPk",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#5e320d"
                },
                "width": 6.299999713897705,
                "height": 6.299999713897705,
                "offsetX": 177.36000657081604,
                "offsetY": 757.2099363803864,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620263gDpyvp",
                "shape": {
                    "type": "Path",
                    "data": "M177,758.49a.57.57,0,0,1-.22,0,.78.78,0,0,1-.53-1l2.77-9.46-21,4.21a.79.79,0,0,1-.91-.61.78.78,0,0,1,.61-.91L180,746.26a.8.8,0,0,1,.73.24.77.77,0,0,1,.17.74l-3.13,10.69A.78.78,0,0,1,177,758.49Z"
                },
                "style": {
                    "fill": "#5e320d",
                    "strokeWidth": 0
                },
                "width": 23.835845947265625,
                "height": 12.2540283203125,
                "offsetX": 169.01416015625,
                "offsetY": 752.3736572265625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620264Cv7Z20",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#5e320d"
                },
                "width": 17.860000610351562,
                "height": 17.860000610351562,
                "offsetX": 149.5300064086914,
                "offsetY": 754.0600051879883,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620265SRL74M",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#a5a5a5"
                },
                "width": 9.460000038146973,
                "height": 9.460000038146973,
                "offsetX": 434.22996950149536,
                "offsetY": 757.5100293159485,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620266HGelgf",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#cecdcc"
                },
                "width": 48.83000183105469,
                "height": 1.0500000715255737,
                "offsetX": 433.9650192260742,
                "offsetY": 754.3550171256065,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620267idXoZx",
                "shape": {
                    "type": "Path",
                    "data": "M454.27 760.66 413.66 760.66 409.55 754.88 458.39 754.88 454.27 760.66"
                },
                "style": {},
                "width": 48.84002685546875,
                "height": 5.77996826171875,
                "offsetX": 433.9700012207031,
                "offsetY": 757.7699890136719,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96202680rirKGG",
                "shape": {
                    "type": "Path",
                    "data": "M453.99 760.13 413.94 760.13 410.57 755.41 457.25 755.41 453.99 760.13"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 46.67999267578125,
                "height": 4.72003173828125,
                "offsetX": 433.9100036621094,
                "offsetY": 757.7699890136719,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620269gm3W0Q",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 1.22
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 80.6500015258789,
                "height": 5.7900004386901855,
                "offsetX": 78.94499969482422,
                "offsetY": 908.8950002193451,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620270gwzR9p",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 1.29
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 79.7699966430664,
                "height": 5.150000095367432,
                "offsetX": 78.74499893188477,
                "offsetY": 1004.4250366687775,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620271sngFD4",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "url(#linear-gradient)"
                },
                "width": 76.12000274658203,
                "height": 90.05999755859375,
                "offsetX": 78.95000076293945,
                "offsetY": 956.8200378417969,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620272u6liBY",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#edaa51"
                },
                "width": 76.12000274658203,
                "height": 61.7599983215332,
                "offsetX": 78.95000076293945,
                "offsetY": 970.9800357818604,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620274sMAWvM",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 1.29
                },
                "style": {
                    "fill": "#edaa51"
                },
                "width": 80.40999603271484,
                "height": 9.170000076293945,
                "offsetX": 79.06499862670898,
                "offsetY": 944.6850366592407,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620275Sx4LW4",
                "shape": {
                    "type": "Path",
                    "data": "M73.74,929.32,70.49,929a82.69,82.69,0,0,0-19,0l-3.25.37a.51.51,0,0,1-.56-.62l.24-1.12a26.1,26.1,0,0,0,0-10.85l-.24-1.12a.51.51,0,0,1,.56-.62l3.25.38a83.83,83.83,0,0,0,19,0l3.25-.38a.51.51,0,0,1,.56.62l-.24,1.12a26.1,26.1,0,0,0,0,10.85l.24,1.12A.51.51,0,0,1,73.74,929.32Z"
                },
                "style": {
                    "fill": "#edaa51",
                    "strokeWidth": 0
                },
                "width": 26.64575958251953,
                "height": 14.3377685546875,
                "offsetX": 60.989994049072266,
                "offsetY": 922.2049560546875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620276Y67XY0",
                "shape": {
                    "type": "Path",
                    "data": "M108.68,929.32l-3.25-.37a82.69,82.69,0,0,0-19,0l-3.25.37a.51.51,0,0,1-.56-.62l.24-1.12a26.1,26.1,0,0,0,0-10.85l-.24-1.12a.51.51,0,0,1,.56-.62l3.25.38a83.83,83.83,0,0,0,19,0l3.25-.38a.51.51,0,0,1,.56.62l-.24,1.12a26.1,26.1,0,0,0,0,10.85l.24,1.12A.51.51,0,0,1,108.68,929.32Z"
                },
                "style": {
                    "fill": "#edaa51",
                    "strokeWidth": 0
                },
                "width": 26.645767211914062,
                "height": 14.337646484375,
                "offsetX": 95.93000793457031,
                "offsetY": 922.155029296875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620277qzFcDg",
                "shape": {
                    "type": "Path",
                    "data": "M48.24,929.32a.51.51,0,0,1-.56-.62l.24-1.12a26.1,26.1,0,0,0,0-10.85l-.24-1.12a.51.51,0,0,1,.56-.62l3.25.38a83.83,83.83,0,0,0,19,0h0a52.1,52.1,0,0,1-20.1,13.18Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 22.822891235351562,
                "height": 14.33758544921875,
                "offsetX": 59.07856750488281,
                "offsetY": 922.1550598144531,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620278N708Lj",
                "shape": {
                    "type": "Path",
                    "data": "M83.18,929.32a.51.51,0,0,1-.56-.62l.24-1.12a26.1,26.1,0,0,0,0-10.85l-.24-1.12a.51.51,0,0,1,.56-.62l3.25.38a83.83,83.83,0,0,0,19,0h0a52.1,52.1,0,0,1-20.1,13.18Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 22.8228759765625,
                "height": 14.337646484375,
                "offsetX": 94.01856231689453,
                "offsetY": 922.155029296875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620279MS82xC",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 1.29
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 63.03999710083008,
                "height": 5.7900004386901855,
                "offsetX": 194.17000770568848,
                "offsetY": 908.8950002193451,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620280uD4d2n",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 1.29
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 59.179996490478516,
                "height": 5.150000095367432,
                "offsetX": 193.97000312805176,
                "offsetY": 1004.4250366687775,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620281mmw6wz",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "url(#linear-gradient-2)"
                },
                "width": 55.529998779296875,
                "height": 90.05999755859375,
                "offsetX": 194.1750030517578,
                "offsetY": 956.8200378417969,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620282b3D2Wl",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#edaa51"
                },
                "width": 55.529998779296875,
                "height": 61.7599983215332,
                "offsetX": 194.1750030517578,
                "offsetY": 970.9800357818604,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620284Bt15I5",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 1.29
                },
                "style": {
                    "fill": "#edaa51"
                },
                "width": 59.83000183105469,
                "height": 9.170000076293945,
                "offsetX": 194.29500579833984,
                "offsetY": 944.6850366592407,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620285Sbhwj6",
                "shape": {
                    "type": "Path",
                    "data": "M206.92,930.61l-3.25-.37a82.61,82.61,0,0,0-19,0l-3.25.37a.52.52,0,0,1-.57-.62l.24-1.12a25.77,25.77,0,0,0,0-10.85l-.24-1.12a.52.52,0,0,1,.57-.62l3.25.37a82.61,82.61,0,0,0,19,0l3.25-.37a.52.52,0,0,1,.57.62l-.24,1.12a25.77,25.77,0,0,0,0,10.85l.24,1.12A.52.52,0,0,1,206.92,930.61Z"
                },
                "style": {
                    "fill": "#edaa51",
                    "strokeWidth": 0
                },
                "width": 26.660842895507812,
                "height": 14.33709716796875,
                "offsetX": 194.17000579833984,
                "offsetY": 923.4450378417969,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620286tYHApb",
                "shape": {
                    "type": "Path",
                    "data": "M181.43,930.61a.52.52,0,0,1-.57-.62l.24-1.12a25.77,25.77,0,0,0,0-10.85l-.24-1.12a.52.52,0,0,1,.57-.62l3.25.37a82.61,82.61,0,0,0,19,0h0a51.91,51.91,0,0,1-20.09,13.18Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 22.830413818359375,
                "height": 14.33697509765625,
                "offsetX": 192.26478576660156,
                "offsetY": 923.4449768066406,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620287Fm2hZ4",
                "shape": {
                    "type": "Path",
                    "data": "M337,972.4V927.6a1.74,1.74,0,0,0-1.75-1.74H264.58a1.74,1.74,0,0,0-1.75,1.74v44.8h0l5.24,8.83h63.69L337,972.4Zm-9.4,4.8c-.17.64-.5,1.1-.75,1s-.32-.63-.15-1.27.5-1.1.75-1S327.77,976.56,327.6,977.2Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 74.17001342773438,
                "height": 55.3699951171875,
                "offsetX": 299.9149932861328,
                "offsetY": 953.5449829101562,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620288jrv3WW",
                "shape": {
                    "type": "Path",
                    "data": "M262.83,972.4l5.24,8.83h63.69L337,972.4Zm64.77,4.8c-.17.64-.5,1.1-.75,1s-.32-.63-.15-1.27.5-1.1.75-1S327.77,976.56,327.6,977.2Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 74.17001342773438,
                "height": 8.83001708984375,
                "offsetX": 299.9149932861328,
                "offsetY": 976.8150329589844,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96202890HbYp0",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 9.13
                },
                "style": {
                    "fill": "#edab7e"
                },
                "width": 18.25,
                "height": 18.25,
                "offsetX": 299.5849914550781,
                "offsetY": 953.0650024414062,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620290QwsiiW",
                "shape": {
                    "type": "Path",
                    "data": "M294.39 944.31 304.86 944.31 306.61 942.02 292.65 942.02 294.39 944.31"
                },
                "style": {
                    "fill": "url(#linear-gradient-3)"
                },
                "width": 13.959991455078125,
                "height": 2.28997802734375,
                "offsetX": 299.62998962402344,
                "offsetY": 943.1650085449219,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620291o320gk",
                "shape": {
                    "type": "Path",
                    "data": "M294.39 954.78 304.86 954.78 306.61 957.06 292.65 957.06 294.39 954.78"
                },
                "style": {
                    "fill": "url(#linear-gradient-4)"
                },
                "width": 13.959991455078125,
                "height": 2.27996826171875,
                "offsetX": 299.62998962402344,
                "offsetY": 955.9200134277344,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96202926ihT26",
                "shape": {
                    "type": "Path",
                    "data": "M304.86 944.31 304.86 954.78 307.15 956.52 307.15 942.56 304.86 944.31"
                },
                "style": {
                    "fill": "url(#linear-gradient-5)"
                },
                "width": 2.290008544921875,
                "height": 13.96002197265625,
                "offsetX": 306.00498962402344,
                "offsetY": 949.5400085449219,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620293KCaIiy",
                "shape": {
                    "type": "Path",
                    "data": "M294.39 944.31 294.39 954.78 292.1 956.52 292.1 942.56 294.39 944.31"
                },
                "style": {
                    "fill": "url(#linear-gradient-6)"
                },
                "width": 2.290008544921875,
                "height": 13.96002197265625,
                "offsetX": 293.24501037597656,
                "offsetY": 949.5400085449219,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620294e5rkmR",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#663610"
                },
                "width": 10.470000267028809,
                "height": 10.470000267028809,
                "offsetX": 299.6249842643738,
                "offsetY": 949.5449976921082,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620295ObPWWE",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "url(#linear-gradient-7)"
                },
                "width": 43.0099983215332,
                "height": 2.2300000190734863,
                "offsetX": 394.5049991607666,
                "offsetY": 962.6950170993805,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96202967dEPbV",
                "shape": {
                    "type": "Path",
                    "data": "M462.37 963.41 419.88 969 419.32 966.9 462.37 961.32 462.37 963.41"
                },
                "style": {
                    "fill": "url(#linear-gradient-8)"
                },
                "width": 43.04998779296875,
                "height": 7.67999267578125,
                "offsetX": 440.8450012207031,
                "offsetY": 965.1600036621094,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620297tWqG1o",
                "shape": {
                    "type": "Path",
                    "data": "M375.23,937h84.9a2.23,2.23,0,0,1,2.23,2.23v22.34a0,0,0,0,1,0,0H373a0,0,0,0,1,0,0V939.23A2.23,2.23,0,0,1,375.23,937Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 89.36001586914062,
                "height": 24.570068359375,
                "offsetX": 417.6800079345703,
                "offsetY": 949.2849731445312,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620298COpECP",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 0.28
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 1.6799999475479126,
                "height": 0.5600000023841858,
                "offsetX": 400.65002804994583,
                "offsetY": 964.0899975597858,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620299X7BIla",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 0.28
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 1.6799999475479126,
                "height": 0.5600000023841858,
                "offsetX": 437.33999997377396,
                "offsetY": 966.9899609386921,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620300ydRnvn",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#d1d2d3"
                },
                "width": 39.689998626708984,
                "height": 2.450000047683716,
                "offsetX": 182.99500846862793,
                "offsetY": 1180.2849365472794,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203011i1xhq",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#d1d2d3"
                },
                "width": 39.689998626708984,
                "height": 1.9600000381469727,
                "offsetX": 182.99500846862793,
                "offsetY": 1228.549946308136,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620302omAMFk",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#d1d2d3"
                },
                "width": 3.9200000762939453,
                "height": 0.9800000190734863,
                "offsetX": 166.09000492095947,
                "offsetY": 1232.4699804782867,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620303AUI22o",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 3.92
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 69.09000396728516,
                "height": 43.119998931884766,
                "offsetX": 314.5550117492676,
                "offsetY": 1111.3599262237549,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620304XtWFSL",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 4.9
                },
                "style": {
                    "fill": "#a2a2a3"
                },
                "width": 67.12999725341797,
                "height": 67.12999725341797,
                "offsetX": 199.01499557495117,
                "offsetY": 1113.564998626709,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203050J7N4IR",
                "shape": {
                    "type": "Path",
                    "data": "M184.32,1107a10,10,0,1,1,10-10A10.06,10.06,0,0,1,184.32,1107Zm0-18.62a8.58,8.58,0,1,0,8.57,8.58A8.59,8.59,0,0,0,184.32,1088.33Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 20,
                "height": 20,
                "offsetX": 184.32000732421875,
                "offsetY": 1097,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203051Cj32E2",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 12.25999927520752,
                "height": 12.25999927520752,
                "offsetX": 184.32000207901,
                "offsetY": 1096.9100289344788,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203060kdNNTX",
                "shape": {
                    "type": "Path",
                    "data": "M213.72,1107a10,10,0,1,1,10-10A10.06,10.06,0,0,1,213.72,1107Zm0-18.62a8.58,8.58,0,1,0,8.57,8.58A8.59,8.59,0,0,0,213.72,1088.33Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 20,
                "height": 20,
                "offsetX": 213.72000122070312,
                "offsetY": 1097,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203061ttc0ln",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 12.25999927520752,
                "height": 12.25999927520752,
                "offsetX": 213.71998071670532,
                "offsetY": 1096.9100289344788,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203070NIIHoD",
                "shape": {
                    "type": "Path",
                    "data": "M184.32,1133.9a10,10,0,1,1,10-10A10.06,10.06,0,0,1,184.32,1133.9Zm0-18.62a8.58,8.58,0,1,0,8.57,8.58A8.59,8.59,0,0,0,184.32,1115.28Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 20,
                "height": 20,
                "offsetX": 184.32000732421875,
                "offsetY": 1123.9000244140625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203071Vysont",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 12.25999927520752,
                "height": 12.25999927520752,
                "offsetX": 184.32000207901,
                "offsetY": 1123.8599801063538,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203080vg7PWe",
                "shape": {
                    "type": "Path",
                    "data": "M213.72,1133.9a10,10,0,1,1,10-10A10.06,10.06,0,0,1,213.72,1133.9Zm0-18.62a8.58,8.58,0,1,0,8.57,8.58A8.59,8.59,0,0,0,213.72,1115.28Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 20,
                "height": 20,
                "offsetX": 213.72000122070312,
                "offsetY": 1123.9000244140625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203081NpWnpY",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 12.25999927520752,
                "height": 12.25999927520752,
                "offsetX": 213.71998071670532,
                "offsetY": 1123.8599801063538,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620309L4AswZ",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 9.319999694824219,
                "height": 9.319999694824219,
                "offsetX": 184.32000350952148,
                "offsetY": 1096.909999847412,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203101heIyV",
                "shape": {
                    "type": "Path",
                    "data": "M184.56 1086.86 184.07 1086.86 184.07 1092.25 184.32 1092.25 184.56 1092.25 184.56 1086.86"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 0.489990234375,
                "height": 5.3900146484375,
                "offsetX": 184.31500244140625,
                "offsetY": 1089.5549926757812,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620311Fyn27R",
                "shape": {
                    "type": "Path",
                    "data": "M184.07 1106.95 184.56 1106.95 184.56 1101.56 184.32 1101.56 184.07 1101.56 184.07 1106.95"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 0.489990234375,
                "height": 5.389892578125,
                "offsetX": 184.31500244140625,
                "offsetY": 1104.2550048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620312y9yPdM",
                "shape": {
                    "type": "Path",
                    "data": "M174.27 1096.66 174.27 1097.15 179.66 1097.15 179.66 1096.9 179.66 1096.66 174.27 1096.66"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 5.3899993896484375,
                "height": 0.489990234375,
                "offsetX": 176.96500396728516,
                "offsetY": 1096.905029296875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620313ScExI9",
                "shape": {
                    "type": "Path",
                    "data": "M188.97 1096.66 188.97 1096.9 188.97 1097.15 194.36 1097.15 194.36 1096.66 188.97 1096.66"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 5.3899993896484375,
                "height": 0.489990234375,
                "offsetX": 191.66500091552734,
                "offsetY": 1096.905029296875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620314MM9zTg",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 9.319999694824219,
                "height": 9.319999694824219,
                "offsetX": 213.7199821472168,
                "offsetY": 1096.909999847412,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203153BoCU3",
                "shape": {
                    "type": "Path",
                    "data": "M213.96 1086.86 213.47 1086.86 213.47 1092.25 213.72 1092.25 213.96 1092.25 213.96 1086.86"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 0.4900054931640625,
                "height": 5.3900146484375,
                "offsetX": 213.71500396728516,
                "offsetY": 1089.5549926757812,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620316MfZCpm",
                "shape": {
                    "type": "Path",
                    "data": "M213.47 1106.95 213.96 1106.95 213.96 1101.56 213.72 1101.56 213.47 1101.56 213.47 1106.95"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 0.4900054931640625,
                "height": 5.389892578125,
                "offsetX": 213.71500396728516,
                "offsetY": 1104.2550048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620317iG9MEP",
                "shape": {
                    "type": "Path",
                    "data": "M203.67 1096.66 203.67 1097.15 209.06 1097.15 209.06 1096.9 209.06 1096.66 203.67 1096.66"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 5.3899993896484375,
                "height": 0.489990234375,
                "offsetX": 206.36499786376953,
                "offsetY": 1096.905029296875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962031893eywv",
                "shape": {
                    "type": "Path",
                    "data": "M218.37 1096.66 218.37 1096.9 218.37 1097.15 223.76 1097.15 223.76 1096.66 218.37 1096.66"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 5.3899993896484375,
                "height": 0.489990234375,
                "offsetX": 221.06499481201172,
                "offsetY": 1096.905029296875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620319FKlJQt",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 9.319999694824219,
                "height": 9.319999694824219,
                "offsetX": 184.32000350952148,
                "offsetY": 1123.859951019287,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620320zWqZPx",
                "shape": {
                    "type": "Path",
                    "data": "M184.56 1113.81 184.07 1113.81 184.07 1119.2 184.32 1119.2 184.56 1119.2 184.56 1113.81"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 0.489990234375,
                "height": 5.389892578125,
                "offsetX": 184.31500244140625,
                "offsetY": 1116.5050048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203216Tl8eY",
                "shape": {
                    "type": "Path",
                    "data": "M184.07 1133.9 184.56 1133.9 184.56 1128.51 184.32 1128.51 184.07 1128.51 184.07 1133.9"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 0.489990234375,
                "height": 5.3900146484375,
                "offsetX": 184.31500244140625,
                "offsetY": 1131.2050170898438,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620322I4kJW2",
                "shape": {
                    "type": "Path",
                    "data": "M174.27 1123.61 174.27 1124.1 179.66 1124.1 179.66 1123.86 179.66 1123.61 174.27 1123.61"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 5.3899993896484375,
                "height": 0.489990234375,
                "offsetX": 176.96500396728516,
                "offsetY": 1123.85498046875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620323dQST5x",
                "shape": {
                    "type": "Path",
                    "data": "M188.97 1123.61 188.97 1123.86 188.97 1124.1 194.36 1124.1 194.36 1123.61 188.97 1123.61"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 5.3899993896484375,
                "height": 0.489990234375,
                "offsetX": 191.66500091552734,
                "offsetY": 1123.85498046875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620324GcpROE",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 9.319999694824219,
                "height": 9.319999694824219,
                "offsetX": 213.7199821472168,
                "offsetY": 1123.859951019287,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620325KsSLnw",
                "shape": {
                    "type": "Path",
                    "data": "M213.96 1113.81 213.47 1113.81 213.47 1119.2 213.72 1119.2 213.96 1119.2 213.96 1113.81"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 0.4900054931640625,
                "height": 5.389892578125,
                "offsetX": 213.71500396728516,
                "offsetY": 1116.5050048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203260EkULA",
                "shape": {
                    "type": "Path",
                    "data": "M213.47 1133.9 213.96 1133.9 213.96 1128.51 213.72 1128.51 213.47 1128.51 213.47 1133.9"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 0.4900054931640625,
                "height": 5.3900146484375,
                "offsetX": 213.71500396728516,
                "offsetY": 1131.2050170898438,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620327m0CBO4",
                "shape": {
                    "type": "Path",
                    "data": "M203.67 1123.61 203.67 1124.1 209.06 1124.1 209.06 1123.86 209.06 1123.61 203.67 1123.61"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 5.3899993896484375,
                "height": 0.489990234375,
                "offsetX": 206.36499786376953,
                "offsetY": 1123.85498046875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620328s0YfYe",
                "shape": {
                    "type": "Path",
                    "data": "M218.37 1123.61 218.37 1123.86 218.37 1124.1 223.76 1124.1 223.76 1123.61 218.37 1123.61"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 5.3899993896484375,
                "height": 0.489990234375,
                "offsetX": 221.06499481201172,
                "offsetY": 1123.85498046875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203298LgLEn",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#6b6c6d"
                },
                "width": 4.900000095367432,
                "height": 4.900000095367432,
                "offsetX": 187.50000309944153,
                "offsetY": 1141.7400391101837,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620330PdQH94",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#6b6c6d"
                },
                "width": 4.900000095367432,
                "height": 4.900000095367432,
                "offsetX": 195.83000493049622,
                "offsetY": 1141.7400391101837,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620331QoR7fo",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#6b6c6d"
                },
                "width": 4.900000095367432,
                "height": 4.900000095367432,
                "offsetX": 204.15999150276184,
                "offsetY": 1141.7400391101837,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620332qgVLMl",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#6b6c6d"
                },
                "width": 4.900000095367432,
                "height": 4.900000095367432,
                "offsetX": 212.48999333381653,
                "offsetY": 1141.7400391101837,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620333jVgYZE",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 3.92
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 42.630001068115234,
                "height": 42.630001068115234,
                "offsetX": 432.0449810028076,
                "offsetY": 1113.0750102996826,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620334X90Itz",
                "shape": {
                    "type": "Path",
                    "data": "M448.46,1096.66H415.63a1,1,0,0,0-1,1V1129a1,1,0,0,0,1,1h32.83a1,1,0,0,0,1-1v-31.36A1,1,0,0,0,448.46,1096.66Zm-16.17,19.6a2.94,2.94,0,1,1,2.94-2.94A2.94,2.94,0,0,1,432.29,1116.26Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 34.83001708984375,
                "height": 33.3399658203125,
                "offsetX": 432.0450134277344,
                "offsetY": 1113.3300170898438,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620335yJWGzQ",
                "shape": {
                    "type": "Path",
                    "data": "M414.65,1096.66v33.22l.23-.14c13.61-8,23.86-19.6,29.21-33.08H414.65Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 29.44000244140625,
                "height": 33.219970703125,
                "offsetX": 429.3699951171875,
                "offsetY": 1113.27001953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620336sE9OFe",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 28.57
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 57.13999938964844,
                "height": 57.13999938964844,
                "offsetX": 291.79000091552734,
                "offsetY": 1206.4299850463867,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620337ryww8c",
                "shape": {
                    "type": "Path",
                    "data": "M292.77,1186.4h-2a22.33,22.33,0,0,0-22.33,22.33h0a22.33,22.33,0,0,0,22.33,22.33h2a22.33,22.33,0,0,0,22.33-22.33h0A22.33,22.33,0,0,0,292.77,1186.4ZM291.46,1210a3.94,3.94,0,1,1,3.94-3.94A3.93,3.93,0,0,1,291.46,1210Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 46.65997314453125,
                "height": 44.659912109375,
                "offsetX": 291.7699890136719,
                "offsetY": 1208.72998046875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620338H96GON",
                "shape": {
                    "type": "Path",
                    "data": "M275.17,1224.36a22.18,22.18,0,0,1,0-31.36h0c8.67-8.67,24-9.34,32.67-.69Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 39.16278076171875,
                "height": 38.2099609375,
                "offsetX": 288.2586364746094,
                "offsetY": 1205.2550048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620339QryCaX",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 3.92
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 52.429996490478516,
                "height": 32.82999801635742,
                "offsetX": 73.97499656677246,
                "offsetY": 1207.8250331878662,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620340lpryYV",
                "shape": {
                    "type": "Path",
                    "data": "M95.29,1196.31H52.66a1,1,0,0,0-1,1v21.56a1,1,0,0,0,1,1H95.29a1,1,0,0,0,1-1v-21.56A1,1,0,0,0,95.29,1196.31Zm-21.56,12.25a2.94,2.94,0,1,1,2.94-2.94A2.94,2.94,0,0,1,73.73,1208.56Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 44.630001068115234,
                "height": 23.56005859375,
                "offsetX": 73.97500038146973,
                "offsetY": 1208.090087890625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620341r0xv5J",
                "shape": {
                    "type": "Path",
                    "data": "M73.88,1192.06h0a1.81,1.81,0,0,1,1.81,1.91l-.53,9.75a1.29,1.29,0,0,1-1.28,1.22h0a1.29,1.29,0,0,1-1.29-1.22l-.52-9.75A1.81,1.81,0,0,1,73.88,1192.06Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 3.6255416870117188,
                "height": 12.8802490234375,
                "offsetX": 73.8799934387207,
                "offsetY": 1198.4999389648438,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620342lRFahl",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 43.61000061035156,
                "height": 2.450000047683716,
                "offsetX": 182.99500274658203,
                "offsetY": 1230.7550293207169,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620343xo9zBh",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 43.61000061035156,
                "height": 46.05999755859375,
                "offsetX": 182.99500274658203,
                "offsetY": 1204.5400085449219,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620344iPlEA6",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 38.709999084472656,
                "height": 0.25,
                "offsetX": 182.99499893188477,
                "offsetY": 1228.3150634765625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620345VDXsap",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 38.709999084472656,
                "height": 0.25,
                "offsetX": 182.99499893188477,
                "offsetY": 1228.8050537109375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620346FYrK3D",
                "shape": {
                    "type": "Path",
                    "data": "M391.94,1180.85l-19.75,19.75a1.46,1.46,0,0,0,0,2.08l30.49,30.49a1.46,1.46,0,0,0,2.08,0l6-6a2,2,0,0,1,2.92.16l5.48,6.88a4.62,4.62,0,0,0,6.95.48h0a4.62,4.62,0,0,0-.61-7l-6.88-5.18a2,2,0,0,1-.21-3l6.14-6.14a1.48,1.48,0,0,0,0-2.08L394,1180.85A1.48,1.48,0,0,0,391.94,1180.85Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 55.68133544921875,
                "height": 55.6092529296875,
                "offsetX": 399.5953674316406,
                "offsetY": 1208.2374877929688,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962034700qHXXY5",
                "shape": {
                    "type": "Path",
                    "data": "M394.5,1180.37s8.12,17.72,26,26"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#af7e38",
                    "strokeWidth": 0
                },
                "width": 26,
                "height": 26,
                "offsetX": 407.5,
                "offsetY": 1193.3699951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962034701mdiErc",
                "shape": {
                    "type": "Path",
                    "data": "M369.29,1201s22.74,13.15,36.16,36.16"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#af7e38",
                    "strokeWidth": 0
                },
                "width": 36.160003662109375,
                "height": 36.1600341796875,
                "offsetX": 387.37001037597656,
                "offsetY": 1219.0800170898438,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962034702KYZouE",
                "shape": {
                    "type": "Path",
                    "data": "M387.7,1179.12s13.15,22.74,36.17,36.16"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#af7e38",
                    "strokeWidth": 0
                },
                "width": 36.16998291015625,
                "height": 36.1600341796875,
                "offsetX": 405.7850036621094,
                "offsetY": 1197.2000122070312,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962034703iPky8C",
                "shape": {
                    "type": "Path",
                    "data": "M383.89,1183.62s13.15,22.75,36.17,36.16"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#af7e38",
                    "strokeWidth": 0
                },
                "width": 36.16998291015625,
                "height": 36.1600341796875,
                "offsetX": 401.9750061035156,
                "offsetY": 1201.7000122070312,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962034704m3f4YK",
                "shape": {
                    "type": "Path",
                    "data": "M372.06,1195.45s22.74,13.15,36.16,36.17"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#af7e38",
                    "strokeWidth": 0
                },
                "width": 36.160003662109375,
                "height": 36.1700439453125,
                "offsetX": 390.13999938964844,
                "offsetY": 1213.5349731445312,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962034705bWa4L2",
                "shape": {
                    "type": "Path",
                    "data": "M375.21,1180.49s19.85,34.32,53.53,54.9"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#af7e38",
                    "strokeWidth": 0
                },
                "width": 53.529998779296875,
                "height": 54.9000244140625,
                "offsetX": 401.97499084472656,
                "offsetY": 1207.9400024414062,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620348ALymNE",
                "shape": {
                    "type": "Path",
                    "data": "M418.37,1219.56l4.57-4.57-50.75-14.39a1.46,1.46,0,0,0,0,2.08l30.49,30.49a1.46,1.46,0,0,0,2.08,0l6-6a2,2,0,0,1,2.92.16l5.48,6.88a4.62,4.62,0,1,0,6.34-6.56l-6.88-5.18A2,2,0,0,1,418.37,1219.56Z"
                },
                "style": {
                    "fill": "#c68f3e",
                    "strokeWidth": 0
                },
                "width": 55.722015380859375,
                "height": 35.4588623046875,
                "offsetX": 399.61573791503906,
                "offsetY": 1218.3295288085938,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620349IMvpkR",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#ea463d"
                },
                "width": 11.75999927520752,
                "height": 11.75999927520752,
                "offsetX": 385.1999764442444,
                "offsetY": 1202.6800484657288,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203501vzcmR",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#ff4729"
                },
                "width": 11.75999927520752,
                "height": 11.75999927520752,
                "offsetX": 385.1999764442444,
                "offsetY": 1202.1900582313538,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620351WvQ2cX",
                "shape": {
                    "type": "Path",
                    "data": "M389.58,1203.17a.45.45,0,0,1,.49.45c-.28,2-2.35,3.47-4.87,3.47s-4.57-1.5-4.86-3.44c0-.25.21-.48.53-.48h.53a5.33,5.33,0,0,1,2.32.52h0a3.49,3.49,0,0,0,2.78.08l.05,0a8.05,8.05,0,0,1,3-.58Z"
                },
                "style": {
                    "fill": "#be2c1c",
                    "strokeWidth": 0
                },
                "width": 9.72998046875,
                "height": 3.9217529296875,
                "offsetX": 385.2049865722656,
                "offsetY": 1205.1290893554688,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620352iAyolE",
                "shape": {
                    "type": "Path",
                    "data": "M389.58,1201.21c.29,0,.52-.2.49-.44-.28-2-2.35-3.48-4.87-3.48s-4.57,1.5-4.86,3.44c0,.26.21.48.53.48h.53a5.47,5.47,0,0,0,2.32-.51h0a3.53,3.53,0,0,1,2.78-.09l.05,0a8.05,8.05,0,0,0,3,.58Z"
                },
                "style": {
                    "fill": "#be2c1c",
                    "strokeWidth": 0
                },
                "width": 9.73260498046875,
                "height": 3.9200439453125,
                "offsetX": 385.206298828125,
                "offsetY": 1199.2500610351562,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203530IdGdt",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.25
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 0.5,
                "height": 1.4800000190734863,
                "offsetX": 384.9499816894531,
                "offsetY": 1205.8700048923492,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620354Tkjdi0",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.25
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 0.5,
                "height": 1.4800000190734863,
                "offsetX": 386.4200134277344,
                "offsetY": 1205.3800146579742,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620355zHVH2p",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.25
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 0.5,
                "height": 1.4800000190734863,
                "offsetX": 387.3999938964844,
                "offsetY": 1204.8900244235992,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203562xR5Nv",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.25
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 0.5,
                "height": 1.4800000190734863,
                "offsetX": 388.3800048828125,
                "offsetY": 1204.4000341892242,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620357WUiXBH",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.74
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1.4800000190734863,
                "height": 0.5,
                "offsetX": 383.59000611305237,
                "offsetY": 1205.3800048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620358lK886k",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.74
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1.4800000190734863,
                "height": 0.5,
                "offsetX": 382.60999512672424,
                "offsetY": 1204.8900146484375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620359plzIqe",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.74
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1.4800000190734863,
                "height": 0.5,
                "offsetX": 381.63001465797424,
                "offsetY": 1204.4000244140625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203605oC09g",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.25
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 0.5,
                "height": 1.4800000190734863,
                "offsetX": 384.9499816894531,
                "offsetY": 1198.5799658298492,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620361yM9oYE",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.74
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1.4800000190734863,
                "height": 0.5,
                "offsetX": 386.4200232028961,
                "offsetY": 1199.0699462890625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620362y8QZ4g",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.74
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1.4800000190734863,
                "height": 0.5,
                "offsetX": 387.4000036716461,
                "offsetY": 1199.5599365234375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620363305oKU",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.74
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1.4800000190734863,
                "height": 0.5,
                "offsetX": 388.38001465797424,
                "offsetY": 1200.0499267578125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203642NyaZk",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.25
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 0.5,
                "height": 1.4800000190734863,
                "offsetX": 383.5899963378906,
                "offsetY": 1199.0699560642242,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620365zCGDJE",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.25
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 0.5,
                "height": 1.4800000190734863,
                "offsetX": 382.6099853515625,
                "offsetY": 1199.5599462985992,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962036647vlJw",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.25
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 0.5,
                "height": 1.4800000190734863,
                "offsetX": 381.6300048828125,
                "offsetY": 1200.0499365329742,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620367sjRlse",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#ea463d"
                },
                "width": 11.75999927520752,
                "height": 11.75999927520752,
                "offsetX": 392.30001306533813,
                "offsetY": 1191.6600289344788,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203685jQPzK",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#ff4729"
                },
                "width": 11.75999927520752,
                "height": 11.75999927520752,
                "offsetX": 391.81002283096313,
                "offsetY": 1191.6600289344788,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620369xzk1ky",
                "shape": {
                    "type": "Path",
                    "data": "M392.79,1196a.45.45,0,0,0,.45.5c1.95-.28,3.47-2.35,3.47-4.87s-1.5-4.57-3.44-4.87a.49.49,0,0,0-.48.54v.53a5.33,5.33,0,0,0,.52,2.32h0a3.49,3.49,0,0,1,.08,2.78v0a7.94,7.94,0,0,0-.59,3Z"
                },
                "style": {
                    "fill": "#be2c1c",
                    "strokeWidth": 0
                },
                "width": 3.922821044921875,
                "height": 9.739990234375,
                "offsetX": 394.7486114501953,
                "offsetY": 1191.6300048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620370K0I2AG",
                "shape": {
                    "type": "Path",
                    "data": "M390.83,1196c0,.3-.2.53-.44.5-2-.28-3.48-2.35-3.48-4.87s1.5-4.57,3.44-4.87a.49.49,0,0,1,.48.54v.53a5.47,5.47,0,0,1-.51,2.32h0a3.53,3.53,0,0,0-.09,2.78l0,0a8.13,8.13,0,0,1,.58,3Z"
                },
                "style": {
                    "fill": "#be2c1c",
                    "strokeWidth": 0
                },
                "width": 3.922607421875,
                "height": 9.74267578125,
                "offsetX": 388.87127685546875,
                "offsetY": 1191.63134765625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620371wixj47",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.74
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1.4800000190734863,
                "height": 0.5,
                "offsetX": 395.49000000953674,
                "offsetY": 1191.4100341796875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620372Ak931d",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.25
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 0.5,
                "height": 1.4800000190734863,
                "offsetX": 395,
                "offsetY": 1192.8800146579742,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620373X3jnVt",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.25
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 0.5,
                "height": 1.4800000190734863,
                "offsetX": 394.510009765625,
                "offsetY": 1193.8599951267242,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203745eRoGR",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.25
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 0.5,
                "height": 1.4800000190734863,
                "offsetX": 394.02001953125,
                "offsetY": 1194.8399755954742,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620375KjhHd5",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.74
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1.4800000190734863,
                "height": 0.5,
                "offsetX": 395.00000977516174,
                "offsetY": 1190.0400390625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620376ChAnQs",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.74
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1.4800000190734863,
                "height": 0.5,
                "offsetX": 394.51001954078674,
                "offsetY": 1189.0599365234375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962037774wakO",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.74
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1.4800000190734863,
                "height": 0.5,
                "offsetX": 394.02002930641174,
                "offsetY": 1188.0799560546875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620378QQoYhv",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.74
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1.4800000190734863,
                "height": 0.5,
                "offsetX": 388.21000123023987,
                "offsetY": 1191.4100341796875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620379tBebXW",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.74
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1.4800000190734863,
                "height": 0.5,
                "offsetX": 388.69999146461487,
                "offsetY": 1192.8800048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620380sJJXXs",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.74
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1.4800000190734863,
                "height": 0.5,
                "offsetX": 389.18998169898987,
                "offsetY": 1193.8599853515625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620381Lgc1bg",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.74
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1.4800000190734863,
                "height": 0.5,
                "offsetX": 389.6800329685211,
                "offsetY": 1194.8399658203125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620382tUnXde",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.25
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 0.5,
                "height": 1.4800000190734863,
                "offsetX": 388.6999816894531,
                "offsetY": 1190.0400488376617,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962038324wyHx",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.25
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 0.5,
                "height": 1.4800000190734863,
                "offsetX": 389.1899719238281,
                "offsetY": 1189.0599462985992,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962038415m5AR",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.25
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 0.5,
                "height": 1.4800000190734863,
                "offsetX": 389.6800231933594,
                "offsetY": 1188.0799658298492,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620385EF1Xk4",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#89344d"
                },
                "width": 10.779999732971191,
                "height": 10.779999732971191,
                "offsetX": 401.3699803352356,
                "offsetY": 1200.719955921173,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203862ERkCy",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 9.699999809265137,
                "height": 9.699999809265137,
                "offsetX": 401.36998891830444,
                "offsetY": 1200.71999502182,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203873HotMn",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#89344d"
                },
                "width": 7.840000152587891,
                "height": 7.840000152587891,
                "offsetX": 401.36998176574707,
                "offsetY": 1200.7199268341064,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96203880gVTp8",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 7.059999942779541,
                "height": 7.059999942779541,
                "offsetX": 401.3699963092804,
                "offsetY": 1200.7199413776398,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962038971UBuk",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#89344d"
                },
                "width": 5.87999963760376,
                "height": 5.87999963760376,
                "offsetX": 401.36999249458313,
                "offsetY": 1200.7200291156769,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620390JDi5q8",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 5.299999713897705,
                "height": 5.299999713897705,
                "offsetX": 401.370001077652,
                "offsetY": 1200.7199461460114,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620391XrwGdq",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#89344d"
                },
                "width": 3.9200000762939453,
                "height": 3.9200000762939453,
                "offsetX": 401.37000370025635,
                "offsetY": 1200.720009803772,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620392OlF7vH",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 3.5200002193450928,
                "height": 3.5200002193450928,
                "offsetX": 401.36998546123505,
                "offsetY": 1200.7199610471725,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620393XR3wnL",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#89344d"
                },
                "width": 1.9600000381469727,
                "height": 1.9600000381469727,
                "offsetX": 401.36998414993286,
                "offsetY": 1200.7199902534485,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620394yUNWST",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1.7600001096725464,
                "height": 1.7600001096725464,
                "offsetX": 401.3699902892113,
                "offsetY": 1200.7199658751488,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620395e1j9TI",
                "shape": {
                    "type": "Path",
                    "data": "M404.25,1198.25a4.37,4.37,0,1,0,4.37,4.37A4.37,4.37,0,0,0,404.25,1198.25Zm0,8a3.58,3.58,0,1,1,3.58-3.58A3.58,3.58,0,0,1,404.25,1206.2Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeColor": "#89344d",
                    "strokeWidth": 0
                },
                "width": 8.739990234375,
                "height": 8.739990234375,
                "offsetX": 404.25,
                "offsetY": 1202.6199951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620396CScmI1",
                "shape": {
                    "type": "Path",
                    "data": "M407.42,1200.68a3.65,3.65,0,1,0,3.65,3.65A3.64,3.64,0,0,0,407.42,1200.68Zm0,6.63a3,3,0,1,1,3-3A3,3,0,0,1,407.42,1207.31Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeColor": "#89344d",
                    "strokeWidth": 0
                },
                "width": 7.300018310546875,
                "height": 7.300048828125,
                "offsetX": 407.42002868652344,
                "offsetY": 1204.330078125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620397X3xYBK",
                "shape": {
                    "type": "Path",
                    "data": "M386,1208.66l34.25,13.78-2.65,7.09S389.21,1218.16,386,1208.66Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 34.25,
                "height": 20.8699951171875,
                "offsetX": 403.125,
                "offsetY": 1219.0950317382812,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620398WUVRtx",
                "shape": {
                    "type": "Path",
                    "data": "M387.49,1209.24l-1.45-.58c3.17,9.5,31.6,20.87,31.6,20.87l.34-.92C417,1228.2,390.64,1217.69,387.49,1209.24Z"
                },
                "style": {
                    "fill": "#cfcfcf",
                    "strokeWidth": 0
                },
                "width": 31.94000244140625,
                "height": 20.8699951171875,
                "offsetX": 402.0099792480469,
                "offsetY": 1219.0950317382812,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620399WY45vL",
                "shape": {
                    "type": "Path",
                    "data": "M420.29,1222.44l15.44,6.31a2.49,2.49,0,0,1,1.44,3h0a1.46,1.46,0,0,1-1.92.92l-16.37-6.46Z"
                },
                "style": {
                    "fill": "#5b3b24",
                    "strokeWidth": 0
                },
                "width": 18.38995361328125,
                "height": 10.3291015625,
                "offsetX": 428.0749816894531,
                "offsetY": 1227.6044921875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620400zlPfS6",
                "shape": {
                    "type": "Path",
                    "data": "M419.57,1225.93l15.77,6.19a.19.19,0,0,0,.26-.12v0a.19.19,0,0,0-.11-.24l-15.78-6.18a.2.2,0,0,0-.26.12h0A.21.21,0,0,0,419.57,1225.93Z"
                },
                "style": {
                    "fill": "#7f502f",
                    "strokeWidth": 0
                },
                "width": 16.164337158203125,
                "height": 6.5697021484375,
                "offsetX": 427.5286102294922,
                "offsetY": 1228.8517456054688,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620401WEhsXo",
                "shape": {
                    "type": "Path",
                    "data": "M69.52,1323.41v-52.92a2,2,0,0,0-2-2H48a2,2,0,0,0-2,2V1345a2,2,0,0,0,2,2H99.9a2,2,0,0,0,2-2v-19.6a2,2,0,0,0-2-2Z"
                },
                "style": {
                    "fill": "#270805",
                    "strokeWidth": 0
                },
                "width": 55.900001525878906,
                "height": 78.510009765625,
                "offsetX": 73.95000076293945,
                "offsetY": 1307.7449951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620402yEa7Nw",
                "shape": {
                    "type": "Path",
                    "data": "M193.09,1320.06v-45.57a2,2,0,0,0-2-2h-19.6a2,2,0,0,0-2,2V1349a2,2,0,0,0,2,2h51.94a2,2,0,0,0,2-2v-19.6a2,2,0,0,0-2-2h-23A7.35,7.35,0,0,1,193.09,1320.06Z"
                },
                "style": {
                    "fill": "#270805",
                    "strokeWidth": 0
                },
                "width": 55.94000244140625,
                "height": 78.5098876953125,
                "offsetX": 197.45999145507812,
                "offsetY": 1311.7450561523438,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620403F1kVuB",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#270805"
                },
                "width": 31.360000610351562,
                "height": 78.4000015258789,
                "offsetX": 298.7999954223633,
                "offsetY": 1311.7300300598145,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620404IFsQ0B",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#270805"
                },
                "width": 31.360000610351562,
                "height": 78.4000015258789,
                "offsetX": 407.7999954223633,
                "offsetY": 1312.7300300598145,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620405pl026b",
                "shape": {
                    "type": "Path",
                    "data": "M344,1094.8H311a1,1,0,0,0-1,1v31.16a1,1,0,0,0,1,1h33a1,1,0,0,0,1-1v-31.16A1,1,0,0,0,344,1094.8Zm-16.5,19a2.94,2.94,0,1,1,2.94-2.94A2.94,2.94,0,0,1,327.54,1113.81Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 35,
                "height": 33.1600341796875,
                "offsetX": 327.5,
                "offsetY": 1111.3800659179688,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620406I0jixA",
                "shape": {
                    "type": "Path",
                    "data": "M310.06,1094.8V1128l.22-.13c13.62-8,23.87-19.61,29.22-33.09H310.06Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 29.44000244140625,
                "height": 33.219970703125,
                "offsetX": 324.7799987792969,
                "offsetY": 1111.3900146484375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962040708TdTti",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 18.6200008392334,
                "height": 0.49000000953674316,
                "offsetX": 294.2200040817261,
                "offsetY": 1094.4549609422684,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204071fs6qVk",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 18.6200008392334,
                "height": 0.49000000953674316,
                "offsetX": 294.2200040817261,
                "offsetY": 1097.8850146532059,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204072KxTfnD",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 18.6200008392334,
                "height": 0.49000000953674316,
                "offsetX": 294.2200040817261,
                "offsetY": 1101.3149462938309,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204073c5pzsm",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 18.6200008392334,
                "height": 0.49000000953674316,
                "offsetX": 294.2200040817261,
                "offsetY": 1104.7450000047684,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204074PK59fG",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 18.6200008392334,
                "height": 0.49000000953674316,
                "offsetX": 294.2200040817261,
                "offsetY": 1108.1750537157059,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204075nRzPHr",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 18.6200008392334,
                "height": 0.49000000953674316,
                "offsetX": 294.2200040817261,
                "offsetY": 1111.6049853563309,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204076XXtNDF",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 18.6200008392334,
                "height": 0.49000000953674316,
                "offsetX": 294.2200040817261,
                "offsetY": 1115.0350390672684,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962040772yOupT",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 18.6200008392334,
                "height": 0.49000000953674316,
                "offsetX": 294.2200040817261,
                "offsetY": 1118.4649707078934,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204078hhwDjr",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 18.6200008392334,
                "height": 0.49000000953674316,
                "offsetX": 294.2200040817261,
                "offsetY": 1121.8950244188309,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204079QfufhA",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 18.6200008392334,
                "height": 0.49000000953674316,
                "offsetX": 294.2200040817261,
                "offsetY": 1125.3249560594559,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962040710Cqm59f",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 18.6200008392334,
                "height": 0.49000000953674316,
                "offsetX": 294.2200040817261,
                "offsetY": 1128.7550097703934,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620408oLPYNw",
                "shape": {
                    "type": "Path",
                    "data": "M327.68,1090.44h0a1.82,1.82,0,0,1,1.81,1.92l-.52,9.75a1.28,1.28,0,0,1-1.29,1.21h0a1.28,1.28,0,0,1-1.28-1.21l-.53-9.75A1.82,1.82,0,0,1,327.68,1090.44Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 3.62548828125,
                "height": 12.880126953125,
                "offsetX": 327.67999267578125,
                "offsetY": 1096.8800048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620409yfwxTd",
                "shape": {
                    "type": "Path",
                    "data": "M432,1092.4h0a1.82,1.82,0,0,1,1.81,1.92l-.53,9.75a1.28,1.28,0,0,1-1.28,1.21h0a1.28,1.28,0,0,1-1.29-1.21l-.53-9.75A1.83,1.83,0,0,1,432,1092.4Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 3.63494873046875,
                "height": 12.880126953125,
                "offsetX": 431.9952697753906,
                "offsetY": 1098.840087890625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620410YdJ7px",
                "shape": {
                    "type": "Path",
                    "data": "M291.65,1178.73h0a2.43,2.43,0,0,1,2.43,2.56l-.71,13.07a1.72,1.72,0,0,1-1.72,1.63h0a1.73,1.73,0,0,1-1.72-1.63l-.71-13.07A2.44,2.44,0,0,1,291.65,1178.73Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 4.866424560546875,
                "height": 17.260009765625,
                "offsetX": 291.65025329589844,
                "offsetY": 1187.3599853515625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620411RkNRuF",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 4.73
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 87,
                "height": 44.97999954223633,
                "offsetX": 78.5,
                "offsetY": 1111.4899997711182,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620412PrTRLN",
                "shape": {
                    "type": "Path",
                    "data": "M65.78,1128.06v-33.14H40.33v33.14Zm-4.15-17.75a2.37,2.37,0,1,1-2.36-2.37A2.36,2.36,0,0,1,61.63,1110.31Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 25.449996948242188,
                "height": 33.1400146484375,
                "offsetX": 53.05500030517578,
                "offsetY": 1111.4900512695312,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204137BvrUX",
                "shape": {
                    "type": "Path",
                    "data": "M71.69,1094.92v33.14h45v-33.14Zm5.92,10.65A2.37,2.37,0,1,1,80,1103.2,2.37,2.37,0,0,1,77.61,1105.57Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 45,
                "height": 33.1400146484375,
                "offsetX": 94.19000244140625,
                "offsetY": 1111.4900512695312,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620414XR3LgA",
                "shape": {
                    "type": "Path",
                    "data": "M67.63,1092.18h0a2.17,2.17,0,0,0,.09,3.14l8.65,7.77a1.55,1.55,0,0,0,2.11-.06h0a1.54,1.54,0,0,0,0-2.11l-7.76-8.65A2.17,2.17,0,0,0,67.63,1092.18Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 11.896446228027344,
                "height": 11.89794921875,
                "offsetX": 72.94990158081055,
                "offsetY": 1097.5264892578125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620415Lq3r2h",
                "shape": {
                    "type": "Path",
                    "data": "M40.33,1128.06v-33.14l.19.13a65.76,65.76,0,0,1,25.26,33H40.33Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 25.449974060058594,
                "height": 33.1400146484375,
                "offsetX": 53.054988861083984,
                "offsetY": 1111.4900512695312,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620416TlVfG2",
                "shape": {
                    "type": "Path",
                    "data": "M71.69,1128.06v-33.14l.3.13c17.51,8,30.7,19.57,37.58,33H71.69Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 37.8800048828125,
                "height": 33.1400146484375,
                "offsetX": 90.6300048828125,
                "offsetY": 1111.4900512695312,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620417LpugGD",
                "shape": {
                    "type": "Path",
                    "data": "M53.73,1554.83h0a10,10,0,0,1-6.94-8.39l-2.3-19.37a292.39,292.39,0,0,1,0-69.21l2.3-19.37a10,10,0,0,1,6.94-8.39h0a67.58,67.58,0,0,1,40.88,0h0a10,10,0,0,1,6.94,8.39l2.29,19.15a292.48,292.48,0,0,1,0,69.22l-2.32,19.58a10,10,0,0,1-7,8.39h0A67.43,67.43,0,0,1,53.73,1554.83Z"
                },
                "style": {
                    "fill": "#dbdcdd",
                    "strokeWidth": 0
                },
                "width": 63.459957122802734,
                "height": 131.053466796875,
                "offsetX": 74.16497230529785,
                "offsetY": 1492.4615478515625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620418sa2ZyO",
                "shape": {
                    "type": "Path",
                    "data": "M57.55,1549.15h0a9,9,0,0,1-5.64-7.63L50,1523.92A296.63,296.63,0,0,1,50,1461l1.87-17.6a9,9,0,0,1,5.64-7.63h0a49.4,49.4,0,0,1,33.24,0h0a9,9,0,0,1,5.64,7.63l1.86,17.41a297.19,297.19,0,0,1,0,62.9l-1.88,17.8a9,9,0,0,1-5.64,7.63h0A49.4,49.4,0,0,1,57.55,1549.15Z"
                },
                "style": {
                    "fill": "#7f7f7f",
                    "strokeWidth": 0
                },
                "width": 51.591827392578125,
                "height": 119.1239013671875,
                "offsetX": 74.12287902832031,
                "offsetY": 1492.4522094726562,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620419Jp7Dj0",
                "shape": {
                    "type": "Path",
                    "data": "M60.82,1540.31h0a7.54,7.54,0,0,1-4.54-6.44L54.78,1519a263.11,263.11,0,0,1,0-53.09l1.5-14.86a7.52,7.52,0,0,1,4.54-6.43h0a37.89,37.89,0,0,1,26.7,0h0a7.52,7.52,0,0,1,4.54,6.43l1.49,14.69a263.2,263.2,0,0,1,0,53.1l-1.52,15a7.52,7.52,0,0,1-4.53,6.44h0A38,38,0,0,1,60.82,1540.31Z"
                },
                "style": {
                    "fill": "#dbdcdd",
                    "strokeWidth": 0
                },
                "width": 41.45502853393555,
                "height": 100.5233154296875,
                "offsetX": 74.16501808166504,
                "offsetY": 1492.4519653320312,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962042050MSNT",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fcfcfc"
                },
                "width": 5.920000076293945,
                "height": 5.920000076293945,
                "offsetX": 75.44000339508057,
                "offsetY": 1456.980019569397,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620421JSJ8nt",
                "shape": {
                    "type": "Path",
                    "data": "M75.44,1460.78a3.8,3.8,0,1,1,3.8-3.8A3.8,3.8,0,0,1,75.44,1460.78Zm0-6.8a3,3,0,1,0,3,3A3,3,0,0,0,75.44,1454Z"
                },
                "style": {
                    "fill": "#707070",
                    "strokeWidth": 0
                },
                "width": 7.600006103515625,
                "height": 7.5999755859375,
                "offsetX": 75.44001007080078,
                "offsetY": 1456.9800415039062,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620422B6LAed",
                "shape": {
                    "type": "Path",
                    "data": "M181.58,1518.51h0a43,43,0,0,1-42.93-40.72,11.14,11.14,0,0,1,.6-4.17v-6.95a2.77,2.77,0,0,1,2.77-2.78h78.49a3.38,3.38,0,0,1,3.38,3.38v6.35a11.14,11.14,0,0,1,.6,4.17A43,43,0,0,1,181.58,1518.51Z"
                },
                "style": {
                    "fill": "#dbdcdd",
                    "strokeWidth": 0
                },
                "width": 85.86500549316406,
                "height": 54.6199951171875,
                "offsetX": 181.56999969482422,
                "offsetY": 1491.2000122070312,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620423xo36Cv",
                "shape": {
                    "type": "Path",
                    "data": "M181.58,1513.44h0c-17.94,0-32.72-11.24-34.77-25.73a11.15,11.15,0,0,1,.77-5.89l.68-1.61a6.9,6.9,0,0,1,6.49-3.85h53.66a6.9,6.9,0,0,1,6.49,3.85l.68,1.61a11.15,11.15,0,0,1,.77,5.89C214.3,1502.2,199.52,1513.44,181.58,1513.44Z"
                },
                "style": {
                    "fill": "#7f7f7f",
                    "strokeWidth": 0
                },
                "width": 69.75709533691406,
                "height": 37.0863037109375,
                "offsetX": 181.58000946044922,
                "offsetY": 1494.8967895507812,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620424hMSbYU",
                "shape": {
                    "type": "Path",
                    "data": "M157,1504.89s23.86-34.61,49,0C206,1504.89,182.45,1523.51,157,1504.89Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 49,
                "height": 23.65771484375,
                "offsetX": 181.5,
                "offsetY": 1501.336669921875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620425UAMthQ",
                "shape": {
                    "type": "Path",
                    "data": "M51.84,1443l5.73,4.34a9,9,0,0,1,5.08-3.38l-2.89-8.93S52.69,1436.28,51.84,1443Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 10.810001373291016,
                "height": 12.31005859375,
                "offsetX": 57.2450008392334,
                "offsetY": 1441.1849365234375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620426mhcyax",
                "shape": {
                    "type": "Path",
                    "data": "M96.44,1443l-5.72,4.34a9,9,0,0,0-5.08-3.38l2.89-8.93S95.6,1436.28,96.44,1443Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 10.800003051757812,
                "height": 12.31005859375,
                "offsetX": 91.04000091552734,
                "offsetY": 1441.1849365234375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620427xkCpTY",
                "shape": {
                    "type": "Path",
                    "data": "M51.9,1542l5.72-4.34A9,9,0,0,0,62.7,1541L59.81,1550S52.74,1548.73,51.9,1542Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 10.799972534179688,
                "height": 12.3399658203125,
                "offsetX": 57.29998779296875,
                "offsetY": 1543.8300170898438,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620428w7Id9a",
                "shape": {
                    "type": "Path",
                    "data": "M96.5,1542l-5.73-4.34a9,9,0,0,1-5.08,3.37l2.89,8.94S95.65,1548.73,96.5,1542Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 10.810020446777344,
                "height": 12.3099365234375,
                "offsetX": 91.09498977661133,
                "offsetY": 1543.8150024414062,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620429LQYWzZ",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 7.599999904632568,
                "height": 7.599999904632568,
                "offsetX": 181.8899962902069,
                "offsetY": 1494.9999511241913,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620430x7tdRA",
                "shape": {
                    "type": "Path",
                    "data": "M181,1466.12h0a3.12,3.12,0,0,1,3.12,3.3l-.91,16.81a2.22,2.22,0,0,1-2.21,2.1h0a2.23,2.23,0,0,1-2.22-2.1l-.91-16.81A3.13,3.13,0,0,1,181,1466.12Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 6.259857177734375,
                "height": 22.210205078125,
                "offsetX": 180.9952850341797,
                "offsetY": 1477.2249755859375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204316LzJPx",
                "shape": {
                    "type": "Path",
                    "data": "M269.19,1523.73v-62.44a4.73,4.73,0,0,1,4.73-4.73h63.82a4.73,4.73,0,0,1,4.73,4.84c-.36,16-6.41,66.29-68.47,67A4.74,4.74,0,0,1,269.19,1523.73Z"
                },
                "style": {
                    "fill": "#dbdcdd",
                    "strokeWidth": 0
                },
                "width": 73.28125,
                "height": 71.840576171875,
                "offsetX": 305.83062744140625,
                "offsetY": 1492.480224609375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620432RjRJm2",
                "shape": {
                    "type": "Path",
                    "data": "M274.26,1516.5v-51a3.86,3.86,0,0,1,3.86-3.86h52.14a3.86,3.86,0,0,1,3.86,3.95c-.29,13.08-5.24,54.18-56,54.78A3.86,3.86,0,0,1,274.26,1516.5Z"
                },
                "style": {
                    "fill": "#7f7f7f",
                    "strokeWidth": 0
                },
                "width": 59.861053466796875,
                "height": 58.72998046875,
                "offsetX": 304.19053649902344,
                "offsetY": 1491.0050048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620433f8dk2n",
                "shape": {
                    "type": "Path",
                    "data": "M274.26,1510.63v-44.78a4.22,4.22,0,0,1,4.23-4.22h43.93S322.42,1498.91,274.26,1510.63Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 48.160003662109375,
                "height": 49.0001220703125,
                "offsetX": 298.3400115966797,
                "offsetY": 1486.1299438476562,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620434fEg0u7",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 5.920000076293945,
                "height": 5.920000076293945,
                "offsetX": 288.63001346588135,
                "offsetY": 1475.1500635147095,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962043540xTnB",
                "shape": {
                    "type": "Path",
                    "data": "M305,1458.5h0a1.94,1.94,0,0,1,1.94,2l-.57,10.44a1.37,1.37,0,0,1-1.37,1.3h0a1.38,1.38,0,0,1-1.38-1.3l-.56-10.44A1.94,1.94,0,0,1,305,1458.5Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 3.881866455078125,
                "height": 13.7401123046875,
                "offsetX": 304.99998474121094,
                "offsetY": 1465.3700561523438,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620436ObMDYr",
                "shape": {
                    "type": "Path",
                    "data": "M437.87,1530.33l-2.95.43a84.21,84.21,0,0,1-24.76,0l-2.94-.43a12.79,12.79,0,0,1-10.12-8.21h0a84.48,84.48,0,0,1-3.65-46l1.21-6.06h55.76l1.22,6.06a84.48,84.48,0,0,1-3.65,46h0A12.81,12.81,0,0,1,437.87,1530.33Z"
                },
                "style": {
                    "fill": "#7f7f7f",
                    "strokeWidth": 0
                },
                "width": 61.47265625,
                "height": 61.614990234375,
                "offsetX": 422.54498291015625,
                "offsetY": 1500.867431640625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620437Pm3WAP",
                "shape": {
                    "type": "Path",
                    "data": "M436.27,1480.11a3.18,3.18,0,0,1,6.35,0"
                },
                "style": {
                    "fill": "#aaa",
                    "strokeWidth": 0
                },
                "width": 6.350006103515625,
                "height": 3.0018310546875,
                "offsetX": 439.4449920654297,
                "offsetY": 1478.6090698242188,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204389kBbrm",
                "shape": {
                    "type": "Path",
                    "data": "M403.4,1480.11a3.18,3.18,0,0,1,6.35,0"
                },
                "style": {
                    "fill": "#aaa",
                    "strokeWidth": 0
                },
                "width": 6.35003662109375,
                "height": 3.001953125,
                "offsetX": 406.57501220703125,
                "offsetY": 1478.6090087890625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620439tuG8Iw",
                "shape": {
                    "type": "Path",
                    "data": "M434.68,1527.94l-2.33.34a66.44,66.44,0,0,1-19.61,0l-2.33-.34a10.17,10.17,0,0,1-8-6.5h0A67,67,0,0,1,399.5,1485l1-4.8h44.17l1,4.8a67,67,0,0,1-2.89,36.42h0A10.17,10.17,0,0,1,434.68,1527.94Z"
                },
                "style": {
                    "fill": "#dbdcdd",
                    "strokeWidth": 0
                },
                "width": 48.756256103515625,
                "height": 48.807373046875,
                "offsetX": 422.58717346191406,
                "offsetY": 1504.6036376953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620440LlhhOL",
                "shape": {
                    "type": "Path",
                    "data": "M455.38,1471.28h0a164.5,164.5,0,0,1-66.52,0h0a4,4,0,0,1-3.2-3.93v-15.27a4,4,0,0,1,4-4h64.9a4,4,0,0,1,4,4v15.27A4,4,0,0,1,455.38,1471.28Z"
                },
                "style": {
                    "fill": "#dbdcdd",
                    "strokeWidth": 0
                },
                "width": 72.9000244140625,
                "height": 26.5975341796875,
                "offsetX": 422.1100158691406,
                "offsetY": 1461.3787231445312,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620441wpB9iB",
                "shape": {
                    "type": "Path",
                    "data": "M398.75,1489.58a66.9,66.9,0,0,0,3.64,31.86,10.17,10.17,0,0,0,8,6.5l2.33.34a66.44,66.44,0,0,0,19.61,0l2.33-.34a10.17,10.17,0,0,0,8-6.5,67,67,0,0,0,3.64-31.85C433.35,1487.55,416.07,1486.34,398.75,1489.58Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 48.645782470703125,
                "height": 41.4281005859375,
                "offsetX": 422.5233917236328,
                "offsetY": 1508.2932739257812,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620442IV2cQf",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 10.979999542236328,
                "height": 10.979999542236328,
                "offsetX": 422.12000465393066,
                "offsetY": 1461.3700046539307,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620443x33aJg",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#7f7f7f"
                },
                "width": 7.599999904632568,
                "height": 7.599999904632568,
                "offsetX": 422.12000727653503,
                "offsetY": 1461.3699462413788,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620444nsz8IZ",
                "shape": {
                    "type": "Path",
                    "data": "M39,1605H157a0,0,0,0,1,0,0v58.26a7.38,7.38,0,0,1-7.37,7.38H46.38a7.38,7.38,0,0,1-7.37-7.37V1605A0,0,0,0,1,39,1605Z"
                },
                "style": {
                    "fill": "#270805",
                    "strokeWidth": 0
                },
                "width": 118,
                "height": 65.6402587890625,
                "offsetX": 98,
                "offsetY": 1637.8201293945312,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620445zGOpew",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#dbdcdd"
                },
                "width": 118,
                "height": 5.769999980926514,
                "offsetX": 98,
                "offsetY": 1607.8849999904633,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620446rxdXkC",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#c2c3c4"
                },
                "width": 118,
                "height": 5.769999980926514,
                "offsetX": 98,
                "offsetY": 1613.6550195217133,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620447KLsSPP",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 32.82
                },
                "style": {
                    "fill": "#dbdcdd"
                },
                "width": 65.63999938964844,
                "height": 35.39999771118164,
                "offsetX": 99.10999298095703,
                "offsetY": 1644.0900135040283,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620448JI2S0b",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 29.87
                },
                "style": {
                    "fill": "#7f7f7f"
                },
                "width": 59.7400016784668,
                "height": 30.98000144958496,
                "offsetX": 99.1099910736084,
                "offsetY": 1644.08997631073,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620449hnjCJr",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fcfcfc"
                },
                "width": 4.740000247955322,
                "height": 4.740000247955322,
                "offsetX": 99.17999768257141,
                "offsetY": 1638.4199268817902,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620450ohxiV8",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 0.74
                },
                "style": {
                    "fill": "#2080ce"
                },
                "width": 5.5,
                "height": 7.769999980926514,
                "offsetX": 147.0800018310547,
                "offsetY": 1645.1149804592133,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204519HRI3C",
                "shape": {
                    "type": "Path",
                    "data": "M98.8,1621.08h0a1.6,1.6,0,0,1,1.6,1.69l-.46,8.61a1.14,1.14,0,0,1-1.14,1.07h0a1.13,1.13,0,0,1-1.13-1.07l-.47-8.61A1.6,1.6,0,0,1,98.8,1621.08Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 3.2050552368164062,
                "height": 11.369873046875,
                "offsetX": 98.80000686645508,
                "offsetY": 1626.764892578125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620452F44BDD",
                "shape": {
                    "type": "Path",
                    "data": "M103.64,1622.93h0a1.6,1.6,0,0,1,1.69-1.6l8.61.47a1.13,1.13,0,0,1,1.08,1.13h0a1.13,1.13,0,0,1-1.08,1.13l-8.61.47A1.6,1.6,0,0,1,103.64,1622.93Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 11.380012512207031,
                "height": 3.2049560546875,
                "offsetX": 109.32999801635742,
                "offsetY": 1622.9301147460938,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620453obI649",
                "shape": {
                    "type": "Path",
                    "data": "M94.25,1622.93h0a1.6,1.6,0,0,0-1.69-1.6l-8.61.47a1.13,1.13,0,0,0-1.08,1.13h0a1.13,1.13,0,0,0,1.08,1.13l8.61.47A1.6,1.6,0,0,0,94.25,1622.93Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 11.380012512207031,
                "height": 3.2049560546875,
                "offsetX": 88.55999374389648,
                "offsetY": 1622.9301147460938,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620454eGRG78",
                "shape": {
                    "type": "Path",
                    "data": "M137.49,1616.53h13.68a0,0,0,0,1,0,0v1.52a.74.74,0,0,1-.74.74H138.22a.74.74,0,0,1-.74-.74v-1.52A0,0,0,0,1,137.49,1616.53Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 13.690017700195312,
                "height": 2.2601318359375,
                "offsetX": 144.32500457763672,
                "offsetY": 1617.6600952148438,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204555M3psa",
                "shape": {
                    "type": "Path",
                    "data": "M46.53,1616.53H60.21a0,0,0,0,1,0,0v1.52a.74.74,0,0,1-.74.74H47.26a.74.74,0,0,1-.74-.74v-1.52A0,0,0,0,1,46.53,1616.53Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 13.690006256103516,
                "height": 2.2601318359375,
                "offsetX": 53.364999771118164,
                "offsetY": 1617.6600952148438,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620456Vfo0gV",
                "shape": {
                    "type": "Path",
                    "data": "M145.06,1649a.73.73,0,0,1-.73-.73V1642a.73.73,0,0,1,.73-.73h4a.74.74,0,0,1,.74.73Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 5.470001220703125,
                "height": 7.72998046875,
                "offsetX": 147.06500244140625,
                "offsetY": 1645.135009765625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620457z975sN",
                "shape": {
                    "type": "Path",
                    "data": "M319,1637v11H208v-11h-6v15a2,2,0,0,0,2,2H323a2,2,0,0,0,2-2v-15Z"
                },
                "style": {
                    "fill": "#270805",
                    "strokeWidth": 0
                },
                "width": 123,
                "height": 17,
                "offsetX": 263.5,
                "offsetY": 1645.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620458PPOtyN",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "url(#linear-gradient-9)"
                },
                "width": 100,
                "height": 13,
                "offsetX": 263,
                "offsetY": 1650.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620459PpWBdy",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#dbdcdd"
                },
                "width": 8,
                "height": 3,
                "offsetX": 322,
                "offsetY": 1635.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620460N1sNA7",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#dbdcdd"
                },
                "width": 8,
                "height": 3,
                "offsetX": 205,
                "offsetY": 1635.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620461yay5Gh",
                "shape": {
                    "type": "Path",
                    "data": "M169.84,801.31h0a0,0,0,0,1,0,0v0a16.5,16.5,0,0,1-16.5,16.5h0a0,0,0,0,1,0,0v0A16.5,16.5,0,0,1,169.84,801.31Z"
                },
                "style": {
                    "fill": "#afb23b",
                    "strokeWidth": 0
                },
                "width": 16.5,
                "height": 16.5,
                "offsetX": 161.58999633789062,
                "offsetY": 809.5599975585938,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620462kJlTUG",
                "shape": {
                    "type": "Path",
                    "data": "M138.31,801.31h0a16.5,16.5,0,0,1,16.5,16.5v0a0,0,0,0,1,0,0h0a16.5,16.5,0,0,1-16.5-16.5v0A0,0,0,0,1,138.31,801.31Z"
                },
                "style": {
                    "fill": "#3d6602",
                    "strokeWidth": 0
                },
                "width": 16.5,
                "height": 16.5,
                "offsetX": 146.55999755859375,
                "offsetY": 809.5599975585938,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620463j0WXGn",
                "shape": {
                    "type": "Path",
                    "data": "M153.35,816.35h0a16.5,16.5,0,0,1,16.5,16.5v0a0,0,0,0,1,0,0h0a16.5,16.5,0,0,1-16.5-16.5v0A0,0,0,0,1,153.35,816.35Z"
                },
                "style": {
                    "fill": "#afb23b",
                    "strokeWidth": 0
                },
                "width": 16.5,
                "height": 16.5,
                "offsetX": 161.60000610351562,
                "offsetY": 824.5999755859375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620464xDbfeK",
                "shape": {
                    "type": "Path",
                    "data": "M154.8,816.35h0a0,0,0,0,1,0,0v0a16.5,16.5,0,0,1-16.5,16.5h0a0,0,0,0,1,0,0v0A16.5,16.5,0,0,1,154.8,816.35Z"
                },
                "style": {
                    "fill": "#3d6602",
                    "strokeWidth": 0
                },
                "width": 16.5,
                "height": 16.5,
                "offsetX": 146.5500030517578,
                "offsetY": 824.5999755859375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620465aRx1k8",
                "shape": {
                    "type": "Path",
                    "data": "M156.32,808.86h0a16.43,16.43,0,0,1,16.43,16.43v0a0,0,0,0,1,0,0h0a16.43,16.43,0,0,1-16.43-16.43v0A0,0,0,0,1,156.32,808.86Z"
                },
                "style": {
                    "fill": "#044f16",
                    "strokeWidth": 0
                },
                "width": 16.42999267578125,
                "height": 16.4300537109375,
                "offsetX": 164.53500366210938,
                "offsetY": 817.074951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620466fXwsbS",
                "shape": {
                    "type": "Path",
                    "data": "M135.4,808.86h0a16.43,16.43,0,0,1,16.43,16.43v0a0,0,0,0,1,0,0h0a16.43,16.43,0,0,1-16.43-16.43v0A0,0,0,0,1,135.4,808.86Z"
                },
                "style": {
                    "fill": "#afb23b",
                    "strokeWidth": 0
                },
                "width": 16.430007934570312,
                "height": 16.4300537109375,
                "offsetX": 143.61499786376953,
                "offsetY": 817.074951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204676CQFMt",
                "shape": {
                    "type": "Path",
                    "data": "M145.86,819.32h0a16.43,16.43,0,0,1,16.43,16.43v0a0,0,0,0,1,0,0h0a16.43,16.43,0,0,1-16.43-16.43v0A0,0,0,0,1,145.86,819.32Z"
                },
                "style": {
                    "fill": "#044f16",
                    "strokeWidth": 0
                },
                "width": 16.430007934570312,
                "height": 16.4300537109375,
                "offsetX": 154.07500457763672,
                "offsetY": 827.5349731445312,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620468cObhCC",
                "shape": {
                    "type": "Path",
                    "data": "M145.86,798.4h0a16.43,16.43,0,0,1,16.43,16.43v0a0,0,0,0,1,0,0h0a16.43,16.43,0,0,1-16.43-16.43v0A0,0,0,0,1,145.86,798.4Z"
                },
                "style": {
                    "fill": "#044f16",
                    "strokeWidth": 0
                },
                "width": 16.430007934570312,
                "height": 16.4300537109375,
                "offsetX": 154.07500457763672,
                "offsetY": 806.614990234375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620470G4RNXJ",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#d1ca43"
                },
                "width": 10.680000305175781,
                "height": 10.680000305175781,
                "offsetX": 154.08000564575195,
                "offsetY": 817.0799903869629,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204715dfw97",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#289"
                },
                "width": 108.04000091552734,
                "height": 108.04000091552734,
                "offsetX": 73.02000045776367,
                "offsetY": 1819.0200004577637,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204720h7z7i7",
                "shape": {
                    "type": "Path",
                    "data": "M 46.35 , 1765 L 46.35 , 1873.04"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 108.0400390625,
                "offsetX": 46.849998474121094,
                "offsetY": 1819.02001953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047213nbePv",
                "shape": {
                    "type": "Path",
                    "data": "M 73.36 , 1765 L 73.36 , 1873.04"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 108.0400390625,
                "offsetX": 73.86000061035156,
                "offsetY": 1819.02001953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204722PFPYk1",
                "shape": {
                    "type": "Path",
                    "data": "M 100.37 , 1765 L 100.37 , 1873.04"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 108.0400390625,
                "offsetX": 100.87000274658203,
                "offsetY": 1819.02001953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204723qrFm32",
                "shape": {
                    "type": "Path",
                    "data": "M 19 , 1846.37 L 127.04 , 1846.37"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 108.04000091552734,
                "height": 1,
                "offsetX": 73.02000045776367,
                "offsetY": 1846.8699951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204724cYRhnB",
                "shape": {
                    "type": "Path",
                    "data": "M 19 , 1819.36 L 127.04 , 1819.36"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 108.04000091552734,
                "height": 1,
                "offsetX": 73.02000045776367,
                "offsetY": 1819.8599853515625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047256hYVjk",
                "shape": {
                    "type": "Path",
                    "data": "M 19 , 1792.35 L 127.04 , 1792.35"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 108.04000091552734,
                "height": 1,
                "offsetX": 73.02000045776367,
                "offsetY": 1792.8499755859375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620473mHFuAR",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#61a03c"
                },
                "width": 108.04000091552734,
                "height": 108.04000091552734,
                "offsetX": 246.27000045776367,
                "offsetY": 1819.0200004577637,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204740uyvXd9",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 212.5,
                "offsetY": 1771.75,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204741SCCyl6",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 239.510009765625,
                "offsetY": 1771.75,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204742aILxGp",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 266.5199890136719,
                "offsetY": 1771.75,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204743XDefpp",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 293.5299987792969,
                "offsetY": 1771.75,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204744iZcb94",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 199,
                "offsetY": 1785.25,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204745YabOea",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 226.010009765625,
                "offsetY": 1785.25,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204746v21IYd",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 253.02000427246094,
                "offsetY": 1785.25,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204747ir9yr8",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 280.0299987792969,
                "offsetY": 1785.25,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204748ykJDnN",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 212.5,
                "offsetY": 1798.7598876953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204749GsjqwQ",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 239.510009765625,
                "offsetY": 1798.7598876953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047410rmooYv",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 266.5199890136719,
                "offsetY": 1798.7598876953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047411LC0vWq",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 293.5299987792969,
                "offsetY": 1798.7598876953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047412DKQU03",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 199,
                "offsetY": 1812.2598876953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047413juJoqD",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 226.010009765625,
                "offsetY": 1812.2598876953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047414TOnywq",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 253.02000427246094,
                "offsetY": 1812.2598876953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047415iAXNoN",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 280.0299987792969,
                "offsetY": 1812.2598876953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047416B9hATp",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 212.5,
                "offsetY": 1825.77001953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047417dmXWGI",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 239.510009765625,
                "offsetY": 1825.77001953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047418EDFSyB",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 266.5199890136719,
                "offsetY": 1825.77001953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047419nUqetc",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 293.5299987792969,
                "offsetY": 1825.77001953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047420XouHLb",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 199,
                "offsetY": 1839.27001953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047421Emqym8",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 226.010009765625,
                "offsetY": 1839.27001953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047422K8Byhk",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 253.02000427246094,
                "offsetY": 1839.27001953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620474236eCynB",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 280.0299987792969,
                "offsetY": 1839.27001953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047424UaFZl0",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 212.5,
                "offsetY": 1852.7799072265625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047425AKweVl",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 239.510009765625,
                "offsetY": 1852.7799072265625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047426ootyKu",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 266.5199890136719,
                "offsetY": 1852.7799072265625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047427q33Er9",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 293.5299987792969,
                "offsetY": 1852.7799072265625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047428h4sdyG",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 199,
                "offsetY": 1866.2799072265625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047429YCNpHu",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 226.010009765625,
                "offsetY": 1866.2799072265625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047430J8hHer",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 253.02000427246094,
                "offsetY": 1866.2799072265625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047431JIDLLK",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.5,
                "height": 13.5,
                "offsetX": 280.0299987792969,
                "offsetY": 1866.2799072265625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620475ArJjZc",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#2260ba"
                },
                "width": 107.91000366210938,
                "height": 107.91000366210938,
                "offsetX": 404.2749786376953,
                "offsetY": 1821.0449676513672,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204760ihdizR",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 370.5550284385681,
                "offsetY": 1773.8349661827087,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047613e5RdC",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 397.5350089073181,
                "offsetY": 1773.8349661827087,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204762wN8ALY",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 424.51501989364624,
                "offsetY": 1773.8349661827087,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204763bAfDbX",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 357.06497716903687,
                "offsetY": 1787.3250784873962,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047646xdm0K",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 451.48499059677124,
                "offsetY": 1773.8349661827087,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204765o0CnlD",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 384.0450186729431,
                "offsetY": 1787.3250784873962,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204766i3Ym4t",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 411.0249991416931,
                "offsetY": 1787.3250784873962,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204767pm7ZB0",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 437.99500036239624,
                "offsetY": 1787.3250784873962,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204768EjwwuU",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 370.5550284385681,
                "offsetY": 1800.8149466514587,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047692KX96t",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 397.5350089073181,
                "offsetY": 1800.8149466514587,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047610y4YP2r",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 424.51501989364624,
                "offsetY": 1800.8149466514587,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047611ixNWCX",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 451.48499059677124,
                "offsetY": 1800.8149466514587,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047612TVdM74",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 357.06497716903687,
                "offsetY": 1814.3050589561462,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047613qce4EQ",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 384.0450186729431,
                "offsetY": 1814.3050589561462,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047614lg2I7h",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 411.0249991416931,
                "offsetY": 1814.3050589561462,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047615nOiHV6",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 437.99500036239624,
                "offsetY": 1814.3050589561462,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047616O3w6rD",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 370.5550284385681,
                "offsetY": 1827.7949271202087,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047617IHzRYb",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 397.5350089073181,
                "offsetY": 1827.7949271202087,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047618R738ZI",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 424.51501989364624,
                "offsetY": 1827.7949271202087,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047619bm1qwy",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 451.48499059677124,
                "offsetY": 1827.7949271202087,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047620SsmhqV",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 357.06497716903687,
                "offsetY": 1841.2749075889587,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047621vtaxRJ",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 384.0450186729431,
                "offsetY": 1841.2749075889587,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047622IK5ALX",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 411.0249991416931,
                "offsetY": 1841.2749075889587,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047623nyLqZX",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 437.99500036239624,
                "offsetY": 1841.2749075889587,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047624Gdf1EV",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 370.5550284385681,
                "offsetY": 1854.7650198936462,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047625uPbgAV",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 397.5350089073181,
                "offsetY": 1854.7650198936462,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047626XazHUT",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 424.51501989364624,
                "offsetY": 1854.7650198936462,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620476277T8Var",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 451.48499059677124,
                "offsetY": 1854.7650198936462,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047628saNXkO",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 357.06497716903687,
                "offsetY": 1868.2548880577087,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047629rXV9dz",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 384.0450186729431,
                "offsetY": 1868.2548880577087,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047630SFhd72",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 411.0249991416931,
                "offsetY": 1868.2548880577087,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047631gFKq24",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13.49000072479248,
                "height": 13.49000072479248,
                "offsetX": 437.99500036239624,
                "offsetY": 1868.2548880577087,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204770dzPA8m",
                "shape": {
                    "type": "Path",
                    "data": "M 363.91 , 1861.51 L 363.91 , 1875"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 364.4100036621094,
                "offsetY": 1868.2550048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047714lJ5bh",
                "shape": {
                    "type": "Path",
                    "data": "M 350.32 , 1780.58 L 458.23 , 1780.58"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 107.91000366210938,
                "height": 1,
                "offsetX": 404.27500915527344,
                "offsetY": 1781.0799560546875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204772cK6dAV",
                "shape": {
                    "type": "Path",
                    "data": "M 350.32 , 1794.07 L 458.23 , 1794.07"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 107.91000366210938,
                "height": 1,
                "offsetX": 404.27500915527344,
                "offsetY": 1794.5699462890625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204773hRrDaq",
                "shape": {
                    "type": "Path",
                    "data": "M 350.32 , 1807.56 L 458.23 , 1807.56"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 107.91000366210938,
                "height": 1,
                "offsetX": 404.27500915527344,
                "offsetY": 1808.06005859375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204774STp6De",
                "shape": {
                    "type": "Path",
                    "data": "M 350.32 , 1821.05 L 458.23 , 1821.05"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 107.91000366210938,
                "height": 1,
                "offsetX": 404.27500915527344,
                "offsetY": 1821.550048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204775AWFXzp",
                "shape": {
                    "type": "Path",
                    "data": "M 350.32 , 1834.53 L 458.23 , 1834.53"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 107.91000366210938,
                "height": 1,
                "offsetX": 404.27500915527344,
                "offsetY": 1835.030029296875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204776gDJ9Xg",
                "shape": {
                    "type": "Path",
                    "data": "M 350.32 , 1848.02 L 458.23 , 1848.02"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 107.91000366210938,
                "height": 1,
                "offsetX": 404.27500915527344,
                "offsetY": 1848.52001953125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204777vAdxlB",
                "shape": {
                    "type": "Path",
                    "data": "M 350.32 , 1861.51 L 458.23 , 1861.51"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 107.91000366210938,
                "height": 1,
                "offsetX": 404.27500915527344,
                "offsetY": 1862.010009765625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047785C7VEm",
                "shape": {
                    "type": "Path",
                    "data": "M 377.4 , 1767.09 L 377.4 , 1780.58"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 377.8999938964844,
                "offsetY": 1773.8349609375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204779zEXnyx",
                "shape": {
                    "type": "Path",
                    "data": "M 404.38 , 1767.09 L 404.38 , 1780.58"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 404.8800048828125,
                "offsetY": 1773.8349609375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047710Lo96hs",
                "shape": {
                    "type": "Path",
                    "data": "M 431.35 , 1767.09 L 431.35 , 1780.58"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 431.8500061035156,
                "offsetY": 1773.8349609375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047711hXt2Vv",
                "shape": {
                    "type": "Path",
                    "data": "M 363.91 , 1780.58 L 363.91 , 1794.07"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 364.4100036621094,
                "offsetY": 1787.324951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047712vQrd8m",
                "shape": {
                    "type": "Path",
                    "data": "M 390.89 , 1780.58 L 390.89 , 1794.07"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 391.3900146484375,
                "offsetY": 1787.324951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047713N6Tqmw",
                "shape": {
                    "type": "Path",
                    "data": "M 417.87 , 1780.58 L 417.87 , 1794.07"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 418.3699951171875,
                "offsetY": 1787.324951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047714gtJEQW",
                "shape": {
                    "type": "Path",
                    "data": "M 444.84 , 1780.58 L 444.84 , 1794.07"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 445.3399963378906,
                "offsetY": 1787.324951171875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047715PuyJVC",
                "shape": {
                    "type": "Path",
                    "data": "M 377.4 , 1794.07 L 377.4 , 1807.56"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.4901123046875,
                "offsetX": 377.8999938964844,
                "offsetY": 1800.8150024414062,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047716iIDuRi",
                "shape": {
                    "type": "Path",
                    "data": "M 404.38 , 1794.07 L 404.38 , 1807.56"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.4901123046875,
                "offsetX": 404.8800048828125,
                "offsetY": 1800.8150024414062,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204771774dFTj",
                "shape": {
                    "type": "Path",
                    "data": "M 431.35 , 1794.07 L 431.35 , 1807.56"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.4901123046875,
                "offsetX": 431.8500061035156,
                "offsetY": 1800.8150024414062,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047718SluiLd",
                "shape": {
                    "type": "Path",
                    "data": "M 363.91 , 1807.56 L 363.91 , 1821.05"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 364.4100036621094,
                "offsetY": 1814.3050537109375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047719AkTymx",
                "shape": {
                    "type": "Path",
                    "data": "M 390.89 , 1807.56 L 390.89 , 1821.05"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 391.3900146484375,
                "offsetY": 1814.3050537109375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047720vFVpM1",
                "shape": {
                    "type": "Path",
                    "data": "M 417.87 , 1807.56 L 417.87 , 1821.05"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 418.3699951171875,
                "offsetY": 1814.3050537109375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047721TXqf35",
                "shape": {
                    "type": "Path",
                    "data": "M 444.84 , 1807.56 L 444.84 , 1821.05"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 445.3399963378906,
                "offsetY": 1814.3050537109375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047722hAmBV6",
                "shape": {
                    "type": "Path",
                    "data": "M 377.4 , 1821.05 L 377.4 , 1834.53"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.47998046875,
                "offsetX": 377.8999938964844,
                "offsetY": 1827.7900390625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047723JX7L6k",
                "shape": {
                    "type": "Path",
                    "data": "M 404.38 , 1821.05 L 404.38 , 1834.53"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.47998046875,
                "offsetX": 404.8800048828125,
                "offsetY": 1827.7900390625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047724HozBwH",
                "shape": {
                    "type": "Path",
                    "data": "M 431.35 , 1821.05 L 431.35 , 1834.53"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.47998046875,
                "offsetX": 431.8500061035156,
                "offsetY": 1827.7900390625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047725pYVK4h",
                "shape": {
                    "type": "Path",
                    "data": "M 363.91 , 1834.53 L 363.91 , 1848.02"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 364.4100036621094,
                "offsetY": 1841.2750244140625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047726kdWhWI",
                "shape": {
                    "type": "Path",
                    "data": "M 390.89 , 1834.53 L 390.89 , 1848.02"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 391.3900146484375,
                "offsetY": 1841.2750244140625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96204772755QWVy",
                "shape": {
                    "type": "Path",
                    "data": "M 417.87 , 1834.53 L 417.87 , 1848.02"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 418.3699951171875,
                "offsetY": 1841.2750244140625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047728GD4i6C",
                "shape": {
                    "type": "Path",
                    "data": "M 444.84 , 1834.53 L 444.84 , 1848.02"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 445.3399963378906,
                "offsetY": 1841.2750244140625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047729FPvQkG",
                "shape": {
                    "type": "Path",
                    "data": "M 377.4 , 1848.02 L 377.4 , 1861.51"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 377.8999938964844,
                "offsetY": 1854.7650146484375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047730em8Sfd",
                "shape": {
                    "type": "Path",
                    "data": "M 404.38 , 1848.02 L 404.38 , 1861.51"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 404.8800048828125,
                "offsetY": 1854.7650146484375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047731MPC7HF",
                "shape": {
                    "type": "Path",
                    "data": "M 431.35 , 1848.02 L 431.35 , 1861.51"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 431.8500061035156,
                "offsetY": 1854.7650146484375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard9620477326E1o9Q",
                "shape": {
                    "type": "Path",
                    "data": "M 390.89 , 1861.51 L 390.89 , 1875"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 391.3900146484375,
                "offsetY": 1868.2550048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047733d3moVF",
                "shape": {
                    "type": "Path",
                    "data": "M 417.87 , 1861.51 L 417.87 , 1875"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 418.3699951171875,
                "offsetY": 1868.2550048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard962047734G7p7iX",
                "shape": {
                    "type": "Path",
                    "data": "M 444.84 , 1861.51 L 444.84 , 1875"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 13.489990234375,
                "offsetX": 445.3399963378906,
                "offsetY": 1868.2550048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Artboard96",
                "children": ["Artboard96200iZDjCQ", "Artboard96201SNRs2d", "Artboard96202z1TvRU", "Artboard962034HyXHU", "Artboard96204yiq8vH", "Artboard96205gt2kyV", "Artboard96206ziGm9D", "Artboard962073KiKTM", "Artboard96208Qo1qWp", "Artboard96209v2RpAZ", "Artboard962010mx4Go3", "Artboard962011Gmn478", "Artboard962012dpQYJ8", "Artboard962013bmOIJE", "Artboard962014MmVQFx", "Artboard9620154TllUm", "Artboard962016wiRCDb", "Artboard9620178N4Ebc", "Artboard962018CZ8CAc", "Artboard962019qcRxqv", "Artboard962020L2F2up", "Artboard962021Kjn7G3", "Artboard962022Otbuay", "Artboard962023M8DeX6", "Artboard962024T5X6g4", "Artboard962025XMSIYx", "Artboard962026yl5ydP", "Artboard962027srWUy6", "Artboard962028d3zxbO", "Artboard962029qpxXn9", "Artboard962030ORVLeK", "Artboard962031Jymwap", "Artboard962032ms8kYQ", "Artboard962033LrXN24", "Artboard962034GLJDsu", "Artboard962035F5KivE", "Artboard962036TheFvq", "Artboard962037fBpETg", "Artboard962038H4eNMd", "Artboard962039TpBB3s", "Artboard962040JWRQgv", "Artboard962041JWInEv", "Artboard962042RP8UTz", "Artboard9620436WsSlc", "Artboard962044weH4bg", "Artboard962045isavtl", "Artboard962046LGjRgq", "Artboard962047VP8pbC", "Artboard962048SkLSqQ", "Artboard962049QNTFnv", "Artboard9620502LMhwe", "Artboard962051rOcpkE", "Artboard9620525aeDuF", "Artboard962053dO7KFd", "Artboard962054NZgs9k", "Artboard962055rVvGTj", "Artboard962056qmBNrw", "Artboard962057FkTGFe", "Artboard962058o5lGqt", "Artboard962059KK9FAH", "Artboard9620604ryNJf", "Artboard962061elwdXr", "Artboard962062yFkYoF", "Artboard962063VGau5n", "Artboard962064UKc5CI", "Artboard962065egus4B", "Artboard962066i6ZyjJ", "Artboard962067gJt5VC", "Artboard962068kphZ3C", "Artboard962069EK27sE", "Artboard962070xRPN1q", "Artboard962071NagQ7V", "Artboard962072psLZKX", "Artboard9620730kLWOi", "Artboard962074P0GIfn", "Artboard962075q7FORE", "Artboard962076pMg6xF", "Artboard962077PJ36qO", "Artboard962078sEk7qe", "Artboard962079Y2FSRV", "Artboard962080i42UEN", "Artboard962081oBNq2R", "Artboard962082xrS6c9", "Artboard962083uHGcMY", "Artboard962084zivYKX", "Artboard962085hwfkho", "Artboard962086DnmLcW", "Artboard962087yPH0Dr", "Artboard962088XXINhR", "Artboard962089ndhmWY", "Artboard9620901Rt54V", "Artboard962091DtDfyt", "Artboard962092kLKeOD", "Artboard962093uy2HBZ", "Artboard962094o30Rdg", "Artboard9620955PL4Jr", "Artboard962096uw558J", "Artboard962097Da2HCF", "Artboard9620982kzi7X", "Artboard962099FPFodq", "Artboard9620100L9ESaY", "Artboard9620101kp4nY6", "Artboard9620102ESWDlG", "Artboard96201032AZdLJ", "Artboard9620104NCkAEN", "Artboard9620105gpAmjA", "Artboard9620106TUcITH", "Artboard9620107gxp5mz", "Artboard9620109vpsaDg", "Artboard9620110MVHknA", "Artboard9620111Qv3GyO", "Artboard9620112zC1y40", "Artboard9620113Mkt4CI", "Artboard9620114rfG3ky", "Artboard9620115xBerD1", "Artboard9620116v58jzw", "Artboard96201179bOiDu", "Artboard9620118X1dzqz", "Artboard9620119GNse0c", "Artboard9620120AFj3Lz", "Artboard9620121dCuAlO", "Artboard96201220ZBRhr", "Artboard9620123mqP3kW", "Artboard9620124QI0tKV", "Artboard9620125leCTRn", "Artboard96201263fnFG1", "Artboard9620127eerptl", "Artboard9620128WUzj87", "Artboard9620129AvYUUF", "Artboard9620130EeQe2n", "Artboard9620131JvgUWQ", "Artboard9620132ssPAkV", "Artboard9620133MmDjZg", "Artboard9620134Kpevp2", "Artboard9620135AKkDMD", "Artboard9620136w4AYvk", "Artboard9620137BdzwNX", "Artboard9620138L7i1ky", "Artboard9620139Se95VG", "Artboard9620140C48N3l", "Artboard9620141cRoicr", "Artboard9620143jI2HOt", "Artboard9620144Bv58NO", "Artboard9620145fR87VQ", "Artboard9620146bG0cKE", "Artboard96201474u6hdg", "Artboard9620148JuvI5j", "Artboard9620149D4HEUH", "Artboard96201503V7oTR", "Artboard9620151NXYERq", "Artboard9620152GyVqxM", "Artboard9620153V8ROM7", "Artboard9620154gewgDd", "Artboard9620155h5FwMQ", "Artboard9620156LNgcow", "Artboard9620157na9FvG", "Artboard9620158Zn6hyD", "Artboard9620159Wn19lQ", "Artboard9620160nwQ4Ye", "Artboard9620161NONr37", "Artboard9620162tvDwT8", "Artboard9620163R9hpSW", "Artboard9620164i0VftP", "Artboard96201659EaB3a", "Artboard9620166Jx2oYn", "Artboard9620167B4VbEy", "Artboard9620168VeIJAN", "Artboard9620169qRZ1E8", "Artboard9620170Ns9Q0f", "Artboard96201712H05QA", "Artboard9620172oz1PV7", "Artboard96201732LmNkK", "Artboard9620175cy2GxP", "Artboard9620176vNDgJP", "Artboard9620184ZnshDS", "Artboard9620185uAEugT", "Artboard9620186TPPwRz", "Artboard96201870ZkMhh", "Artboard9620188J8se01", "Artboard9620189tIig06", "Artboard96201908qpIQT", "Artboard9620191URCFz5", "Artboard9620192PJdWvo", "Artboard9620193gOGnkD", "Artboard9620194r2KTtR", "Artboard96201953s0bLl", "Artboard9620196BwFC7G", "Artboard9620197i7FcXV", "Artboard9620198bzLn1c", "Artboard9620199ncspcl", "Artboard9620200ihxicq", "Artboard9620201O37sqU", "Artboard9620202NpGFvz", "Artboard9620203eUHj33", "Artboard96202048LdJhB", "Artboard9620205db0lc2", "Artboard9620206AmcX1F", "Artboard9620207gbB1pQ", "Artboard9620208xtR99e", "Artboard9620209wWfBUZ", "Artboard9620211rp495d", "Artboard9620212WsObj1", "Artboard9620213gvLGGB", "Artboard962021420m44Y", "Artboard9620215G83NpD", "Artboard9620216w5M5Aw", "Artboard9620217GQK0RO", "Artboard9620218mp4eSr", "Artboard9620219s3nLZX", "Artboard9620220KAKg49", "Artboard9620221KdphPN", "Artboard96202226g0RcW", "Artboard9620223lSJWB7", "Artboard9620224TPUblO", "Artboard9620225V3ZNhG", "Artboard9620226GTZ7nv", "Artboard9620227UXXfvj", "Artboard9620228qHUgy4", "Artboard9620229uFx1De", "Artboard9620230dnnLXO", "Artboard96202319pTZ7h", "Artboard9620232LEUrtR", "Artboard962023395b3oC", "Artboard96202340HABAT", "Artboard9620235HKssUe", "Artboard9620236eQKOFU", "Artboard9620237r8mF1r", "Artboard9620238gNVbZf", "Artboard9620239KSU5RZ", "Artboard9620240dGTKpq", "Artboard9620241qjDtsB", "Artboard9620242NJrTCM", "Artboard96202437Sywn1", "Artboard9620244Od2NZ2", "Artboard9620245M8TQHF", "Artboard96202462PTvKI", "Artboard96202478uaZyO", "Artboard9620248ur9l2E", "Artboard9620249faRVc1", "Artboard9620250SJOBEG", "Artboard9620251NFlC2i", "Artboard96202520DxkEah", "Artboard9620253Dujcor", "Artboard9620254Qjbg4m", "Artboard9620255Brhaz8", "Artboard96202569KS3fw", "Artboard9620257IIzuFT", "Artboard9620258bShrha", "Artboard9620260Bfr0p9", "Artboard96202617ClESt", "Artboard9620262RnUFPk", "Artboard9620263gDpyvp", "Artboard9620264Cv7Z20", "Artboard9620265SRL74M", "Artboard9620266HGelgf", "Artboard9620267idXoZx", "Artboard96202680rirKGG", "Artboard9620269gm3W0Q", "Artboard9620270gwzR9p", "Artboard9620271sngFD4", "Artboard9620272u6liBY", "Artboard9620274sMAWvM", "Artboard9620275Sx4LW4", "Artboard9620276Y67XY0", "Artboard9620277qzFcDg", "Artboard9620278N708Lj", "Artboard9620279MS82xC", "Artboard9620280uD4d2n", "Artboard9620281mmw6wz", "Artboard9620282b3D2Wl", "Artboard9620284Bt15I5", "Artboard9620285Sbhwj6", "Artboard9620286tYHApb", "Artboard9620287Fm2hZ4", "Artboard9620288jrv3WW", "Artboard96202890HbYp0", "Artboard9620290QwsiiW", "Artboard9620291o320gk", "Artboard96202926ihT26", "Artboard9620293KCaIiy", "Artboard9620294e5rkmR", "Artboard9620295ObPWWE", "Artboard96202967dEPbV", "Artboard9620297tWqG1o", "Artboard9620298COpECP", "Artboard9620299X7BIla", "Artboard9620300ydRnvn", "Artboard96203011i1xhq", "Artboard9620302omAMFk", "Artboard9620303AUI22o", "Artboard9620304XtWFSL", "Artboard96203050J7N4IR", "Artboard96203051Cj32E2", "Artboard96203060kdNNTX", "Artboard96203061ttc0ln", "Artboard96203070NIIHoD", "Artboard96203071Vysont", "Artboard96203080vg7PWe", "Artboard96203081NpWnpY", "Artboard9620309L4AswZ", "Artboard96203101heIyV", "Artboard9620311Fyn27R", "Artboard9620312y9yPdM", "Artboard9620313ScExI9", "Artboard9620314MM9zTg", "Artboard96203153BoCU3", "Artboard9620316MfZCpm", "Artboard9620317iG9MEP", "Artboard962031893eywv", "Artboard9620319FKlJQt", "Artboard9620320zWqZPx", "Artboard96203216Tl8eY", "Artboard9620322I4kJW2", "Artboard9620323dQST5x", "Artboard9620324GcpROE", "Artboard9620325KsSLnw", "Artboard96203260EkULA", "Artboard9620327m0CBO4", "Artboard9620328s0YfYe", "Artboard96203298LgLEn", "Artboard9620330PdQH94", "Artboard9620331QoR7fo", "Artboard9620332qgVLMl", "Artboard9620333jVgYZE", "Artboard9620334X90Itz", "Artboard9620335yJWGzQ", "Artboard9620336sE9OFe", "Artboard9620337ryww8c", "Artboard9620338H96GON", "Artboard9620339QryCaX", "Artboard9620340lpryYV", "Artboard9620341r0xv5J", "Artboard9620342lRFahl", "Artboard9620343xo9zBh", "Artboard9620344iPlEA6", "Artboard9620345VDXsap", "Artboard9620346FYrK3D", "Artboard962034700qHXXY5", "Artboard962034701mdiErc", "Artboard962034702KYZouE", "Artboard962034703iPky8C", "Artboard962034704m3f4YK", "Artboard962034705bWa4L2", "Artboard9620348ALymNE", "Artboard9620349IMvpkR", "Artboard96203501vzcmR", "Artboard9620351WvQ2cX", "Artboard9620352iAyolE", "Artboard96203530IdGdt", "Artboard9620354Tkjdi0", "Artboard9620355zHVH2p", "Artboard96203562xR5Nv", "Artboard9620357WUiXBH", "Artboard9620358lK886k", "Artboard9620359plzIqe", "Artboard96203605oC09g", "Artboard9620361yM9oYE", "Artboard9620362y8QZ4g", "Artboard9620363305oKU", "Artboard96203642NyaZk", "Artboard9620365zCGDJE", "Artboard962036647vlJw", "Artboard9620367sjRlse", "Artboard96203685jQPzK", "Artboard9620369xzk1ky", "Artboard9620370K0I2AG", "Artboard9620371wixj47", "Artboard9620372Ak931d", "Artboard9620373X3jnVt", "Artboard96203745eRoGR", "Artboard9620375KjhHd5", "Artboard9620376ChAnQs", "Artboard962037774wakO", "Artboard9620378QQoYhv", "Artboard9620379tBebXW", "Artboard9620380sJJXXs", "Artboard9620381Lgc1bg", "Artboard9620382tUnXde", "Artboard962038324wyHx", "Artboard962038415m5AR", "Artboard9620385EF1Xk4", "Artboard96203862ERkCy", "Artboard96203873HotMn", "Artboard96203880gVTp8", "Artboard962038971UBuk", "Artboard9620390JDi5q8", "Artboard9620391XrwGdq", "Artboard9620392OlF7vH", "Artboard9620393XR3wnL", "Artboard9620394yUNWST", "Artboard9620395e1j9TI", "Artboard9620396CScmI1", "Artboard9620397X3xYBK", "Artboard9620398WUVRtx", "Artboard9620399WY45vL", "Artboard9620400zlPfS6", "Artboard9620401WEhsXo", "Artboard9620402yEa7Nw", "Artboard9620403F1kVuB", "Artboard9620404IFsQ0B", "Artboard9620405pl026b", "Artboard9620406I0jixA", "Artboard962040708TdTti", "Artboard96204071fs6qVk", "Artboard96204072KxTfnD", "Artboard96204073c5pzsm", "Artboard96204074PK59fG", "Artboard96204075nRzPHr", "Artboard96204076XXtNDF", "Artboard962040772yOupT", "Artboard96204078hhwDjr", "Artboard96204079QfufhA", "Artboard962040710Cqm59f", "Artboard9620408oLPYNw", "Artboard9620409yfwxTd", "Artboard9620410YdJ7px", "Artboard9620411RkNRuF", "Artboard9620412PrTRLN", "Artboard96204137BvrUX", "Artboard9620414XR3LgA", "Artboard9620415Lq3r2h", "Artboard9620416TlVfG2", "Artboard9620417LpugGD", "Artboard9620418sa2ZyO", "Artboard9620419Jp7Dj0", "Artboard962042050MSNT", "Artboard9620421JSJ8nt", "Artboard9620422B6LAed", "Artboard9620423xo36Cv", "Artboard9620424hMSbYU", "Artboard9620425UAMthQ", "Artboard9620426mhcyax", "Artboard9620427xkCpTY", "Artboard9620428w7Id9a", "Artboard9620429LQYWzZ", "Artboard9620430x7tdRA", "Artboard96204316LzJPx", "Artboard9620432RjRJm2", "Artboard9620433f8dk2n", "Artboard9620434fEg0u7", "Artboard962043540xTnB", "Artboard9620436ObMDYr", "Artboard9620437Pm3WAP", "Artboard96204389kBbrm", "Artboard9620439tuG8Iw", "Artboard9620440LlhhOL", "Artboard9620441wpB9iB", "Artboard9620442IV2cQf", "Artboard9620443x33aJg", "Artboard9620444nsz8IZ", "Artboard9620445zGOpew", "Artboard9620446rxdXkC", "Artboard9620447KLsSPP", "Artboard9620448JI2S0b", "Artboard9620449hnjCJr", "Artboard9620450ohxiV8", "Artboard96204519HRI3C", "Artboard9620452F44BDD", "Artboard9620453obI649", "Artboard9620454eGRG78", "Artboard96204555M3psa", "Artboard9620456Vfo0gV", "Artboard9620457z975sN", "Artboard9620458PPOtyN", "Artboard9620459PpWBdy", "Artboard9620460N1sNA7", "Artboard9620461yay5Gh", "Artboard9620462kJlTUG", "Artboard9620463j0WXGn", "Artboard9620464xDbfeK", "Artboard9620465aRx1k8", "Artboard9620466fXwsbS", "Artboard96204676CQFMt", "Artboard9620468cObhCC", "Artboard9620470G4RNXJ", "Artboard96204715dfw97", "Artboard96204720h7z7i7", "Artboard962047213nbePv", "Artboard96204722PFPYk1", "Artboard96204723qrFm32", "Artboard96204724cYRhnB", "Artboard962047256hYVjk", "Artboard9620473mHFuAR", "Artboard96204740uyvXd9", "Artboard96204741SCCyl6", "Artboard96204742aILxGp", "Artboard96204743XDefpp", "Artboard96204744iZcb94", "Artboard96204745YabOea", "Artboard96204746v21IYd", "Artboard96204747ir9yr8", "Artboard96204748ykJDnN", "Artboard96204749GsjqwQ", "Artboard962047410rmooYv", "Artboard962047411LC0vWq", "Artboard962047412DKQU03", "Artboard962047413juJoqD", "Artboard962047414TOnywq", "Artboard962047415iAXNoN", "Artboard962047416B9hATp", "Artboard962047417dmXWGI", "Artboard962047418EDFSyB", "Artboard962047419nUqetc", "Artboard962047420XouHLb", "Artboard962047421Emqym8", "Artboard962047422K8Byhk", "Artboard9620474236eCynB", "Artboard962047424UaFZl0", "Artboard962047425AKweVl", "Artboard962047426ootyKu", "Artboard962047427q33Er9", "Artboard962047428h4sdyG", "Artboard962047429YCNpHu", "Artboard962047430J8hHer", "Artboard962047431JIDLLK", "Artboard9620475ArJjZc", "Artboard96204760ihdizR", "Artboard962047613e5RdC", "Artboard96204762wN8ALY", "Artboard96204763bAfDbX", "Artboard962047646xdm0K", "Artboard96204765o0CnlD", "Artboard96204766i3Ym4t", "Artboard96204767pm7ZB0", "Artboard96204768EjwwuU", "Artboard962047692KX96t", "Artboard962047610y4YP2r", "Artboard962047611ixNWCX", "Artboard962047612TVdM74", "Artboard962047613qce4EQ", "Artboard962047614lg2I7h", "Artboard962047615nOiHV6", "Artboard962047616O3w6rD", "Artboard962047617IHzRYb", "Artboard962047618R738ZI", "Artboard962047619bm1qwy", "Artboard962047620SsmhqV", "Artboard962047621vtaxRJ", "Artboard962047622IK5ALX", "Artboard962047623nyLqZX", "Artboard962047624Gdf1EV", "Artboard962047625uPbgAV", "Artboard962047626XazHUT", "Artboard9620476277T8Var", "Artboard962047628saNXkO", "Artboard962047629rXV9dz", "Artboard962047630SFhd72", "Artboard962047631gFKq24", "Artboard96204770dzPA8m", "Artboard962047714lJ5bh", "Artboard96204772cK6dAV", "Artboard96204773hRrDaq", "Artboard96204774STp6De", "Artboard96204775AWFXzp", "Artboard96204776gDJ9Xg", "Artboard96204777vAdxlB", "Artboard962047785C7VEm", "Artboard96204779zEXnyx", "Artboard962047710Lo96hs", "Artboard962047711hXt2Vv", "Artboard962047712vQrd8m", "Artboard962047713N6Tqmw", "Artboard962047714gtJEQW", "Artboard962047715PuyJVC", "Artboard962047716iIDuRi", "Artboard96204771774dFTj", "Artboard962047718SluiLd", "Artboard962047719AkTymx", "Artboard962047720vFVpM1", "Artboard962047721TXqf35", "Artboard962047722hAmBV6", "Artboard962047723JX7L6k", "Artboard962047724HozBwH", "Artboard962047725pYVK4h", "Artboard962047726kdWhWI", "Artboard96204772755QWVy", "Artboard962047728GD4i6C", "Artboard962047729FPvQkG", "Artboard962047730em8Sfd", "Artboard962047731MPC7HF", "Artboard9620477326E1o9Q", "Artboard962047733d3moVF", "Artboard962047734G7p7iX"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "BathroomTiles2XXzxlC",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#289"
                },
                "width": 160,
                "height": 160,
                "offsetX": 80,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "BathroomTiles30YlZk9q",
                "shape": {
                    "type": "Path",
                    "data": "M 40.5 , 0 L 40.5 , 160"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 160,
                "offsetX": 41,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "BathroomTiles31FJgKkH",
                "shape": {
                    "type": "Path",
                    "data": "M 80.5 , 0 L 80.5 , 160"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 160,
                "offsetX": 81,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "BathroomTiles32Voclvx",
                "shape": {
                    "type": "Path",
                    "data": "M 120.5 , 0 L 120.5 , 160"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 160,
                "offsetX": 121,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "BathroomTiles337bukNL",
                "shape": {
                    "type": "Path",
                    "data": "M 0 , 120.5 L 160 , 120.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 160,
                "height": 1,
                "offsetX": 80,
                "offsetY": 121,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "BathroomTiles349NRjw3",
                "shape": {
                    "type": "Path",
                    "data": "M 0 , 80.5 L 160 , 80.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 160,
                "height": 1,
                "offsetX": 80,
                "offsetY": 81,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "BathroomTiles35soihGp",
                "shape": {
                    "type": "Path",
                    "data": "M 0 , 40.5 L 160 , 40.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 160,
                "height": 1,
                "offsetX": 80,
                "offsetY": 41,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "BathroomTiles",
                "children": ["BathroomTiles2XXzxlC", "BathroomTiles30YlZk9q", "BathroomTiles31FJgKkH", "BathroomTiles32Voclvx", "BathroomTiles337bukNL", "BathroomTiles349NRjw3", "BathroomTiles35soihGp"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "BathtoomHanger2dUQ16T",
                "shape": {
                    "type": "Path",
                    "data": "M140,64V75H29V64H23V79a2,2,0,0,0,2,2H144a2,2,0,0,0,2-2V64Z"
                },
                "style": {
                    "fill": "#270805",
                    "strokeWidth": 0
                },
                "width": 123,
                "height": 17,
                "offsetX": 84.5,
                "offsetY": 72.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "BathtoomHanger3jrX2tq",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "url(#linear-gradient)"
                },
                "width": 100,
                "height": 13,
                "offsetX": 84,
                "offsetY": 77.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "BathtoomHanger4lHZg8b",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#dbdcdd"
                },
                "width": 8,
                "height": 3,
                "offsetX": 143,
                "offsetY": 62.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "BathtoomHanger5SIlbPN",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#dbdcdd"
                },
                "width": 8,
                "height": 3,
                "offsetX": 26,
                "offsetY": 62.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "BathtoomHanger",
                "children": ["BathtoomHanger2dUQ16T", "BathtoomHanger3jrX2tq", "BathtoomHanger4lHZg8b", "BathtoomHanger5SIlbPN"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Bathtub2fk4M08",
                "shape": {
                    "type": "Path",
                    "data": "M55.8,155.32h0a11.9,11.9,0,0,1-8.22-9.93l-2.73-22.93a346.43,346.43,0,0,1,0-81.92l2.73-22.93A11.9,11.9,0,0,1,55.8,7.68h0a80,80,0,0,1,48.4,0h0a11.9,11.9,0,0,1,8.21,9.93l2.71,22.67a346.51,346.51,0,0,1,0,81.93l-2.75,23.17a11.89,11.89,0,0,1-8.21,9.94h0A80,80,0,0,1,55.8,155.32Z"
                },
                "style": {
                    "fill": "#dbdcdd",
                    "strokeWidth": 0
                },
                "width": 75.12997436523438,
                "height": 155.1297607421875,
                "offsetX": 79.9850082397461,
                "offsetY": 81.4968249797821,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Bathtub3ApbX5T",
                "shape": {
                    "type": "Path",
                    "data": "M60.33,148.59h0a10.58,10.58,0,0,1-6.68-9l-2.21-20.84a351,351,0,0,1,0-74.46l2.21-20.84a10.58,10.58,0,0,1,6.68-9h0a58.4,58.4,0,0,1,39.34,0h0a10.58,10.58,0,0,1,6.68,9L108.55,44a352.34,352.34,0,0,1,0,74.46l-2.24,21.06a10.57,10.57,0,0,1-6.67,9h0A58.4,58.4,0,0,1,60.33,148.59Z"
                },
                "style": {
                    "fill": "#7f7f7f",
                    "strokeWidth": 0
                },
                "width": 61.06253433227539,
                "height": 140.9242706298828,
                "offsetX": 79.9911937713623,
                "offsetY": 81.49986934661865,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Bathtub4lOUBw2",
                "shape": {
                    "type": "Path",
                    "data": "M64.2,138.13h0a8.89,8.89,0,0,1-5.37-7.61l-1.78-17.59a311.24,311.24,0,0,1,0-62.84l1.78-17.59a8.89,8.89,0,0,1,5.37-7.61h0a44.89,44.89,0,0,1,31.6,0h0a8.9,8.9,0,0,1,5.36,7.61l1.77,17.39a311.34,311.34,0,0,1,0,62.85l-1.79,17.77a8.92,8.92,0,0,1-5.37,7.63h0A44.89,44.89,0,0,1,64.2,138.13Z"
                },
                "style": {
                    "fill": "#dbdcdd",
                    "strokeWidth": 0
                },
                "width": 49.06000900268555,
                "height": 118.98432922363281,
                "offsetX": 79.98999977111816,
                "offsetY": 81.50969314575195,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Bathtub5VuZx4N",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fcfcfc"
                },
                "width": 7,
                "height": 7,
                "offsetX": 81.5,
                "offsetY": 39.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Bathtub6OyCt0D",
                "shape": {
                    "type": "Path",
                    "data": "M81.5,44A4.5,4.5,0,1,1,86,39.5,4.51,4.51,0,0,1,81.5,44Zm0-8a3.55,3.55,0,1,0,3.55,3.55A3.55,3.55,0,0,0,81.5,36Z"
                },
                "style": {
                    "fill": "#707070",
                    "strokeWidth": 0
                },
                "width": 9,
                "height": 9,
                "offsetX": 81.5,
                "offsetY": 39.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Bathtub7WVzocQ",
                "shape": {
                    "type": "Path",
                    "data": "M53.57,23l6.78,5.13a10.67,10.67,0,0,1,6-4L62.94,13.56S54.57,15,53.57,23Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 12.779998779296875,
                "height": 14.570000648498535,
                "offsetX": 59.959999084472656,
                "offsetY": 20.845000743865967,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Bathtub8jLg1Zv",
                "shape": {
                    "type": "Path",
                    "data": "M106.36,23l-6.77,5.13a10.68,10.68,0,0,0-6-4L97,13.56S105.36,15,106.36,23Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 12.769989013671875,
                "height": 14.570000648498535,
                "offsetX": 99.97500610351562,
                "offsetY": 20.845000743865967,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Bathtub9pl1ybW",
                "shape": {
                    "type": "Path",
                    "data": "M53.64,140.1,60.41,135a10.68,10.68,0,0,0,6,4L63,149.54S54.64,148.1,53.64,140.1Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 12.770004272460938,
                "height": 14.539993286132812,
                "offsetX": 60.025001525878906,
                "offsetY": 142.2699966430664,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Bathtub10KN6oAI",
                "shape": {
                    "type": "Path",
                    "data": "M106.43,140.1,99.65,135a10.67,10.67,0,0,1-6,4l3.42,10.58S105.43,148.1,106.43,140.1Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 12.779998779296875,
                "height": 14.580001831054688,
                "offsetX": 100.04000091552734,
                "offsetY": 142.29000091552734,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Bathtub",
                "children": ["Bathtub2fk4M08", "Bathtub3ApbX5T", "Bathtub4lOUBw2", "Bathtub5VuZx4N", "Bathtub6OyCt0D", "Bathtub7WVzocQ", "Bathtub8jLg1Zv", "Bathtub9pl1ybW", "Bathtub10KN6oAI"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "BifoldDoor2UaUgr9",
                "shape": {
                    "type": "Path",
                    "data": "M7.87 98.5 21.68 75.23 35.49 51.97 49.3 75.23 63.11 98.5 60.13 98.5 46.32 75.23 32.51 51.97 18.7 75.23 4.89 98.5 7.87 98.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 58.220001220703125,
                "height": 46.529998779296875,
                "offsetX": 34.00000047683716,
                "offsetY": 75.23500061035156,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "BifoldDoor3h7QX3w",
                "shape": {
                    "type": "Path",
                    "data": "M98.87 98.5 112.68 75.23 126.49 51.97 140.3 75.23 154.11 98.5 151.13 98.5 137.32 75.23 123.51 51.97 109.7 75.23 95.89 98.5 98.87 98.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 58.220001220703125,
                "height": 46.529998779296875,
                "offsetX": 125,
                "offsetY": 75.23500061035156,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "BifoldDoor",
                "children": ["BifoldDoor2UaUgr9", "BifoldDoor3h7QX3w"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "CurvedWall2zWqCiM",
                "shape": {
                    "type": "Path",
                    "data": "M80,59c27.52,0,49.94,22.66,50.95,51H141a61,61,0,0,0-122,0H29.05C30.06,81.66,52.48,59,80,59Z"
                },
                "style": {
                    "fill": "#464747",
                    "strokeWidth": 0
                },
                "width": 122,
                "height": 60.978946685791016,
                "offsetX": 79.99999618530273,
                "offsetY": 79.51052665710449,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "CurvedWall",
                "children": ["CurvedWall2zWqCiM"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Decoratives200lGTpLi",
                "shape": {
                    "type": "Path",
                    "data": "M113,48h0a0,0,0,0,1,0,0v0A34,34,0,0,1,79,82h0a0,0,0,0,1,0,0v0A34,34,0,0,1,113,48Z"
                },
                "style": {
                    "fill": "#afb23b",
                    "strokeWidth": 0
                },
                "width": 34,
                "height": 34.000003814697266,
                "offsetX": 96,
                "offsetY": 64.99999809265137,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Decoratives2016d27bG",
                "shape": {
                    "type": "Path",
                    "data": "M48,48h0A34,34,0,0,1,82,82v0a0,0,0,0,1,0,0h0A34,34,0,0,1,48,48v0A0,0,0,0,1,48,48Z"
                },
                "style": {
                    "fill": "#3d6602",
                    "strokeWidth": 0
                },
                "width": 34.000003814697266,
                "height": 34.000003814697266,
                "offsetX": 64.99999809265137,
                "offsetY": 64.99999809265137,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Decoratives202bGoDAj",
                "shape": {
                    "type": "Path",
                    "data": "M79,79h0a34,34,0,0,1,34,34v0a0,0,0,0,1,0,0h0A34,34,0,0,1,79,79v0A0,0,0,0,1,79,79Z"
                },
                "style": {
                    "fill": "#afb23b",
                    "strokeWidth": 0
                },
                "width": 34,
                "height": 34,
                "offsetX": 96,
                "offsetY": 96,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Decoratives203lXOJjk",
                "shape": {
                    "type": "Path",
                    "data": "M82,79h0a0,0,0,0,1,0,0v0a34,34,0,0,1-34,34h0a0,0,0,0,1,0,0v0A34,34,0,0,1,82,79Z"
                },
                "style": {
                    "fill": "#3d6602",
                    "strokeWidth": 0
                },
                "width": 34.000003814697266,
                "height": 34,
                "offsetX": 64.99999809265137,
                "offsetY": 96,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Decoratives2045IEaeM",
                "shape": {
                    "type": "Path",
                    "data": "M85.12,63.57h0A33.87,33.87,0,0,1,119,97.43v0a0,0,0,0,1,0,0h0A33.87,33.87,0,0,1,85.12,63.57v0a0,0,0,0,1,0,0Z"
                },
                "style": {
                    "fill": "#044f16",
                    "strokeWidth": 0
                },
                "width": 33.8800048828125,
                "height": 33.86000442504883,
                "offsetX": 102.05999755859375,
                "offsetY": 80.49999809265137,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Decoratives205KGIDIx",
                "shape": {
                    "type": "Path",
                    "data": "M42,63.57h0A33.87,33.87,0,0,1,75.88,97.43v0a0,0,0,0,1,0,0h0A33.87,33.87,0,0,1,42,63.57v0A0,0,0,0,1,42,63.57Z"
                },
                "style": {
                    "fill": "#afb23b",
                    "strokeWidth": 0
                },
                "width": 33.87999725341797,
                "height": 33.86000442504883,
                "offsetX": 58.939998626708984,
                "offsetY": 80.49999809265137,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Decoratives206k14DUC",
                "shape": {
                    "type": "Path",
                    "data": "M63.57,85.12h0A33.87,33.87,0,0,1,97.43,119v0a0,0,0,0,1,0,0h0A33.87,33.87,0,0,1,63.57,85.12v0a0,0,0,0,1,0,0Z"
                },
                "style": {
                    "fill": "#044f16",
                    "strokeWidth": 0
                },
                "width": 33.86000061035156,
                "height": 33.87999725341797,
                "offsetX": 80.5,
                "offsetY": 102.06000137329102,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Decoratives207Vtb7Y7",
                "shape": {
                    "type": "Path",
                    "data": "M63.57,42h0A33.87,33.87,0,0,1,97.43,75.88v0a0,0,0,0,1,0,0h0A33.87,33.87,0,0,1,63.57,42v0a0,0,0,0,1,0,0Z"
                },
                "style": {
                    "fill": "#044f16",
                    "strokeWidth": 0
                },
                "width": 33.860008239746094,
                "height": 33.87999725341797,
                "offsetX": 80.50000381469727,
                "offsetY": 58.939998626708984,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Decoratives2094BMz5z",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#d1ca43"
                },
                "width": 22,
                "height": 22,
                "offsetX": 80.5,
                "offsetY": 80.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Decoratives",
                "children": ["Decoratives200lGTpLi", "Decoratives2016d27bG", "Decoratives202bGoDAj", "Decoratives203lXOJjk", "Decoratives2045IEaeM", "Decoratives205KGIDIx", "Decoratives206k14DUC", "Decoratives207Vtb7Y7", "Decoratives2094BMz5z"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable3SqCzVG",
                "shape": {
                    "type": "Path",
                    "data": "M103.7,129H56.3l-.08-.22C44.66,98,44.66,68,56.22,37.22L56.3,37h47.4l.08.22c11.56,30.81,11.56,60.75,0,91.56Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 64.89999389648438,
                "height": 92,
                "offsetX": 79.99999618530273,
                "offsetY": 83,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable",
                "children": ["DiningTable3SqCzVG"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningChair2ElPfgJ",
                "shape": {
                    "type": "Path",
                    "data": "M113.66,116H45.34A4.35,4.35,0,0,1,41,111.64L41.5,47H118v64.64A4.35,4.35,0,0,1,113.66,116Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 77.00003051757812,
                "height": 69,
                "offsetX": 79.50000381469727,
                "offsetY": 81.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningChair35GxvfS",
                "shape": {
                    "type": "Path",
                    "data": "M 128.5 , 53.5 L 32.5 , 53.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a",
                    "strokeWidth": 1
                },
                "width": 96,
                "height": 1,
                "offsetX": 80.5,
                "offsetY": 54,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningChair4JR4Xjx",
                "shape": {
                    "type": "Path",
                    "data": "M 32.5 , 45.5 L 128.5 , 45.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a",
                    "strokeWidth": 1
                },
                "width": 96,
                "height": 1,
                "offsetX": 80.5,
                "offsetY": 46,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningChair5wXf14B",
                "shape": {
                    "type": "Path",
                    "data": "M 42 , 45.41 L 44.65 , 58.54"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a",
                    "strokeWidth": 1
                },
                "width": 2.6500015258789062,
                "height": 13.130001068115234,
                "offsetX": 43.32500076293945,
                "offsetY": 51.97500038146973,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningChair6BJHLd8",
                "shape": {
                    "type": "Path",
                    "data": "M 116.31 , 45.48 L 113.67 , 58.54"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a",
                    "strokeWidth": 1
                },
                "width": 2.6399993896484375,
                "height": 13.060001373291016,
                "offsetX": 114.98999786376953,
                "offsetY": 52.010000228881836,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningChair",
                "children": ["DiningChair2ElPfgJ", "DiningChair35GxvfS", "DiningChair4JR4Xjx", "DiningChair5wXf14B", "DiningChair6BJHLd8"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable2Y5gwo6",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 77,
                "height": 77,
                "offsetX": 82.71000289916992,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable3zorvVj",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 67,
                "height": 67,
                "offsetX": 82.71000289916992,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable",
                "children": ["DiningTable2Y5gwo6", "DiningTable3zorvVj"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_12yO5IjU",
                "shape": {
                    "type": "Path",
                    "data": "M68.63,44H94.37A1.64,1.64,0,0,0,96,42.36L95.81,18H67V42.36A1.64,1.64,0,0,0,68.63,44Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 29,
                "height": 26,
                "offsetX": 81.5,
                "offsetY": 31,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_13cbZsug",
                "shape": {
                    "type": "Path",
                    "data": "M69.63,116.14H95.37A1.64,1.64,0,0,1,97,117.78l-.19,24.36H68V117.78A1.64,1.64,0,0,1,69.63,116.14Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 28.99999237060547,
                "height": 26,
                "offsetX": 82.49999618530273,
                "offsetY": 129.13999938964844,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_14427zYw",
                "shape": {
                    "type": "Path",
                    "data": "M44.93,92.44V66.7a1.64,1.64,0,0,0-1.64-1.63l-24.36.19V94.07H43.29A1.64,1.64,0,0,0,44.93,92.44Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 26,
                "height": 29,
                "offsetX": 31.93000030517578,
                "offsetY": 79.56999969482422,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_15MMyV2U",
                "shape": {
                    "type": "Path",
                    "data": "M117.64,94A1.65,1.65,0,0,1,116,92.36V66.63A1.64,1.64,0,0,1,117.64,65l24.36.19V94Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 26,
                "height": 28.99999237060547,
                "offsetX": 129,
                "offsetY": 79.50000381469727,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_16IWryC0",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 77,
                "height": 77,
                "offsetX": 80.70999908447266,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_17lyPd8B",
                "shape": {
                    "type": "Path",
                    "data": "M 63 , 20.5 L 99 , 20.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 36,
                "height": 1,
                "offsetX": 81,
                "offsetY": 21,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_18ZjpQKB",
                "shape": {
                    "type": "Path",
                    "data": "M 99 , 17.5 L 63 , 17.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 36,
                "height": 1,
                "offsetX": 81,
                "offsetY": 18,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_19soewBv",
                "shape": {
                    "type": "Path",
                    "data": "M 95.5 , 17.56 L 94.5 , 22.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 1,
                "height": 4.940000534057617,
                "offsetX": 95,
                "offsetY": 20.02999973297119,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_110hOXeIA",
                "shape": {
                    "type": "Path",
                    "data": "M 67.54 , 17.59 L 68.53 , 22.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 0.9899978637695312,
                "height": 4.909999847412109,
                "offsetX": 68.03499984741211,
                "offsetY": 20.045000076293945,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_111Oj68vZ",
                "shape": {
                    "type": "Path",
                    "data": "M 64 , 139.64 L 100 , 139.64"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 36,
                "height": 1,
                "offsetX": 82,
                "offsetY": 140.13999938964844,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_112dCCIeO",
                "shape": {
                    "type": "Path",
                    "data": "M 100 , 142.64 L 64 , 142.64"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 36,
                "height": 1,
                "offsetX": 82,
                "offsetY": 143.13999938964844,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_113gZW9wg",
                "shape": {
                    "type": "Path",
                    "data": "M 96.5 , 142.58 L 95.5 , 137.64"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 1,
                "height": 4.94000244140625,
                "offsetX": 96,
                "offsetY": 140.11000061035156,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_114SSOT9f",
                "shape": {
                    "type": "Path",
                    "data": "M 68.54 , 142.55 L 69.53 , 137.64"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 0.9899978637695312,
                "height": 4.910003662109375,
                "offsetX": 69.03499984741211,
                "offsetY": 140.09500122070312,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_115pofjc6",
                "shape": {
                    "type": "Path",
                    "data": "M 21.43 , 98.07 L 21.43 , 62.07"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 1,
                "height": 36,
                "offsetX": 21.93000030517578,
                "offsetY": 80.06999969482422,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_1169znyo9",
                "shape": {
                    "type": "Path",
                    "data": "M 18.43 , 62.07 L 18.43 , 98.07"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 1,
                "height": 36,
                "offsetX": 18.93000030517578,
                "offsetY": 80.06999969482422,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_117z7kJ9i",
                "shape": {
                    "type": "Path",
                    "data": "M 18.49 , 65.57 L 23.43 , 66.57"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 4.940000534057617,
                "height": 1,
                "offsetX": 20.960000038146973,
                "offsetY": 66.06999969482422,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_118NLfsSd",
                "shape": {
                    "type": "Path",
                    "data": "M 18.52 , 93.53 L 23.43 , 92.54"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 4.909999847412109,
                "height": 0.9899978637695312,
                "offsetX": 20.975000381469727,
                "offsetY": 93.03499984741211,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_119VEHh3P",
                "shape": {
                    "type": "Path",
                    "data": "M 139.5 , 98.5 L 139.5 , 62.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 1,
                "height": 36,
                "offsetX": 140,
                "offsetY": 80.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_120NwuBb0",
                "shape": {
                    "type": "Path",
                    "data": "M 142.5 , 62.5 L 142.5 , 98.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 1,
                "height": 36,
                "offsetX": 143,
                "offsetY": 80.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_121AWqoSp",
                "shape": {
                    "type": "Path",
                    "data": "M 142.51 , 65.57 L 137.57 , 66.57"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 4.9399871826171875,
                "height": 1,
                "offsetX": 140.04000091552734,
                "offsetY": 66.06999969482422,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_122zhHjTv",
                "shape": {
                    "type": "Path",
                    "data": "M 142.48 , 93.53 L 137.57 , 92.54"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 4.9099884033203125,
                "height": 0.9899978637695312,
                "offsetX": 140.0250015258789,
                "offsetY": 93.03499984741211,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_123PHWdwZ",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#522c0a"
                },
                "width": 77,
                "height": 77,
                "offsetX": 80.70999908447266,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_124EYrlzl",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 67,
                "height": 67,
                "offsetX": 80.71000289916992,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DiningTable_1",
                "children": ["DiningTable_12yO5IjU", "DiningTable_13cbZsug", "DiningTable_14427zYw", "DiningTable_15MMyV2U", "DiningTable_16IWryC0", "DiningTable_17lyPd8B", "DiningTable_18ZjpQKB", "DiningTable_19soewBv", "DiningTable_110hOXeIA", "DiningTable_111Oj68vZ", "DiningTable_112dCCIeO", "DiningTable_113gZW9wg", "DiningTable_114SSOT9f", "DiningTable_115pofjc6", "DiningTable_1169znyo9", "DiningTable_117z7kJ9i", "DiningTable_118NLfsSd", "DiningTable_119VEHh3P", "DiningTable_120NwuBb0", "DiningTable_121AWqoSp", "DiningTable_122zhHjTv", "DiningTable_123PHWdwZ", "DiningTable_124EYrlzl"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_42uZUn1v",
                "shape": {
                    "type": "Path",
                    "data": "M76.1,125.05l-1-5.21a.38.38,0,0,1,.37-.45h2.08a.38.38,0,0,1,.37.45l-1,5.21A.38.38,0,0,1,76.1,125.05Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 2.8330154418945312,
                "height": 6.069999694824219,
                "offsetX": 76.51000595092773,
                "offsetY": 122.42500686645508,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_43VATWEB",
                "shape": {
                    "type": "Path",
                    "data": "M38.27,87.22l5.21,1a.37.37,0,0,0,.45-.36V85.81a.38.38,0,0,0-.45-.37l-5.21,1A.37.37,0,0,0,38.27,87.22Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 6.050006866455078,
                "height": 2.7952728271484375,
                "offsetX": 40.90500068664551,
                "offsetY": 86.83112335205078,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_44ZcKsf5",
                "shape": {
                    "type": "Path",
                    "data": "M125.8,75.36l-5.66-1.14v3l5.66-1.13A.37.37,0,0,0,125.8,75.36Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 5.969413757324219,
                "height": 3,
                "offsetX": 123.12470626831055,
                "offsetY": 75.72000122070312,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_45ANuyxK",
                "shape": {
                    "type": "Path",
                    "data": "M87.44,37l1.14,5.66h-3L86.71,37A.37.37,0,0,1,87.44,37Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 3,
                "height": 5.969398498535156,
                "offsetX": 87.08000183105469,
                "offsetY": 39.67530059814453,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_46HYmbQI",
                "shape": {
                    "type": "Path",
                    "data": "M137.21,55.33A20.36,20.36,0,0,0,136,27.59h0a20.36,20.36,0,0,0-27.74-1.25Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 33.826637268066406,
                "height": 33.84841537475586,
                "offsetX": 125.17332077026367,
                "offsetY": 38.40579414367676,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_47RjnCm8",
                "shape": {
                    "type": "Path",
                    "data": "M57.19,135.35a20.37,20.37,0,0,1-27.74-1.25h0a20.37,20.37,0,0,1-1.25-27.74Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 33.84476089477539,
                "height": 33.844764709472656,
                "offsetX": 40.26761817932129,
                "offsetY": 123.28239059448242,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_488iJbCU",
                "shape": {
                    "type": "Path",
                    "data": "M56.36,25.09a20.36,20.36,0,0,0-27.74,1.26h0a20.35,20.35,0,0,0-1.25,27.73Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 33.847434997558594,
                "height": 33.8438720703125,
                "offsetX": 39.4362850189209,
                "offsetY": 37.15806770324707,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_49epgAtY",
                "shape": {
                    "type": "Path",
                    "data": "M138,105.77a20.36,20.36,0,0,1-1.25,27.74h0a20.36,20.36,0,0,1-27.74,1.25Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 33.848411560058594,
                "height": 33.848411560058594,
                "offsetX": 125.93420791625977,
                "offsetY": 122.6942024230957,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_4109b3r65",
                "shape": {
                    "type": "Path",
                    "data": "M121.66,25.39h0a16.5,16.5,0,0,1,16.5,16.5V56.7a1.69,1.69,0,0,1-1.69,1.69H106.85a1.69,1.69,0,0,1-1.69-1.69V41.89a16.5,16.5,0,0,1,16.5-16.5Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 33.00000762939453,
                "height": 33,
                "offsetX": 121.65999984741211,
                "offsetY": 41.88999938964844,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_411cIOJis",
                "shape": {
                    "type": "Path",
                    "data": "M28.95,103.29H58.56A1.69,1.69,0,0,1,60.26,105v14.81a16.5,16.5,0,0,1-16.5,16.5h0a16.5,16.5,0,0,1-16.5-16.5V105a1.69,1.69,0,0,1,1.69-1.69Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 33.00011444091797,
                "height": 33.02002716064453,
                "offsetX": 43.76005554199219,
                "offsetY": 119.79998397827148,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_412MLgVbr",
                "shape": {
                    "type": "Path",
                    "data": "M42.93,24.15h0a16.5,16.5,0,0,1,16.5,16.5V55.46a1.69,1.69,0,0,1-1.69,1.69H28.12a1.69,1.69,0,0,1-1.69-1.69V40.65a16.5,16.5,0,0,1,16.5-16.5Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 33.000003814697266,
                "height": 33,
                "offsetX": 42.930002212524414,
                "offsetY": 40.64999961853027,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_413ilqhyK",
                "shape": {
                    "type": "Path",
                    "data": "M107.68,102.71h29.62A1.69,1.69,0,0,1,139,104.4v14.81a16.5,16.5,0,0,1-16.5,16.5h0a16.5,16.5,0,0,1-16.5-16.5V104.4a1.69,1.69,0,0,1,1.69-1.69Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 33,
                "height": 33.000030517578125,
                "offsetX": 122.5,
                "offsetY": 119.20997619628906,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_415GZc7a0",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#3d2009"
                },
                "width": 81,
                "height": 81,
                "offsetX": 82.29999542236328,
                "offsetY": 81.25,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_416mXNEoq",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 75,
                "height": 75,
                "offsetX": 82.29999542236328,
                "offsetY": 81.25,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_4",
                "children": ["DinningSet_42uZUn1v", "DinningSet_43VATWEB", "DinningSet_44ZcKsf5", "DinningSet_45ANuyxK", "DinningSet_46HYmbQI", "DinningSet_47RjnCm8", "DinningSet_488iJbCU", "DinningSet_49epgAtY", "DinningSet_4109b3r65", "DinningSet_411cIOJis", "DinningSet_412MLgVbr", "DinningSet_413ilqhyK", "DinningSet_415GZc7a0", "DinningSet_416mXNEoq"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_824djVI8",
                "shape": {
                    "type": "Path",
                    "data": "M62.92,144.54A16.58,16.58,0,0,0,79.46,160h0A16.58,16.58,0,0,0,96,144.54Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 33.08000946044922,
                "height": 15.460006713867188,
                "offsetX": 79.46000289916992,
                "offsetY": 152.2699966430664,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_83dSx9cu",
                "shape": {
                    "type": "Path",
                    "data": "M62.92,16A16.59,16.59,0,0,1,79.46.54h0A16.59,16.59,0,0,1,96,16Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 33.08000183105469,
                "height": 15.460000038146973,
                "offsetX": 79.45999908447266,
                "offsetY": 8.270000040531158,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_84dG6DSE",
                "shape": {
                    "type": "Path",
                    "data": "M28.69,63.23A16.59,16.59,0,0,0,13.23,79.77h0A16.59,16.59,0,0,0,28.69,96.31Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 15.460000991821289,
                "height": 33.08000564575195,
                "offsetX": 20.960000038146973,
                "offsetY": 79.7700023651123,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_85K4pDFg",
                "shape": {
                    "type": "Path",
                    "data": "M131.23,63.23a16.58,16.58,0,0,1,15.46,16.54h0a16.58,16.58,0,0,1-15.46,16.54Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 15.460006713867188,
                "height": 33.08000564575195,
                "offsetX": 138.95999908447266,
                "offsetY": 79.7700023651123,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_86sqsv8A",
                "shape": {
                    "type": "Path",
                    "data": "M131.54,100.52a16.57,16.57,0,0,1,11.84,19.29h0a16.57,16.57,0,0,1-18.44,13.12Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 18.774688720703125,
                "height": 32.557029724121094,
                "offsetX": 134.32733154296875,
                "offsetY": 116.79851150512695,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_874bsWBf",
                "shape": {
                    "type": "Path",
                    "data": "M131.54,59.08a16.57,16.57,0,0,0,11.84-19.29h0a16.57,16.57,0,0,0-18.44-13.12Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 18.774688720703125,
                "height": 32.557037353515625,
                "offsetX": 134.32733154296875,
                "offsetY": 42.801483154296875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_88DnQ19Z",
                "shape": {
                    "type": "Path",
                    "data": "M29.29,100.52a16.58,16.58,0,0,0-11.85,19.29h0a16.57,16.57,0,0,0,18.44,13.12Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 18.772499084472656,
                "height": 32.557029724121094,
                "offsetX": 26.493751525878906,
                "offsetY": 116.79851150512695,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_89oFXD2d",
                "shape": {
                    "type": "Path",
                    "data": "M29.29,59.08A16.58,16.58,0,0,1,17.44,39.79h0A16.57,16.57,0,0,1,35.88,26.67Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 18.772499084472656,
                "height": 32.557037353515625,
                "offsetX": 26.493751525878906,
                "offsetY": 42.80148506164551,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_8114lk4KP",
                "shape": {
                    "type": "Path",
                    "data": "M103.7,126H56.3l-.08-.22C44.66,95,44.66,65,56.22,34.22L56.3,34h47.4l.08.22c11.56,30.81,11.56,60.75,0,91.56Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 64.89999389648438,
                "height": 92,
                "offsetX": 79.99999618530273,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_812SNLZ3z",
                "shape": {
                    "type": "Path",
                    "data": "M79.42,129.54h0A13.5,13.5,0,0,1,92.92,143v12.12a1.38,1.38,0,0,1-1.38,1.38H67.31a1.38,1.38,0,0,1-1.38-1.38V143A13.5,13.5,0,0,1,79.42,129.54Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 26.98999786376953,
                "height": 26.960006713867188,
                "offsetX": 79.42499923706055,
                "offsetY": 143.0199966430664,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_813KwMoSG",
                "shape": {
                    "type": "Path",
                    "data": "M67.31,4H91.54a1.38,1.38,0,0,1,1.38,1.38V17.5A13.5,13.5,0,0,1,79.42,31h0a13.5,13.5,0,0,1-13.5-13.5V5.38A1.38,1.38,0,0,1,67.31,4Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 27.00000762939453,
                "height": 27.000036239624023,
                "offsetX": 79.42000198364258,
                "offsetY": 17.49998188018799,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_814aazUsg",
                "shape": {
                    "type": "Path",
                    "data": "M30.19,66.23h0a13.5,13.5,0,0,1,13.5,13.5V91.85a1.38,1.38,0,0,1-1.38,1.38H18.08a1.38,1.38,0,0,1-1.38-1.38V79.73a13.5,13.5,0,0,1,13.5-13.5Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 26.990001678466797,
                "height": 26.99999237060547,
                "offsetX": 30.19500160217285,
                "offsetY": 79.72999954223633,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_815wJoPOH",
                "shape": {
                    "type": "Path",
                    "data": "M117.62,66.23h24.23a1.38,1.38,0,0,1,1.38,1.38V79.73a13.5,13.5,0,0,1-13.5,13.5h0a13.5,13.5,0,0,1-13.5-13.5V67.62a1.38,1.38,0,0,1,1.38-1.38Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 27,
                "height": 27,
                "offsetX": 129.73001098632812,
                "offsetY": 79.7300033569336,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_816zdmA9V",
                "shape": {
                    "type": "Path",
                    "data": "M114.66,102.89h24.23a1.38,1.38,0,0,1,1.38,1.38v12.12a13.5,13.5,0,0,1-13.5,13.5h0a13.5,13.5,0,0,1-13.5-13.5V104.27A1.38,1.38,0,0,1,114.66,102.89Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 27.00000762939453,
                "height": 27.000038146972656,
                "offsetX": 126.77000045776367,
                "offsetY": 116.38998031616211,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_8179rOnBv",
                "shape": {
                    "type": "Path",
                    "data": "M126.78,29.71h0a13.5,13.5,0,0,1,13.5,13.5V55.33a1.38,1.38,0,0,1-1.38,1.38H114.66a1.38,1.38,0,0,1-1.38-1.38V43.21a13.5,13.5,0,0,1,13.5-13.5Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 26.99999237060547,
                "height": 27.000003814697266,
                "offsetX": 126.78000259399414,
                "offsetY": 43.21000099182129,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_818mGY82R",
                "shape": {
                    "type": "Path",
                    "data": "M34,102.89h0a13.5,13.5,0,0,1,13.5,13.5V128.5a1.38,1.38,0,0,1-1.38,1.38H21.93a1.38,1.38,0,0,1-1.38-1.38V116.39A13.5,13.5,0,0,1,34,102.89Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 26.94999885559082,
                "height": 26.990005493164062,
                "offsetX": 34.02500057220459,
                "offsetY": 116.38500213623047,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_819pyEsaP",
                "shape": {
                    "type": "Path",
                    "data": "M21.93,29.71H46.16a1.38,1.38,0,0,1,1.38,1.38V43.21A13.5,13.5,0,0,1,34,56.71h0a13.5,13.5,0,0,1-13.5-13.5V31.1A1.38,1.38,0,0,1,21.93,29.71Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 27.0400447845459,
                "height": 27.000967025756836,
                "offsetX": 34.019978523254395,
                "offsetY": 43.20957279205322,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DinningSet_8",
                "children": ["DinningSet_824djVI8", "DinningSet_83dSx9cu", "DinningSet_84dG6DSE", "DinningSet_85K4pDFg", "DinningSet_86sqsv8A", "DinningSet_874bsWBf", "DinningSet_88DnQ19Z", "DinningSet_89oFXD2d", "DinningSet_8114lk4KP", "DinningSet_812SNLZ3z", "DinningSet_813KwMoSG", "DinningSet_814aazUsg", "DinningSet_815wJoPOH", "DinningSet_816zdmA9V", "DinningSet_8179rOnBv", "DinningSet_818mGY82R", "DinningSet_819pyEsaP"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoorSwing2WNa9kD",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 3,
                "height": 63,
                "offsetX": 52,
                "offsetY": 76,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoorSwing3HCEDXa",
                "shape": {
                    "type": "Path",
                    "data": "M53.5,108V44.5h0a56,56,0,0,1,56,56V108"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747",
                    "strokeWidth": 0
                },
                "width": 56,
                "height": 63.5,
                "offsetX": 81.5,
                "offsetY": 76.25,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoorSwing",
                "children": ["DoorSwing2WNa9kD", "DoorSwing3HCEDXa"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoorSwingCloseDoor2a6tE9r",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 62.88999938964844,
                "height": 2.990000009536743,
                "offsetX": 71.00500106811523,
                "offsetY": 78.99500000476837,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoorSwingCloseDoor3B7him8",
                "shape": {
                    "type": "Path",
                    "data": "M94.29,57.83l1.38,1.54a54.9,54.9,0,0,1,13.57,41.33l-.15,1.59"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747",
                    "strokeWidth": 0
                },
                "width": 15.172737121582031,
                "height": 44.459999084472656,
                "offsetX": 101.87636947631836,
                "offsetY": 80.06000137329102,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoorSwingCloseDoor",
                "children": ["DoorSwingCloseDoor2a6tE9r", "DoorSwingCloseDoor3B7him8"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoubleCotBed2oicVyI",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 1.9
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 125,
                "height": 9,
                "offsetX": 79.5,
                "offsetY": 5.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoubleCotBed3QgJ1X7",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 2
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 124,
                "height": 8,
                "offsetX": 79,
                "offsetY": 154,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoubleCotBed4SvkPoP",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "url(#linear-gradient)"
                },
                "width": 118,
                "height": 140,
                "offsetX": 79,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoubleCotBed5CdUtWQ",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#edaa51"
                },
                "width": 118,
                "height": 96,
                "offsetX": 79,
                "offsetY": 102,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoubleCotBed7UtznCk",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 1.98
                },
                "style": {
                    "fill": "#edaa51"
                },
                "width": 125,
                "height": 14,
                "offsetX": 79.5,
                "offsetY": 61,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoubleCotBed8LPigt3",
                "shape": {
                    "type": "Path",
                    "data": "M71.21,37.26l-5-.59a129,129,0,0,0-29.52,0l-5.05.59a.8.8,0,0,1-.88-1l.37-1.74a40.31,40.31,0,0,0,0-16.87l-.37-1.74a.79.79,0,0,1,.88-1l5.05.58a129,129,0,0,0,29.52,0l5-.58a.79.79,0,0,1,.88,1l-.37,1.74a40.31,40.31,0,0,0,0,16.87l.37,1.74A.8.8,0,0,1,71.21,37.26Z"
                },
                "style": {
                    "fill": "#edaa51",
                    "strokeWidth": 0
                },
                "width": 41.392112731933594,
                "height": 22.366565704345703,
                "offsetX": 51.42500114440918,
                "offsetY": 26.083949089050293,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoubleCotBed9i5nKvw",
                "shape": {
                    "type": "Path",
                    "data": "M125.53,37.26l-5.06-.59a129,129,0,0,0-29.52,0l-5,.59a.8.8,0,0,1-.88-1l.37-1.74a40.31,40.31,0,0,0,0-16.87L85,15.94a.79.79,0,0,1,.88-1l5,.58a129,129,0,0,0,29.52,0l5.06-.58a.79.79,0,0,1,.87,1L126,17.68a40.31,40.31,0,0,0,0,16.87l.37,1.74A.8.8,0,0,1,125.53,37.26Z"
                },
                "style": {
                    "fill": "#edaa51",
                    "strokeWidth": 0
                },
                "width": 41.4197998046875,
                "height": 22.336557388305664,
                "offsetX": 105.67884063720703,
                "offsetY": 26.098952293395996,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoubleCotBed10TsdG12",
                "shape": {
                    "type": "Path",
                    "data": "M31.59,37.26a.8.8,0,0,1-.88-1l.37-1.74a40.31,40.31,0,0,0,0-16.87l-.37-1.74a.79.79,0,0,1,.88-1l5.05.58a129,129,0,0,0,29.52,0h0A80.82,80.82,0,0,1,34.93,36.05Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 35.48106002807617,
                "height": 22.366565704345703,
                "offsetX": 48.41947364807129,
                "offsetY": 26.083948135375977,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoubleCotBed11tO8jVn",
                "shape": {
                    "type": "Path",
                    "data": "M85.9,37.26a.8.8,0,0,1-.88-1l.37-1.74a40.31,40.31,0,0,0,0-16.87L85,15.94a.79.79,0,0,1,.88-1l5,.58a129,129,0,0,0,29.52,0h0A80.82,80.82,0,0,1,89.24,36.05Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 35.431053161621094,
                "height": 22.3365535736084,
                "offsetX": 102.68446731567383,
                "offsetY": 26.098950386047363,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoubleCotBed",
                "children": ["DoubleCotBed2oicVyI", "DoubleCotBed3QgJ1X7", "DoubleCotBed4SvkPoP", "DoubleCotBed5CdUtWQ", "DoubleCotBed7UtznCk", "DoubleCotBed8LPigt3", "DoubleCotBed9i5nKvw", "DoubleCotBed10TsdG12", "DoubleCotBed11tO8jVn"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoubleDoorSwing2qOeL2P",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 3,
                "height": 63,
                "offsetX": 23,
                "offsetY": 76,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoubleDoorSwing3kSfHps",
                "shape": {
                    "type": "Path",
                    "data": "M24.5,108V44.5h0a56,56,0,0,1,56,56V108"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747",
                    "strokeWidth": 0
                },
                "width": 56.00000762939453,
                "height": 63.5,
                "offsetX": 52.500003814697266,
                "offsetY": 76.25,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoubleDoorSwing48ZvrNO",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 3,
                "height": 63,
                "offsetX": 138,
                "offsetY": 76,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoubleDoorSwing50Ay9ZF",
                "shape": {
                    "type": "Path",
                    "data": "M136.5,108V44.5h0a56,56,0,0,0-56,56V108"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747",
                    "strokeWidth": 0
                },
                "width": 56,
                "height": 63.5,
                "offsetX": 108.5,
                "offsetY": 76.25,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "DoubleDoorSwing",
                "children": ["DoubleDoorSwing2qOeL2P", "DoubleDoorSwing3kSfHps", "DoubleDoorSwing48ZvrNO", "DoubleDoorSwing50Ay9ZF"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "FlowerPot2cIIxrk",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#822c0f"
                },
                "width": 82,
                "height": 82,
                "offsetX": 83,
                "offsetY": 81,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "FlowerPot3GrCDPC",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#270805"
                },
                "width": 66,
                "height": 66,
                "offsetX": 83,
                "offsetY": 81,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "FlowerPot4aGcCmB",
                "shape": {
                    "type": "Path",
                    "data": "M85,79h.37A24.63,24.63,0,0,1,110,103.63V104a0,0,0,0,1,0,0h-.37A24.63,24.63,0,0,1,85,79.37V79A0,0,0,0,1,85,79Z"
                },
                "style": {
                    "fill": "#03cd4e",
                    "strokeWidth": 0
                },
                "width": 25.00000762939453,
                "height": 25,
                "offsetX": 97.50000381469727,
                "offsetY": 91.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "FlowerPot5hZ8VXB",
                "shape": {
                    "type": "Path",
                    "data": "M55.56,62.11h0A24.63,24.63,0,0,1,80.19,86.74v0a0,0,0,0,1,0,0h0A24.63,24.63,0,0,1,55.56,62.11v0A0,0,0,0,1,55.56,62.11Z"
                },
                "style": {
                    "fill": "#04a53a",
                    "strokeWidth": 0
                },
                "width": 24.630001068115234,
                "height": 24.62999725341797,
                "offsetX": 67.87500190734863,
                "offsetY": 74.42499923706055,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "FlowerPot6i5xlNR",
                "shape": {
                    "type": "Path",
                    "data": "M54.29,80h0a25.76,25.76,0,0,1,25.76,25.76v0a0,0,0,0,1,0,0h0A25.76,25.76,0,0,1,54.29,80v0A0,0,0,0,1,54.29,80Z"
                },
                "style": {
                    "fill": "#03cd4e",
                    "strokeWidth": 0
                },
                "width": 25.76000213623047,
                "height": 25.760009765625,
                "offsetX": 67.17000198364258,
                "offsetY": 92.8800048828125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "FlowerPot788L5oQ",
                "shape": {
                    "type": "Path",
                    "data": "M83,61.37h0A24.63,24.63,0,0,1,107.64,86v0a0,0,0,0,1,0,0h0A24.63,24.63,0,0,1,83,61.37v0a0,0,0,0,1,0,0Z"
                },
                "style": {
                    "fill": "#04a53a",
                    "strokeWidth": 0
                },
                "width": 24.639999389648438,
                "height": 24.6300048828125,
                "offsetX": 95.31999969482422,
                "offsetY": 73.68499755859375,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "FlowerPot8xw1SkS",
                "shape": {
                    "type": "Path",
                    "data": "M67.63,82.27h0A26.53,26.53,0,0,1,94.16,108.8v0a0,0,0,0,1,0,0h0A26.53,26.53,0,0,1,67.63,82.27v0a0,0,0,0,1,0,0Z"
                },
                "style": {
                    "fill": "#025909",
                    "strokeWidth": 0
                },
                "width": 26.530006408691406,
                "height": 26.530006408691406,
                "offsetX": 80.89500045776367,
                "offsetY": 95.53499984741211,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "FlowerPot9m3E2jR",
                "shape": {
                    "type": "Path",
                    "data": "M69.35,47.71h0A25.76,25.76,0,0,1,95.12,73.47v0a0,0,0,0,1,0,0h0A25.76,25.76,0,0,1,69.35,47.71v0a0,0,0,0,1,0,0Z"
                },
                "style": {
                    "fill": "#04a53a",
                    "strokeWidth": 0
                },
                "width": 25.770004272460938,
                "height": 25.760005950927734,
                "offsetX": 82.23500061035156,
                "offsetY": 60.58999824523926,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "FlowerPot10GktLp6",
                "shape": {
                    "type": "Path",
                    "data": "M61,55h.37A24.63,24.63,0,0,1,86,79.63V80a0,0,0,0,1,0,0h-.37A24.63,24.63,0,0,1,61,55.37V55A0,0,0,0,1,61,55Z"
                },
                "style": {
                    "fill": "#025909",
                    "strokeWidth": 0
                },
                "width": 25,
                "height": 25,
                "offsetX": 73.5,
                "offsetY": 67.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "FlowerPot11fx9kYr",
                "shape": {
                    "type": "Path",
                    "data": "M88.84,65.3h0a24.63,24.63,0,0,1,24.63,24.63v0a0,0,0,0,1,0,0h0A24.63,24.63,0,0,1,88.84,65.3v0a0,0,0,0,1,0,0Z"
                },
                "style": {
                    "fill": "#025909",
                    "strokeWidth": 0
                },
                "width": 24.62999725341797,
                "height": 24.6300048828125,
                "offsetX": 101.15499496459961,
                "offsetY": 77.61500549316406,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "FlowerPot",
                "children": ["FlowerPot2cIIxrk", "FlowerPot3GrCDPC", "FlowerPot4aGcCmB", "FlowerPot5hZ8VXB", "FlowerPot6i5xlNR", "FlowerPot788L5oQ", "FlowerPot8xw1SkS", "FlowerPot9m3E2jR", "FlowerPot10GktLp6", "FlowerPot11fx9kYr"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Fridge2UgwgEw",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#d1d2d3"
                },
                "width": 81,
                "height": 5,
                "offsetX": 82.5,
                "offsetY": 19.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Fridge3sKXl4G",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#d1d2d3"
                },
                "width": 81,
                "height": 4,
                "offsetX": 82.5,
                "offsetY": 118,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Fridge4B2RVO2",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#d1d2d3"
                },
                "width": 8,
                "height": 2,
                "offsetX": 48,
                "offsetY": 126,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Fridge5ochVkT",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 89,
                "height": 5,
                "offsetX": 82.5,
                "offsetY": 122.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Fridge6t7y4KE",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 89,
                "height": 94,
                "offsetX": 82.5,
                "offsetY": 69,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Fridge7iy2fws",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 79,
                "height": 0.5,
                "offsetX": 82.5,
                "offsetY": 117.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Fridge8f4BNBf",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 79,
                "height": 0.5,
                "offsetX": 82.5,
                "offsetY": 118.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Fridge",
                "children": ["Fridge2UgwgEw", "Fridge3sKXl4G", "Fridge4B2RVO2", "Fridge5ochVkT", "Fridge6t7y4KE", "Fridge7iy2fws", "Fridge8f4BNBf"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "HorizontalWall2sSktqn",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#464747"
                },
                "width": 113,
                "height": 14,
                "offsetX": 78.5,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "HorizontalWall",
                "children": ["HorizontalWall2sSktqn"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "KitchenDesk2hL4gtD",
                "shape": {
                    "type": "Path",
                    "data": "M48,112V4a4,4,0,0,0-4-4H4A4,4,0,0,0,0,4V156a4,4,0,0,0,4,4H110a4,4,0,0,0,4-4V116a4,4,0,0,0-4-4Z"
                },
                "style": {
                    "fill": "#270805",
                    "strokeWidth": 0
                },
                "width": 114,
                "height": 160,
                "offsetX": 57,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "KitchenDesk",
                "children": ["KitchenDesk2hL4gtD"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "KitchenDesk12ZqqmUH",
                "shape": {
                    "type": "Path",
                    "data": "M48,97V4a4,4,0,0,0-4-4H4A4,4,0,0,0,0,4V156a4,4,0,0,0,4,4H110a4,4,0,0,0,4-4V116a4,4,0,0,0-4-4H63A15,15,0,0,1,48,97Z"
                },
                "style": {
                    "fill": "#270805",
                    "strokeWidth": 0
                },
                "width": 114,
                "height": 160,
                "offsetX": 57,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "KitchenDesk1",
                "children": ["KitchenDesk12ZqqmUH"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "KitchenDesk22WGidmo",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#270805"
                },
                "width": 64,
                "height": 160,
                "offsetX": 81,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "KitchenDesk2",
                "children": ["KitchenDesk22WGidmo"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "KitchenDesk32iyRiKe",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#270805"
                },
                "width": 64,
                "height": 160,
                "offsetX": 80,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "KitchenDesk3",
                "children": ["KitchenDesk32iyRiKe"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "OpenWindow2iBxqMC",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 113,
                "height": 14,
                "offsetX": 87,
                "offsetY": 84.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "OpenWindow3gUbG5G",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 113,
                "height": 4,
                "offsetX": 87,
                "offsetY": 84.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "OpenWindow",
                "children": ["OpenWindow2iBxqMC", "OpenWindow3gUbG5G"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "PocketSlidingDoor2w36ele",
                "shape": {
                    "type": "Path",
                    "data": "M91 74.5 30.5 74.5 30.5 85.5 91 85.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 60.5,
                "height": 11,
                "offsetX": 60.75,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "PocketSlidingDoor3RBqypY",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 5,
                "height": 60,
                "offsetX": 99.5,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "PocketSlidingDoor",
                "children": ["PocketSlidingDoor2w36ele", "PocketSlidingDoor3RBqypY"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SideTable_Lamp2KmYZjL",
                "shape": {
                    "type": "Path",
                    "data": "M126.83,95.2V43.86a2,2,0,0,0-2-2h-81a2,2,0,0,0-2,2V95.2h0l6,10.11h73l6-10.11Zm-10.77,5.5c-.19.73-.57,1.26-.86,1.18s-.36-.72-.17-1.45.57-1.26.86-1.19S116.25,100,116.06,100.7Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 85,
                "height": 63.44999694824219,
                "offsetX": 84.33000183105469,
                "offsetY": 73.58499908447266,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SideTable_Lamp3xktJZt",
                "shape": {
                    "type": "Path",
                    "data": "M41.83,95.2l6,10.11h73l6-10.11Zm74.23,5.5c-.19.73-.57,1.26-.86,1.18s-.36-.72-.17-1.45.57-1.26.86-1.19S116.25,100,116.06,100.7Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 85,
                "height": 10.110000610351562,
                "offsetX": 84.33000183105469,
                "offsetY": 100.25499725341797,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SideTable_Lamp4C8Mk8o",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 10.46
                },
                "style": {
                    "fill": "#edab7e"
                },
                "width": 20.920000076293945,
                "height": 20.920000076293945,
                "offsetX": 83.96000003814697,
                "offsetY": 73.05000019073486,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SideTable_Lamp5VaTdD2",
                "shape": {
                    "type": "Path",
                    "data": "M78 63 90 63 92 60.38 76 60.38 78 63"
                },
                "style": {
                    "fill": "url(#linear-gradient)"
                },
                "width": 16,
                "height": 2.6199989318847656,
                "offsetX": 84,
                "offsetY": 61.69000053405762,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SideTable_Lamp69n8Fd7",
                "shape": {
                    "type": "Path",
                    "data": "M78 75 90 75 92 77.62 76 77.62 78 75"
                },
                "style": {
                    "fill": "url(#linear-gradient-2)"
                },
                "width": 16,
                "height": 2.6200027465820312,
                "offsetX": 84,
                "offsetY": 76.31000137329102,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SideTable_Lamp7PQDblT",
                "shape": {
                    "type": "Path",
                    "data": "M90 63 90 75 92.62 77 92.62 61 90 63"
                },
                "style": {
                    "fill": "url(#linear-gradient-3)"
                },
                "width": 2.6200027465820312,
                "height": 16,
                "offsetX": 91.31000137329102,
                "offsetY": 69,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SideTable_Lamp85sPwbo",
                "shape": {
                    "type": "Path",
                    "data": "M78 63 78 75 75.38 77 75.38 61 78 63"
                },
                "style": {
                    "fill": "url(#linear-gradient-4)"
                },
                "width": 2.6200027465820312,
                "height": 16,
                "offsetX": 76.68999862670898,
                "offsetY": 69,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SideTable_Lamp9pinsIv",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#663610"
                },
                "width": 12,
                "height": 12,
                "offsetX": 84,
                "offsetY": 69,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SideTable_Lamp",
                "children": ["SideTable_Lamp2KmYZjL", "SideTable_Lamp3xktJZt", "SideTable_Lamp4C8Mk8o", "SideTable_Lamp5VaTdD2", "SideTable_Lamp69n8Fd7", "SideTable_Lamp7PQDblT", "SideTable_Lamp85sPwbo", "SideTable_Lamp9pinsIv"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SingleCotBed2jof4oX",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 2
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 97.98999786376953,
                "height": 9,
                "offsetX": 78.12499809265137,
                "offsetY": 5.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SingleCotBed36X9rqB",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 2
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 92,
                "height": 8,
                "offsetX": 77.80999946594238,
                "offsetY": 154,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SingleCotBed4u37RVJ",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "url(#linear-gradient)"
                },
                "width": 86.31999969482422,
                "height": 140,
                "offsetX": 78.11999893188477,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SingleCotBed5IAWBTj",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#edaa51"
                },
                "width": 86.31999969482422,
                "height": 96,
                "offsetX": 78.11999893188477,
                "offsetY": 102,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SingleCotBed7yjkygh",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 2
                },
                "style": {
                    "fill": "#edaa51"
                },
                "width": 93,
                "height": 14.25999927520752,
                "offsetX": 78.30999946594238,
                "offsetY": 61.12999963760376,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SingleCotBed8lWjPMX",
                "shape": {
                    "type": "Path",
                    "data": "M97.94,39.26l-5.06-.59a129,129,0,0,0-29.52,0l-5,.59a.8.8,0,0,1-.88-1l.37-1.74a40.31,40.31,0,0,0,0-16.87l-.37-1.74a.79.79,0,0,1,.88-1l5,.58a129,129,0,0,0,29.52,0L97.94,17a.79.79,0,0,1,.87,1l-.37,1.74a40.31,40.31,0,0,0,0,16.87l.37,1.74A.8.8,0,0,1,97.94,39.26Z"
                },
                "style": {
                    "fill": "#edaa51",
                    "strokeWidth": 0
                },
                "width": 41.391666412353516,
                "height": 22.366559982299805,
                "offsetX": 78.1447811126709,
                "offsetY": 28.08394718170166,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SingleCotBed9IRY9nX",
                "shape": {
                    "type": "Path",
                    "data": "M58.31,39.26a.8.8,0,0,1-.88-1l.37-1.74a40.31,40.31,0,0,0,0-16.87l-.37-1.74a.79.79,0,0,1,.88-1l5,.58a129,129,0,0,0,29.52,0h0A80.82,80.82,0,0,1,61.65,38.05Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 35.43105697631836,
                "height": 22.366561889648438,
                "offsetX": 75.11447334289551,
                "offsetY": 28.083946228027344,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SingleCotBed",
                "children": ["SingleCotBed2jof4oX", "SingleCotBed36X9rqB", "SingleCotBed4u37RVJ", "SingleCotBed5IAWBTj", "SingleCotBed7yjkygh", "SingleCotBed8lWjPMX", "SingleCotBed9IRY9nX"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink12ndeecb",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 8
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 147,
                "height": 76,
                "offsetX": 79.5,
                "offsetY": 76,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink13ADMRhG",
                "shape": {
                    "type": "Path",
                    "data": "M58,104V48H15v56ZM51,74a4,4,0,1,1-4-4A4,4,0,0,1,51,74Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 43,
                "height": 56,
                "offsetX": 36.5,
                "offsetY": 76,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink14xUWYoV",
                "shape": {
                    "type": "Path",
                    "data": "M68,48v56h76V48ZM78,66a4,4,0,1,1,4-4A4,4,0,0,1,78,66Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 76,
                "height": 56,
                "offsetX": 106,
                "offsetY": 76,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink15L623g2",
                "shape": {
                    "type": "Path",
                    "data": "M61.14,43.38h0a3.65,3.65,0,0,0,.14,5.3L75.9,61.8a2.58,2.58,0,0,0,3.56-.1h0a2.59,2.59,0,0,0,.1-3.55L66.43,43.52A3.65,3.65,0,0,0,61.14,43.38Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 20.147144317626953,
                "height": 20.150390625,
                "offsetX": 70.1417064666748,
                "offsetY": 52.388587951660156,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink16kgHB4c",
                "shape": {
                    "type": "Path",
                    "data": "M15,104V48l.33.23A110.93,110.93,0,0,1,58,104H15Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 42.99999237060547,
                "height": 56,
                "offsetX": 36.499996185302734,
                "offsetY": 76,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink17UYyfs9",
                "shape": {
                    "type": "Path",
                    "data": "M68,104V48l.5.23C98.09,61.71,120.37,81.28,132,104H68Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 64,
                "height": 56,
                "offsetX": 100,
                "offsetY": 76,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink1",
                "children": ["Sink12ndeecb", "Sink13ADMRhG", "Sink14xUWYoV", "Sink15L623g2", "Sink16kgHB4c", "Sink17UYyfs9"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink22N2TRSr",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 8
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 141,
                "height": 88,
                "offsetX": 80.5,
                "offsetY": 74,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink23QXgXRj",
                "shape": {
                    "type": "Path",
                    "data": "M140.67,40.21H73.33a2,2,0,0,0-2,2V105.8a2,2,0,0,0,2,2h67.34a2,2,0,0,0,2-2V42.21A2,2,0,0,0,140.67,40.21ZM107,79a6,6,0,1,1,6-6A6,6,0,0,1,107,79Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 71.33999633789062,
                "height": 67.59000396728516,
                "offsetX": 107,
                "offsetY": 74.00500106811523,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink24LGb5r3",
                "shape": {
                    "type": "Path",
                    "data": "M71.33,40.21V108l.46-.27c27.78-16.33,48.7-40,59.62-67.52H71.33Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 60.08000183105469,
                "height": 67.79000091552734,
                "offsetX": 101.37000274658203,
                "offsetY": 74.10499954223633,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink250EZcH5Z",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 38,
                "height": 1,
                "offsetX": 39,
                "offsetY": 39.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink251moCmxl",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 38,
                "height": 1,
                "offsetX": 39,
                "offsetY": 46.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink252nOgEkl",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 38,
                "height": 1,
                "offsetX": 39,
                "offsetY": 53.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink253nW0IeP",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 38,
                "height": 1,
                "offsetX": 39,
                "offsetY": 60.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink254veHgZA",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 38,
                "height": 1,
                "offsetX": 39,
                "offsetY": 67.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink255pnMCJr",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 38,
                "height": 1,
                "offsetX": 39,
                "offsetY": 74.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink256uCUFwf",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 38,
                "height": 1,
                "offsetX": 39,
                "offsetY": 81.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink257H9Egl8",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 38,
                "height": 1,
                "offsetX": 39,
                "offsetY": 88.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink258TXUUvY",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 38,
                "height": 1,
                "offsetX": 39,
                "offsetY": 95.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink2599zRa2Y",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 38,
                "height": 1,
                "offsetX": 39,
                "offsetY": 102.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink2510RLAa29",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 38,
                "height": 1,
                "offsetX": 39,
                "offsetY": 109.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink26eu02We",
                "shape": {
                    "type": "Path",
                    "data": "M107.3,31.32h0a3.69,3.69,0,0,1,3.69,3.9l-1.07,19.9a2.63,2.63,0,0,1-2.62,2.48h0a2.62,2.62,0,0,1-2.62-2.48l-1.08-19.9A3.71,3.71,0,0,1,107.3,31.32Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 7.4008636474609375,
                "height": 26.280010223388672,
                "offsetX": 107.29556274414062,
                "offsetY": 44.46000099182129,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink2",
                "children": ["Sink22N2TRSr", "Sink23QXgXRj", "Sink24LGb5r3", "Sink250EZcH5Z", "Sink251moCmxl", "Sink252nOgEkl", "Sink253nW0IeP", "Sink254veHgZA", "Sink255pnMCJr", "Sink256uCUFwf", "Sink257H9Egl8", "Sink258TXUUvY", "Sink2599zRa2Y", "Sink2510RLAa29", "Sink26eu02We"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink324iaSRl",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 8
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 87,
                "height": 87,
                "offsetX": 80.5,
                "offsetY": 77.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink33QuxJ96",
                "shape": {
                    "type": "Path",
                    "data": "M114,44H47a2,2,0,0,0-2,2v64a2,2,0,0,0,2,2h67a2,2,0,0,0,2-2V46A2,2,0,0,0,114,44ZM81,84a6,6,0,1,1,6-6A6,6,0,0,1,81,84Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 71,
                "height": 68,
                "offsetX": 80.5,
                "offsetY": 78,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink34KlfPmH",
                "shape": {
                    "type": "Path",
                    "data": "M45,44v67.79l.47-.27c27.78-16.33,48.7-40,59.61-67.52H45Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 60.08000183105469,
                "height": 67.79000091552734,
                "offsetX": 75.04000091552734,
                "offsetY": 77.89500045776367,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink356oN9Q1",
                "shape": {
                    "type": "Path",
                    "data": "M80.3,35.32h0A3.69,3.69,0,0,1,84,39.22l-1.07,19.9A2.63,2.63,0,0,1,80.3,61.6h0a2.62,2.62,0,0,1-2.62-2.48L76.6,39.22A3.71,3.71,0,0,1,80.3,35.32Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 7.410850524902344,
                "height": 26.280033111572266,
                "offsetX": 80.30055618286133,
                "offsetY": 48.45998191833496,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink3",
                "children": ["Sink324iaSRl", "Sink33QuxJ96", "Sink34KlfPmH", "Sink356oN9Q1"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink42X05l1h",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 8
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 107,
                "height": 67,
                "offsetX": 77.5,
                "offsetY": 65.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink43PExeFN",
                "shape": {
                    "type": "Path",
                    "data": "M121,42H34a2,2,0,0,0-2,2V88a2,2,0,0,0,2,2h87a2,2,0,0,0,2-2V44A2,2,0,0,0,121,42ZM77,67a6,6,0,1,1,6-6A6,6,0,0,1,77,67Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 91,
                "height": 48,
                "offsetX": 77.5,
                "offsetY": 66,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink44iAIsMM",
                "shape": {
                    "type": "Path",
                    "data": "M77.3,33.32h0A3.69,3.69,0,0,1,81,37.22l-1.07,19.9A2.63,2.63,0,0,1,77.3,59.6h0a2.62,2.62,0,0,1-2.62-2.48L73.6,37.22A3.71,3.71,0,0,1,77.3,33.32Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 7.410850524902344,
                "height": 26.280033111572266,
                "offsetX": 77.30055618286133,
                "offsetY": 46.45998191833496,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sink4",
                "children": ["Sink42X05l1h", "Sink43PExeFN", "Sink44iAIsMM"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SlidingDoor2Sc4U9R",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 5,
                "height": 63,
                "offsetX": 64,
                "offsetY": 85,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SlidingDoor3UJdFzP",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 5,
                "height": 63,
                "offsetX": 105,
                "offsetY": 90,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SlidingDoor",
                "children": ["SlidingDoor2Sc4U9R", "SlidingDoor3UJdFzP"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "sofachair2RnObZZ",
                "shape": {
                    "type": "Path",
                    "data": "M127.08,81A47.2,47.2,0,0,0,80,37h0A47.2,47.2,0,0,0,32.92,81Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 94.16000366210938,
                "height": 44.00000762939453,
                "offsetX": 80.00000381469727,
                "offsetY": 59.000003814697266,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "sofachair368y1sX",
                "shape": {
                    "type": "Path",
                    "data": "M80,45h0a39,39,0,0,1,39,39v35a4,4,0,0,1-4,4H45a4,4,0,0,1-4-4V84A39,39,0,0,1,80,45Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 78.00000762939453,
                "height": 78,
                "offsetX": 80.00000381469727,
                "offsetY": 84,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "sofachair",
                "children": ["sofachair2RnObZZ", "sofachair368y1sX"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_12XCFQXo",
                "shape": {
                    "type": "Path",
                    "data": "M36,55h87a0,0,0,0,1,0,0v83a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V55a0,0,0,0,1,0,0Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 87,
                "height": 87,
                "offsetX": 79.5,
                "offsetY": 98.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_13eA4Dbp",
                "shape": {
                    "type": "Path",
                    "data": "M14,36v80a4,4,0,0,0,4,4H29a4,4,0,0,0,4-4V52h93v64a4,4,0,0,0,4,4h12a4,4,0,0,0,4-4V36a4,4,0,0,0-4-4H18A4,4,0,0,0,14,36Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 132,
                "height": 88,
                "offsetX": 80,
                "offsetY": 76,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_1",
                "children": ["SofaSet_12XCFQXo", "SofaSet_13eA4Dbp"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_22SUBRvE",
                "shape": {
                    "type": "Path",
                    "data": "M81,55h51a0,0,0,0,1,0,0v60a4,4,0,0,1-4,4H85a4,4,0,0,1-4-4V55A0,0,0,0,1,81,55Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 51,
                "height": 64,
                "offsetX": 106.5,
                "offsetY": 87,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_23QGu7lj",
                "shape": {
                    "type": "Path",
                    "data": "M27,55H78a0,0,0,0,1,0,0v60a4,4,0,0,1-4,4H31a4,4,0,0,1-4-4V55A0,0,0,0,1,27,55Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 51,
                "height": 64,
                "offsetX": 52.5,
                "offsetY": 87,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_24gal8qg",
                "shape": {
                    "type": "Path",
                    "data": "M5,36v66a4,4,0,0,0,4,4H20a4,4,0,0,0,4-4V52H135v50a4,4,0,0,0,4,4h12a4,4,0,0,0,4-4V36a4,4,0,0,0-4-4H9A4,4,0,0,0,5,36Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 150,
                "height": 74,
                "offsetX": 80,
                "offsetY": 69,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_2",
                "children": ["SofaSet_22SUBRvE", "SofaSet_23QGu7lj", "SofaSet_24gal8qg"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_32H8GE7d",
                "shape": {
                    "type": "Path",
                    "data": "M65,67h36a0,0,0,0,1,0,0v42a4,4,0,0,1-4,4H69a4,4,0,0,1-4-4V67A0,0,0,0,1,65,67Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 36,
                "height": 46,
                "offsetX": 83,
                "offsetY": 90,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_33AMvwdZ",
                "shape": {
                    "type": "Path",
                    "data": "M104,67h36a0,0,0,0,1,0,0v42a4,4,0,0,1-4,4H108a4,4,0,0,1-4-4V67A0,0,0,0,1,104,67Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 36,
                "height": 46,
                "offsetX": 122,
                "offsetY": 90,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_34agikUE",
                "shape": {
                    "type": "Path",
                    "data": "M26,67H62a0,0,0,0,1,0,0v42a4,4,0,0,1-4,4H30a4,4,0,0,1-4-4V67A0,0,0,0,1,26,67Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 36,
                "height": 46,
                "offsetX": 44,
                "offsetY": 90,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_35KEub3T",
                "shape": {
                    "type": "Path",
                    "data": "M9,53.85v47.3A2.86,2.86,0,0,0,11.85,104h8.3A2.86,2.86,0,0,0,23,101.15V65H143v36.15a2.86,2.86,0,0,0,2.85,2.85h8.3a2.86,2.86,0,0,0,2.85-2.85V53.85A2.86,2.86,0,0,0,154.15,51H11.85A2.86,2.86,0,0,0,9,53.85Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 148.00001525878906,
                "height": 53,
                "offsetX": 83.00000762939453,
                "offsetY": 77.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_3",
                "children": ["SofaSet_32H8GE7d", "SofaSet_33AMvwdZ", "SofaSet_34agikUE", "SofaSet_35KEub3T"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_42MwDU0p",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 4
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 38,
                "height": 38,
                "offsetX": 49,
                "offsetY": 103,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_43y8536E",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 4
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 38,
                "height": 38,
                "offsetX": 49,
                "offsetY": 63,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_44IX84wj",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 4
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 38,
                "height": 38,
                "offsetX": 89,
                "offsetY": 63,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_45882ZZN",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 4
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 38,
                "height": 38,
                "offsetX": 129,
                "offsetY": 63,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_46aK4Qo0",
                "shape": {
                    "type": "Path",
                    "data": "M147,27.06,17,27a4,4,0,0,0-4,4h0v90a4,4,0,0,0,4,4h7a4,4,0,0,0,4-4V41.94L147,42a4,4,0,0,0,4-4V31.06A4,4,0,0,0,147,27.06Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 138,
                "height": 98,
                "offsetX": 82,
                "offsetY": 76,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_4",
                "children": ["SofaSet_42MwDU0p", "SofaSet_43y8536E", "SofaSet_44IX84wj", "SofaSet_45882ZZN", "SofaSet_46aK4Qo0"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_Alt2qyX0Ue",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 4
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 87,
                "height": 87,
                "offsetX": 79.5,
                "offsetY": 91.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_Alt3G5L4WA",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 4
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 136,
                "height": 20,
                "offsetX": 80,
                "offsetY": 34,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_Alt4rZiFi8",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 4
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 75,
                "height": 20,
                "offsetX": 137,
                "offsetY": 85.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_Alt5fQluO2",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 4
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 75,
                "height": 20,
                "offsetX": 22,
                "offsetY": 85.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "SofaSet_Alt",
                "children": ["SofaSet_Alt2qyX0Ue", "SofaSet_Alt3G5L4WA", "SofaSet_Alt4rZiFi8", "SofaSet_Alt5fQluO2"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sofa_Table2YcawQH",
                "shape": {
                    "type": "Path",
                    "data": "M133.77 139.27 133.77 139.27 129.53 136.44 130.94 135.03 133.77 139.27"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 4.2400054931640625,
                "height": 4.2400054931640625,
                "offsetX": 131.6500015258789,
                "offsetY": 137.1500015258789,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sofa_Table3zYfciS",
                "shape": {
                    "type": "Path",
                    "data": "M133.77 91.03 133.77 91.03 129.53 93.85 130.94 95.27 133.77 91.03"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 4.2400054931640625,
                "height": 4.239997863769531,
                "offsetX": 131.6500015258789,
                "offsetY": 93.14999771118164,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sofa_Table41eXvIF",
                "shape": {
                    "type": "Path",
                    "data": "M96.53 139.27 96.53 139.27 100.77 136.44 99.35 135.03 96.53 139.27"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 4.239997863769531,
                "height": 4.2400054931640625,
                "offsetX": 98.64999771118164,
                "offsetY": 137.1500015258789,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sofa_Table5q04V70",
                "shape": {
                    "type": "Path",
                    "data": "M95.53 91.03 95.53 91.03 99.77 93.85 98.35 95.27 95.53 91.03"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 4.239997863769531,
                "height": 4.239997863769531,
                "offsetX": 97.64999771118164,
                "offsetY": 93.14999771118164,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sofa_Table6KjYre4",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 54,
                "height": 54,
                "offsetX": 115,
                "offsetY": 115,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sofa_Table7lUZ3FF",
                "shape": {
                    "type": "Path",
                    "data": "M144,39A32.11,32.11,0,0,0,112,9.06h0A32.11,32.11,0,0,0,79.92,39Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 64.07998657226562,
                "height": 29.94002914428711,
                "offsetX": 111.96000671386719,
                "offsetY": 24.029985427856445,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sofa_Table8AOyNBb",
                "shape": {
                    "type": "Path",
                    "data": "M42,85.46a32.11,32.11,0,0,0-29.94,32h0a32.11,32.11,0,0,0,29.94,32Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 29.940006256103516,
                "height": 64.00000762939453,
                "offsetX": 27.02999973297119,
                "offsetY": 117.46000289916992,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sofa_Table9ROOL5g",
                "shape": {
                    "type": "Path",
                    "data": "M112,14h0a26.5,26.5,0,0,1,26.5,26.5V64.28A2.72,2.72,0,0,1,135.74,67H88.18a2.72,2.72,0,0,1-2.72-2.72V40.5A26.5,26.5,0,0,1,112,14Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 53.040000915527344,
                "height": 53.000328063964844,
                "offsetX": 111.97999954223633,
                "offsetY": 40.5001335144043,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sofa_Table10HmJ1Dt",
                "shape": {
                    "type": "Path",
                    "data": "M43.5,91h0A26.5,26.5,0,0,1,70,117.5v23.78A2.72,2.72,0,0,1,67.28,144H19.72A2.72,2.72,0,0,1,17,141.28V117.5A26.5,26.5,0,0,1,43.5,91Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 53.00000762939453,
                "height": 53,
                "offsetX": 43.500003814697266,
                "offsetY": 117.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sofa_Table11kUWhFz",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 50,
                "height": 50,
                "offsetX": 115,
                "offsetY": 115,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Sofa_Table",
                "children": ["Sofa_Table2YcawQH", "Sofa_Table3zYfciS", "Sofa_Table41eXvIF", "Sofa_Table5q04V70", "Sofa_Table6KjYre4", "Sofa_Table7lUZ3FF", "Sofa_Table8AOyNBb", "Sofa_Table9ROOL5g", "Sofa_Table10HmJ1Dt", "Sofa_Table11kUWhFz"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_180FlatTurn20UTila",
                "shape": {
                    "type": "Path",
                    "data": "M137.5 134.5 112 134.5 87.5 134.5 87.5 78.5 74.5 78.5 74.5 134.5 49 134.5 24.5 134.5 24.5 28.5 137.5 28.5 137.5 134.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 113,
                "height": 106,
                "offsetX": 81,
                "offsetY": 81.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_180FlatTurn3LK4bWc",
                "shape": {
                    "type": "Path",
                    "data": "M 74.5 , 78.5 L 24.5 , 78.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 49.5,
                "offsetY": 79,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_180FlatTurn4vEmJnw",
                "shape": {
                    "type": "Path",
                    "data": "M 74.5 , 86.5 L 24.5 , 86.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 49.5,
                "offsetY": 87,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_180FlatTurn5f8AzEV",
                "shape": {
                    "type": "Path",
                    "data": "M 74.5 , 94.5 L 24.5 , 94.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 49.5,
                "offsetY": 95,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_180FlatTurn6m7lveK",
                "shape": {
                    "type": "Path",
                    "data": "M 74.5 , 102.5 L 24.5 , 102.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 49.5,
                "offsetY": 103,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_180FlatTurn7Om3JV2",
                "shape": {
                    "type": "Path",
                    "data": "M 74.5 , 110.5 L 24.5 , 110.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 49.5,
                "offsetY": 111,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_180FlatTurn8r3cpgz",
                "shape": {
                    "type": "Path",
                    "data": "M 74.5 , 118.5 L 24.5 , 118.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 49.5,
                "offsetY": 119,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_180FlatTurn98XjE20",
                "shape": {
                    "type": "Path",
                    "data": "M 137.5 , 78.5 L 87.5 , 78.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 112.5,
                "offsetY": 79,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_180FlatTurn10qkFxCT",
                "shape": {
                    "type": "Path",
                    "data": "M 137.5 , 86.5 L 87.5 , 86.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 112.5,
                "offsetY": 87,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_180FlatTurn11cMVx2M",
                "shape": {
                    "type": "Path",
                    "data": "M 137.5 , 94.5 L 87.5 , 94.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 112.5,
                "offsetY": 95,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_180FlatTurn124zrN94",
                "shape": {
                    "type": "Path",
                    "data": "M 137.5 , 102.5 L 87.5 , 102.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 112.5,
                "offsetY": 103,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_180FlatTurn13vBBEu1",
                "shape": {
                    "type": "Path",
                    "data": "M 137.5 , 110.5 L 87.5 , 110.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 112.5,
                "offsetY": 111,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_180FlatTurn14yXb5Nn",
                "shape": {
                    "type": "Path",
                    "data": "M 137.5 , 118.5 L 87.5 , 118.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 112.5,
                "offsetY": 119,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_180FlatTurn15DdkBx9",
                "shape": {
                    "type": "Path",
                    "data": "M 138 , 126.5 L 88 , 126.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 113,
                "offsetY": 127,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_180FlatTurn16G9QM0S",
                "shape": {
                    "type": "Path",
                    "data": "M 74 , 126.5 L 24 , 126.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 49,
                "offsetY": 127,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_180FlatTurn",
                "children": ["StairCase_180FlatTurn20UTila", "StairCase_180FlatTurn3LK4bWc", "StairCase_180FlatTurn4vEmJnw", "StairCase_180FlatTurn5f8AzEV", "StairCase_180FlatTurn6m7lveK", "StairCase_180FlatTurn7Om3JV2", "StairCase_180FlatTurn8r3cpgz", "StairCase_180FlatTurn98XjE20", "StairCase_180FlatTurn10qkFxCT", "StairCase_180FlatTurn11cMVx2M", "StairCase_180FlatTurn124zrN94", "StairCase_180FlatTurn13vBBEu1", "StairCase_180FlatTurn14yXb5Nn", "StairCase_180FlatTurn15DdkBx9", "StairCase_180FlatTurn16G9QM0S"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90FlatTurn23btWLQ",
                "shape": {
                    "type": "Path",
                    "data": "M80.5 31.5 80.5 138.5 55 138.5 30.5 138.5 30.5 31.5 137.5 31.5 137.5 81.5 30.5 81.5"
                },
                "style": {
                    "fill": "#fff",
                    "strokeColor": "#464747"
                },
                "width": 107,
                "height": 107,
                "offsetX": 84,
                "offsetY": 85,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90FlatTurn3aI4pod",
                "shape": {
                    "type": "Path",
                    "data": "M 89.17 , 31.5 L 89.17 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 89.66999816894531,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90FlatTurn4Wg5jgE",
                "shape": {
                    "type": "Path",
                    "data": "M 97.33 , 31.5 L 97.33 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 97.83000183105469,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90FlatTurn5xTbrxm",
                "shape": {
                    "type": "Path",
                    "data": "M 105.5 , 31.5 L 105.5 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 106,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90FlatTurn6U8JK6D",
                "shape": {
                    "type": "Path",
                    "data": "M 113.67 , 31.5 L 113.67 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 114.16999816894531,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90FlatTurn78BffSC",
                "shape": {
                    "type": "Path",
                    "data": "M 121.83 , 31.5 L 121.83 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 122.33000183105469,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90FlatTurn841UKWX",
                "shape": {
                    "type": "Path",
                    "data": "M 130 , 31.5 L 130 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 130.5,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90FlatTurn9dTAn0b",
                "shape": {
                    "type": "Path",
                    "data": "M 80.5 , 90.17 L 30.5 , 90.17"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 55.5,
                "offsetY": 90.66999816894531,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90FlatTurn10XGPM5T",
                "shape": {
                    "type": "Path",
                    "data": "M 80.5 , 98.33 L 30.5 , 98.33"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 55.5,
                "offsetY": 98.83000183105469,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90FlatTurn11wGh0P3",
                "shape": {
                    "type": "Path",
                    "data": "M 80.5 , 106.5 L 30.5 , 106.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 55.5,
                "offsetY": 107,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90FlatTurn12ouX1zD",
                "shape": {
                    "type": "Path",
                    "data": "M 80.5 , 114.67 L 30.5 , 114.67"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 55.5,
                "offsetY": 115.16999816894531,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90FlatTurn13UCanGm",
                "shape": {
                    "type": "Path",
                    "data": "M 80.5 , 122.83 L 30.5 , 122.83"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 55.5,
                "offsetY": 123.33000183105469,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90FlatTurn14bRv5IH",
                "shape": {
                    "type": "Path",
                    "data": "M 80.5 , 131 L 30.5 , 131"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 55.5,
                "offsetY": 131.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90FlatTurn",
                "children": ["StairCase_90FlatTurn23btWLQ", "StairCase_90FlatTurn3aI4pod", "StairCase_90FlatTurn4Wg5jgE", "StairCase_90FlatTurn5xTbrxm", "StairCase_90FlatTurn6U8JK6D", "StairCase_90FlatTurn78BffSC", "StairCase_90FlatTurn841UKWX", "StairCase_90FlatTurn9dTAn0b", "StairCase_90FlatTurn10XGPM5T", "StairCase_90FlatTurn11wGh0P3", "StairCase_90FlatTurn12ouX1zD", "StairCase_90FlatTurn13UCanGm", "StairCase_90FlatTurn14bRv5IH"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90ShortRadius2rMq2xG",
                "shape": {
                    "type": "Path",
                    "data": "M84.5 31.5 84.5 138.5 59 138.5 34.5 138.5 34.5 31.5 141.5 31.5 141.5 81.5 34.5 81.5"
                },
                "style": {
                    "fill": "#fff",
                    "strokeColor": "#464747"
                },
                "width": 107,
                "height": 107,
                "offsetX": 88,
                "offsetY": 85,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90ShortRadius3zbLbvd",
                "shape": {
                    "type": "Path",
                    "data": "M 93.17 , 31.5 L 93.17 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 93.66999816894531,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90ShortRadius4PSMaSI",
                "shape": {
                    "type": "Path",
                    "data": "M 101.33 , 31.5 L 101.33 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 101.83000183105469,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90ShortRadius5Yj4uvH",
                "shape": {
                    "type": "Path",
                    "data": "M 109.5 , 31.5 L 109.5 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 110,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90ShortRadius6Gw40aY",
                "shape": {
                    "type": "Path",
                    "data": "M 117.67 , 31.5 L 117.67 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 118.16999816894531,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90ShortRadius7FHkYgZ",
                "shape": {
                    "type": "Path",
                    "data": "M 125.83 , 31.5 L 125.83 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 126.33000183105469,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90ShortRadius8yER9mo",
                "shape": {
                    "type": "Path",
                    "data": "M 134 , 31.5 L 134 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 134.5,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90ShortRadius9qs9u8G",
                "shape": {
                    "type": "Path",
                    "data": "M 84.5 , 90.17 L 34.5 , 90.17"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 59.5,
                "offsetY": 90.66999816894531,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90ShortRadius10hVS890",
                "shape": {
                    "type": "Path",
                    "data": "M 84.5 , 98.33 L 34.5 , 98.33"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 59.5,
                "offsetY": 98.83000183105469,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90ShortRadius11nypuwP",
                "shape": {
                    "type": "Path",
                    "data": "M 84.5 , 106.5 L 34.5 , 106.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 59.5,
                "offsetY": 107,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90ShortRadius12mZtaus",
                "shape": {
                    "type": "Path",
                    "data": "M 84.5 , 114.67 L 34.5 , 114.67"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 59.5,
                "offsetY": 115.16999816894531,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90ShortRadius13gRtIrs",
                "shape": {
                    "type": "Path",
                    "data": "M 84.5 , 122.83 L 34.5 , 122.83"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 59.5,
                "offsetY": 123.33000183105469,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90ShortRadius14eUAOJU",
                "shape": {
                    "type": "Path",
                    "data": "M 84.5 , 131 L 34.5 , 131"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 59.5,
                "offsetY": 131.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90ShortRadius15pUhM2U",
                "shape": {
                    "type": "Path",
                    "data": "M34.5 53.66 84.2 81.5 57.2 31.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 49.69999694824219,
                "height": 50,
                "offsetX": 59.349998474121094,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90ShortRadius",
                "children": ["StairCase_90ShortRadius2rMq2xG", "StairCase_90ShortRadius3zbLbvd", "StairCase_90ShortRadius4PSMaSI", "StairCase_90ShortRadius5Yj4uvH", "StairCase_90ShortRadius6Gw40aY", "StairCase_90ShortRadius7FHkYgZ", "StairCase_90ShortRadius8yER9mo", "StairCase_90ShortRadius9qs9u8G", "StairCase_90ShortRadius10hVS890", "StairCase_90ShortRadius11nypuwP", "StairCase_90ShortRadius12mZtaus", "StairCase_90ShortRadius13gRtIrs", "StairCase_90ShortRadius14eUAOJU", "StairCase_90ShortRadius15pUhM2U"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90LargeRadius22oiZOW",
                "shape": {
                    "type": "Path",
                    "data": "M81.5,31.5v107h-50v-85a22,22,0,0,1,22-22h85v50H31.5"
                },
                "style": {
                    "fill": "#fff",
                    "strokeColor": "#464747",
                    "strokeWidth": 0
                },
                "width": 107,
                "height": 107,
                "offsetX": 85,
                "offsetY": 85,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90LargeRadius3JPMLbL",
                "shape": {
                    "type": "Path",
                    "data": "M 90.17 , 31.5 L 90.17 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 90.66999816894531,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90LargeRadius4DR15W1",
                "shape": {
                    "type": "Path",
                    "data": "M 98.33 , 31.5 L 98.33 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 98.83000183105469,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90LargeRadius5T8xmxU",
                "shape": {
                    "type": "Path",
                    "data": "M 106.5 , 31.5 L 106.5 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 107,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90LargeRadius6MVPWx9",
                "shape": {
                    "type": "Path",
                    "data": "M 114.67 , 31.5 L 114.67 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 115.16999816894531,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90LargeRadius7RrkfbB",
                "shape": {
                    "type": "Path",
                    "data": "M 122.83 , 31.5 L 122.83 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 123.33000183105469,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90LargeRadius84g3KQ5",
                "shape": {
                    "type": "Path",
                    "data": "M 131 , 31.5 L 131 , 81.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 131.5,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90LargeRadius9WsFDgp",
                "shape": {
                    "type": "Path",
                    "data": "M 81.5 , 90.17 L 31.5 , 90.17"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 56.5,
                "offsetY": 90.66999816894531,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90LargeRadius10HSuWhf",
                "shape": {
                    "type": "Path",
                    "data": "M 81.5 , 98.33 L 31.5 , 98.33"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 56.5,
                "offsetY": 98.83000183105469,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90LargeRadius113FUOzK",
                "shape": {
                    "type": "Path",
                    "data": "M 81.5 , 106.5 L 31.5 , 106.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 56.5,
                "offsetY": 107,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90LargeRadius12Z8yhZm",
                "shape": {
                    "type": "Path",
                    "data": "M 81.5 , 114.67 L 31.5 , 114.67"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 56.5,
                "offsetY": 115.16999816894531,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90LargeRadius13jA9Tu7",
                "shape": {
                    "type": "Path",
                    "data": "M 81.5 , 122.83 L 31.5 , 122.83"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 56.5,
                "offsetY": 123.33000183105469,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90LargeRadius14IWIWQ9",
                "shape": {
                    "type": "Path",
                    "data": "M 81.5 , 131 L 31.5 , 131"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 56.5,
                "offsetY": 131.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90LargeRadius15Jh1AWf",
                "shape": {
                    "type": "Path",
                    "data": "M31.5 53.66 81.2 81.5 54.2 31.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 49.69999694824219,
                "height": 50,
                "offsetX": 56.349998474121094,
                "offsetY": 56.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_90LargeRadius",
                "children": ["StairCase_90LargeRadius22oiZOW", "StairCase_90LargeRadius3JPMLbL", "StairCase_90LargeRadius4DR15W1", "StairCase_90LargeRadius5T8xmxU", "StairCase_90LargeRadius6MVPWx9", "StairCase_90LargeRadius7RrkfbB", "StairCase_90LargeRadius84g3KQ5", "StairCase_90LargeRadius9WsFDgp", "StairCase_90LargeRadius10HSuWhf", "StairCase_90LargeRadius113FUOzK", "StairCase_90LargeRadius12Z8yhZm", "StairCase_90LargeRadius13jA9Tu7", "StairCase_90LargeRadius14IWIWQ9", "StairCase_90LargeRadius15Jh1AWf"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn2WoU9BA",
                "shape": {
                    "type": "Path",
                    "data": "M 72.5 , 79.5 L 22.5 , 79.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 47.5,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn3FyqAlg",
                "shape": {
                    "type": "Path",
                    "data": "M 72.5 , 87.5 L 22.5 , 87.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 47.5,
                "offsetY": 88,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn4WJNDyb",
                "shape": {
                    "type": "Path",
                    "data": "M 72.5 , 95.5 L 22.5 , 95.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 47.5,
                "offsetY": 96,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn5CPae2M",
                "shape": {
                    "type": "Path",
                    "data": "M 72.5 , 103.5 L 22.5 , 103.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 47.5,
                "offsetY": 104,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn6fdG4e8",
                "shape": {
                    "type": "Path",
                    "data": "M 72.5 , 111.5 L 22.5 , 111.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 47.5,
                "offsetY": 112,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn7oLvFIF",
                "shape": {
                    "type": "Path",
                    "data": "M 72.5 , 119.5 L 22.5 , 119.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 47.5,
                "offsetY": 120,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn8ZYPvUf",
                "shape": {
                    "type": "Path",
                    "data": "M 72.5 , 127.5 L 22.5 , 127.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 47.5,
                "offsetY": 128,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn9IgjIgq",
                "shape": {
                    "type": "Path",
                    "data": "M 142.5 , 127.5 L 92.5 , 127.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 117.5,
                "offsetY": 128,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn10XmDT4e",
                "shape": {
                    "type": "Path",
                    "data": "M72.5 79.5 72.5 134.5 47 134.5 22.5 134.5 22.5 28.5 142.5 28.5 142.5 134.5 117 134.5 92.5 134.5 92.5 79.5 72.5 79.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 120,
                "height": 106,
                "offsetX": 82.5,
                "offsetY": 81.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn11sVZNhS",
                "shape": {
                    "type": "Path",
                    "data": "M 142.5 , 79.5 L 92.5 , 79.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 117.5,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn12tbp1lD",
                "shape": {
                    "type": "Path",
                    "data": "M 142.5 , 87.5 L 92.5 , 87.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 117.5,
                "offsetY": 88,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn13qd3qME",
                "shape": {
                    "type": "Path",
                    "data": "M 142.5 , 95.5 L 92.5 , 95.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 117.5,
                "offsetY": 96,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn14v9njBX",
                "shape": {
                    "type": "Path",
                    "data": "M 142.5 , 103.5 L 92.5 , 103.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 117.5,
                "offsetY": 104,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn15aclP9t",
                "shape": {
                    "type": "Path",
                    "data": "M 142.5 , 111.5 L 92.5 , 111.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 117.5,
                "offsetY": 112,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn169OziZR",
                "shape": {
                    "type": "Path",
                    "data": "M 142.5 , 119.5 L 92.5 , 119.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 50,
                "height": 1,
                "offsetX": 117.5,
                "offsetY": 120,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn17G30EXp",
                "shape": {
                    "type": "Path",
                    "data": "M 79.5 , 79.5 L 79.5 , 28.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 51,
                "offsetX": 80,
                "offsetY": 54,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn18thrS4i",
                "shape": {
                    "type": "Path",
                    "data": "M 92.5 , 79.5 L 92.5 , 28.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 51,
                "offsetX": 93,
                "offsetY": 54,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn19eUe5bP",
                "shape": {
                    "type": "Path",
                    "data": "M 86.5 , 79.5 L 86.5 , 28.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 51,
                "offsetX": 87,
                "offsetY": 54,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn20SkrJ1l",
                "shape": {
                    "type": "Path",
                    "data": "M 72.5 , 79.5 L 72.5 , 28.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 51,
                "offsetX": 73,
                "offsetY": 54,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Double90_FlatTurn",
                "children": ["StairCase_Double90_FlatTurn2WoU9BA", "StairCase_Double90_FlatTurn3FyqAlg", "StairCase_Double90_FlatTurn4WJNDyb", "StairCase_Double90_FlatTurn5CPae2M", "StairCase_Double90_FlatTurn6fdG4e8", "StairCase_Double90_FlatTurn7oLvFIF", "StairCase_Double90_FlatTurn8ZYPvUf", "StairCase_Double90_FlatTurn9IgjIgq", "StairCase_Double90_FlatTurn10XmDT4e", "StairCase_Double90_FlatTurn11sVZNhS", "StairCase_Double90_FlatTurn12tbp1lD", "StairCase_Double90_FlatTurn13qd3qME", "StairCase_Double90_FlatTurn14v9njBX", "StairCase_Double90_FlatTurn15aclP9t", "StairCase_Double90_FlatTurn169OziZR", "StairCase_Double90_FlatTurn17G30EXp", "StairCase_Double90_FlatTurn18thrS4i", "StairCase_Double90_FlatTurn19eUe5bP", "StairCase_Double90_FlatTurn20SkrJ1l"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Normal2IKsqJF",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff",
                    "strokeColor": "#464747"
                },
                "width": 104,
                "height": 50,
                "offsetX": 77.5,
                "offsetY": 80.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Normal37nDh61",
                "shape": {
                    "type": "Path",
                    "data": "M 33.5 , 56 L 33.5 , 106"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 34,
                "offsetY": 81,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Normal4K9ziiJ",
                "shape": {
                    "type": "Path",
                    "data": "M 41.5 , 56 L 41.5 , 106"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 42,
                "offsetY": 81,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Normal5W3Ads3",
                "shape": {
                    "type": "Path",
                    "data": "M 49.5 , 56 L 49.5 , 106"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 50,
                "offsetY": 81,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Normal6S07a0R",
                "shape": {
                    "type": "Path",
                    "data": "M 65.5 , 56 L 65.5 , 106"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 66,
                "offsetY": 81,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Normal76bOuVB",
                "shape": {
                    "type": "Path",
                    "data": "M 57.5 , 56 L 57.5 , 106"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 58,
                "offsetY": 81,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Normal8Mx5v5e",
                "shape": {
                    "type": "Path",
                    "data": "M 73.5 , 56 L 73.5 , 106"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 74,
                "offsetY": 81,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Normal9aetpwv",
                "shape": {
                    "type": "Path",
                    "data": "M 81.5 , 56 L 81.5 , 106"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 82,
                "offsetY": 81,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Normal105Gq5lk",
                "shape": {
                    "type": "Path",
                    "data": "M 89.5 , 56 L 89.5 , 106"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 90,
                "offsetY": 81,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Normal11XfjL21",
                "shape": {
                    "type": "Path",
                    "data": "M 97.5 , 56 L 97.5 , 106"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 98,
                "offsetY": 81,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Normal12rKJKRl",
                "shape": {
                    "type": "Path",
                    "data": "M 105.5 , 56 L 105.5 , 106"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 106,
                "offsetY": 81,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Normal13a5Yrd2",
                "shape": {
                    "type": "Path",
                    "data": "M 113.5 , 56 L 113.5 , 106"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 114,
                "offsetY": 81,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Normal14TsLydR",
                "shape": {
                    "type": "Path",
                    "data": "M 121.5 , 56 L 121.5 , 106"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 1,
                "height": 50,
                "offsetX": 122,
                "offsetY": 81,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StairCase_Normal",
                "children": ["StairCase_Normal2IKsqJF", "StairCase_Normal37nDh61", "StairCase_Normal4K9ziiJ", "StairCase_Normal5W3Ads3", "StairCase_Normal6S07a0R", "StairCase_Normal76bOuVB", "StairCase_Normal8Mx5v5e", "StairCase_Normal9aetpwv", "StairCase_Normal105Gq5lk", "StairCase_Normal11XfjL21", "StairCase_Normal12rKJKRl", "StairCase_Normal13a5Yrd2", "StairCase_Normal14TsLydR"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable2lK9vyA",
                "shape": {
                    "type": "Path",
                    "data": "M140.78,52.89H18.85a6,6,0,0,0-6,6v41a6,6,0,0,0,6,6h1.83s0,0,0,.07l2.59,7a1.38,1.38,0,0,0,1.76.81,1.37,1.37,0,0,0,.81-1.76l-2.27-6.15H136L133.7,112a1.37,1.37,0,0,0,2.57.95l2.59-7a.19.19,0,0,0,0-.07h1.9a6,6,0,0,0,6-6v-41A6,6,0,0,0,140.78,52.89Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 133.9099884033203,
                "height": 60.96217346191406,
                "offsetX": 79.80499458312988,
                "offsetY": 83.37108612060547,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable",
                "children": ["StudyTable2lK9vyA"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp28HLLXG",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 1.37
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 2.740000009536743,
                "height": 10.230000495910645,
                "offsetX": 21.460000157356262,
                "offsetY": 100.82499933242798,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp3yLTOEk",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 1.37
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 2.740000009536743,
                "height": 10.230000495910645,
                "offsetX": 134.459996342659,
                "offsetY": 100.82499933242798,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp4Q1fVn3",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 6
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 133.9300079345703,
                "height": 52.96000289916992,
                "offsetX": 78.00500392913818,
                "offsetY": 71.22000312805176,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp5CEoNhO",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 14.479999542236328,
                "height": 14.479999542236328,
                "offsetX": 132.33000373840332,
                "offsetY": 61.75999641418457,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp7Oa2WbN",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 11.77
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 23.540000915527344,
                "height": 24.51999855041504,
                "offsetX": 112.42000961303711,
                "offsetY": 60.910000801086426,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp8iN6CLs",
                "shape": {
                    "type": "Path",
                    "data": "M70,60.22V87.45l.11,0a37.71,37.71,0,0,1,19.78,0l.11,0V60.22l-.11,0a37.71,37.71,0,0,0-19.78,0Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 20,
                "height": 28.54999542236328,
                "offsetX": 80,
                "offsetY": 73.17499923706055,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp9GTnyYM",
                "shape": {
                    "type": "Path",
                    "data": "M69,60.22l-.11,0a37.71,37.71,0,0,0-19.78,0l-.11,0V87.45l.11,0a37.71,37.71,0,0,1,19.78,0l.11,0Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 20,
                "height": 28.54999542236328,
                "offsetX": 59,
                "offsetY": 73.17499923706055,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp10LHWlHn",
                "shape": {
                    "type": "Path",
                    "data": "M 74 , 65.5 L 87 , 65.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 13,
                "height": 1,
                "offsetX": 80.5,
                "offsetY": 66,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp11bmwbpw",
                "shape": {
                    "type": "Path",
                    "data": "M 74 , 68.5 L 84 , 68.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 10,
                "height": 1,
                "offsetX": 79,
                "offsetY": 69,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp12VPBHVr",
                "shape": {
                    "type": "Path",
                    "data": "M 74 , 71.5 L 87 , 71.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 13,
                "height": 1,
                "offsetX": 80.5,
                "offsetY": 72,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp1356IX6t",
                "shape": {
                    "type": "Path",
                    "data": "M 74 , 74.5 L 85 , 74.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 11,
                "height": 1,
                "offsetX": 79.5,
                "offsetY": 75,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp149cQByZ",
                "shape": {
                    "type": "Path",
                    "data": "M 74 , 77.5 L 87 , 77.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 13,
                "height": 1,
                "offsetX": 80.5,
                "offsetY": 78,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp15gvWD4m",
                "shape": {
                    "type": "Path",
                    "data": "M 74 , 80.5 L 80 , 80.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 6,
                "height": 1,
                "offsetX": 77,
                "offsetY": 81,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp16V3gEQY",
                "shape": {
                    "type": "Path",
                    "data": "M 52.5 , 65.5 L 65.5 , 65.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 13,
                "height": 1,
                "offsetX": 59,
                "offsetY": 66,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp177lIe3n",
                "shape": {
                    "type": "Path",
                    "data": "M 52.5 , 68.5 L 62.5 , 68.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 10,
                "height": 1,
                "offsetX": 57.5,
                "offsetY": 69,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp18ZzDC5d",
                "shape": {
                    "type": "Path",
                    "data": "M 52.5 , 71.5 L 65.5 , 71.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 13,
                "height": 1,
                "offsetX": 59,
                "offsetY": 72,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp19EE2tXw",
                "shape": {
                    "type": "Path",
                    "data": "M 52.5 , 74.5 L 63.5 , 74.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 11,
                "height": 1,
                "offsetX": 58,
                "offsetY": 75,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp20ZrN5on",
                "shape": {
                    "type": "Path",
                    "data": "M 52.5 , 77.5 L 65.5 , 77.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 13,
                "height": 1,
                "offsetX": 59,
                "offsetY": 78,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp21kOY0nx",
                "shape": {
                    "type": "Path",
                    "data": "M 52.5 , 80.5 L 58.5 , 80.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#cdd1d3",
                    "strokeWidth": 1
                },
                "width": 6,
                "height": 1,
                "offsetX": 55.5,
                "offsetY": 81,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp22MT6Jaa",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 1.9600000381469727,
                "height": 1.9600000381469727,
                "offsetX": 127.0199933052063,
                "offsetY": 62.27000093460083,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp23EHQdEA",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#5e320d"
                },
                "width": 4.059999942779541,
                "height": 4.059999942779541,
                "offsetX": 131.97000241279602,
                "offsetY": 62.11000180244446,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp24eTOTuI",
                "shape": {
                    "type": "Path",
                    "data": "M131.91,63l-.14,0a.5.5,0,0,1-.34-.62l1.79-6.11L119.64,59a.51.51,0,0,1-.59-.4.49.49,0,0,1,.4-.58l14.38-2.88a.5.5,0,0,1,.58.63l-2,6.9A.49.49,0,0,1,131.91,63Z"
                },
                "style": {
                    "fill": "#5e320d",
                    "strokeWidth": 0
                },
                "width": 15.389640808105469,
                "height": 7.871467590332031,
                "offsetX": 126.73520278930664,
                "offsetY": 59.06562042236328,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp25hf7gzd",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#5e320d"
                },
                "width": 11.40000057220459,
                "height": 11.40000057220459,
                "offsetX": 114.08999967575073,
                "offsetY": 60.11999845504761,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "StudyTable_Lamp",
                "children": ["StudyTable_Lamp28HLLXG", "StudyTable_Lamp3yLTOEk", "StudyTable_Lamp4Q1fVn3", "StudyTable_Lamp5CEoNhO", "StudyTable_Lamp7Oa2WbN", "StudyTable_Lamp8iN6CLs", "StudyTable_Lamp9GTnyYM", "StudyTable_Lamp10LHWlHn", "StudyTable_Lamp11bmwbpw", "StudyTable_Lamp12VPBHVr", "StudyTable_Lamp1356IX6t", "StudyTable_Lamp149cQByZ", "StudyTable_Lamp15gvWD4m", "StudyTable_Lamp16V3gEQY", "StudyTable_Lamp177lIe3n", "StudyTable_Lamp18ZzDC5d", "StudyTable_Lamp19EE2tXw", "StudyTable_Lamp20ZrN5on", "StudyTable_Lamp21kOY0nx", "StudyTable_Lamp22MT6Jaa", "StudyTable_Lamp23EHQdEA", "StudyTable_Lamp24eTOTuI", "StudyTable_Lamp25hf7gzd"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "TableWithTV2AIDRCg",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 148,
                "height": 38,
                "offsetX": 82,
                "offsetY": 61,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "TableWithTV3oyptwF",
                "shape": {
                    "type": "Path",
                    "data": "M144.79 91 19.21 91 8 80 156 80 144.79 91"
                },
                "style": {
                    "fill": "#442409"
                },
                "width": 148,
                "height": 11,
                "offsetX": 82,
                "offsetY": 85.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "TableWithTV4b8Ysa5",
                "shape": {
                    "type": "Path",
                    "data": "M147 86.19 16 86 10.74 81 152.7 81 147 86.19"
                },
                "style": {
                    "fill": "#301709"
                },
                "width": 141.95999145507812,
                "height": 5.19000244140625,
                "offsetX": 81.71999549865723,
                "offsetY": 83.59500122070312,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "TableWithTV5pvaKMy",
                "shape": {
                    "type": "Path",
                    "data": "M146.37 87 16.95 87 20 90 142.64 90 146.37 87"
                },
                "style": {
                    "fill": "#301709"
                },
                "width": 129.4199981689453,
                "height": 3,
                "offsetX": 81.65999984741211,
                "offsetY": 88.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "TableWithTV66eK8Ub",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#a5a5a5"
                },
                "width": 18,
                "height": 18,
                "offsetX": 82,
                "offsetY": 61,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "TableWithTV76UWM4Q",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#cecdcc"
                },
                "width": 93,
                "height": 2,
                "offsetX": 81.5,
                "offsetY": 55,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "TableWithTV8uGlHmo",
                "shape": {
                    "type": "Path",
                    "data": "M120.17 67 42.83 67 35 56 128 56 120.17 67"
                },
                "style": {},
                "width": 93,
                "height": 11,
                "offsetX": 81.5,
                "offsetY": 61.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "TableWithTV90IVgwNC",
                "shape": {
                    "type": "Path",
                    "data": "M119.63 66 43.35 66 36.95 57 125.85 57 119.63 66"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 88.89999389648438,
                "height": 9,
                "offsetX": 81.39999771118164,
                "offsetY": 61.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "TableWithTV101QMIAw",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 0.14
                },
                "style": {
                    "fill": "#cecdcc"
                },
                "width": 8.980000495910645,
                "height": 3.369999885559082,
                "offsetX": 138.26000452041626,
                "offsetY": 69.23499536514282,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "TableWithTV",
                "children": ["TableWithTV2AIDRCg", "TableWithTV3oyptwF", "TableWithTV4b8Ysa5", "TableWithTV5pvaKMy", "TableWithTV66eK8Ub", "TableWithTV76UWM4Q", "TableWithTV8uGlHmo", "TableWithTV90IVgwNC", "TableWithTV101QMIAw"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "TableLamp2YIRMzh",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 43,
                "height": 43,
                "offsetX": 115.5,
                "offsetY": 82.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "TableLamp4TEH9Mb",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 34.5
                },
                "style": {
                    "fill": "#dda54a"
                },
                "width": 69,
                "height": 72,
                "offsetX": 56.5,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "TableLamp5et6qHQ",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 6,
                "height": 6,
                "offsetX": 100,
                "offsetY": 84,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "TableLamp6LhJqQA",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#5e320d"
                },
                "width": 12,
                "height": 12,
                "offsetX": 115,
                "offsetY": 84,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "TableLamp7saLOXz",
                "shape": {
                    "type": "Path",
                    "data": "M114.38,86.44a1.52,1.52,0,0,1-.42-.06,1.48,1.48,0,0,1-1-1.83l5.28-18-40,8a1.51,1.51,0,0,1-1.74-1.16,1.48,1.48,0,0,1,1.16-1.74l42.44-8.48a1.44,1.44,0,0,1,1.37.45,1.46,1.46,0,0,1,.33,1.41l-6,20.35A1.46,1.46,0,0,1,114.38,86.44Z"
                },
                "style": {
                    "fill": "#5e320d",
                    "strokeWidth": 0
                },
                "width": 45.38905334472656,
                "height": 23.300857543945312,
                "offsetX": 99.1660385131836,
                "offsetY": 74.7896728515625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "TableLamp8bI9pdY",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#5e320d"
                },
                "width": 34,
                "height": 34,
                "offsetX": 62,
                "offsetY": 78,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "TableLamp",
                "children": ["TableLamp2YIRMzh", "TableLamp4TEH9Mb", "TableLamp5et6qHQ", "TableLamp6LhJqQA", "TableLamp7saLOXz", "TableLamp8bI9pdY"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Television2zahwzz",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#a5a5a5"
                },
                "width": 18,
                "height": 18,
                "offsetX": 82,
                "offsetY": 84,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Television3FzDGXj",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#cecdcc"
                },
                "width": 93,
                "height": 2,
                "offsetX": 81.5,
                "offsetY": 78,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Television4vrzmXL",
                "shape": {
                    "type": "Path",
                    "data": "M120.17 90 42.83 90 35 79 128 79 120.17 90"
                },
                "style": {},
                "width": 93,
                "height": 11,
                "offsetX": 81.5,
                "offsetY": 84.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Television50IjHikd",
                "shape": {
                    "type": "Path",
                    "data": "M119.63 89 43.35 89 36.95 80 125.85 80 119.63 89"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 88.89999389648438,
                "height": 9,
                "offsetX": 81.39999771118164,
                "offsetY": 84.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Television",
                "children": ["Television2zahwzz", "Television3FzDGXj", "Television4vrzmXL", "Television50IjHikd"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles12jAHA2l",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#289"
                },
                "width": 160,
                "height": 160,
                "offsetX": 80,
                "offsetY": 80,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles130RQ24IJ",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 30,
                "offsetY": 10,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1311wh3Q2",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 70,
                "offsetY": 10,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles132u8mbYF",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 110,
                "offsetY": 10,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles133wfXfqh",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 150,
                "offsetY": 10,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles134xIF2YH",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 10,
                "offsetY": 30,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles135yzkRs5",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 50,
                "offsetY": 30,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles136vccOuu",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 90,
                "offsetY": 30,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles137KuU74g",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 130,
                "offsetY": 30,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1387W1hK5",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 30,
                "offsetY": 50,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles139NlRTRH",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 70,
                "offsetY": 50,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1310Dq1KDt",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 110,
                "offsetY": 50,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1311NVdrgh",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 150,
                "offsetY": 50,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1312RyIZdn",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 10,
                "offsetY": 70,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1313QD4WrG",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 50,
                "offsetY": 70,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1314xwrFzS",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 90,
                "offsetY": 70,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1315vVh1EZ",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 130,
                "offsetY": 70,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1316Ceas8Q",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 30,
                "offsetY": 90,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles131783nQmJ",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 70,
                "offsetY": 90,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1318vNZgX1",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 110,
                "offsetY": 90,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1319yY3Cbk",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 150,
                "offsetY": 90,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1320crSEiQ",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 10,
                "offsetY": 110,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1321ImDCKI",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 50,
                "offsetY": 110,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1322glorsN",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 90,
                "offsetY": 110,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1323Yf3n5R",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 130,
                "offsetY": 110,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles13249kgazf",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 30,
                "offsetY": 130,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1325Ua90aM",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 70,
                "offsetY": 130,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1326zPvsT9",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 110,
                "offsetY": 130,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1327OV9VkE",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 150,
                "offsetY": 130,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1328dGHjEU",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 10,
                "offsetY": 150,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles13299cSgAa",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 50,
                "offsetY": 150,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1330PylPtW",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 90,
                "offsetY": 150,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1331qQ7pd4",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 20,
                "height": 20,
                "offsetX": 130,
                "offsetY": 150,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles1",
                "children": ["Tiles12jAHA2l", "Tiles130RQ24IJ", "Tiles1311wh3Q2", "Tiles132u8mbYF", "Tiles133wfXfqh", "Tiles134xIF2YH", "Tiles135yzkRs5", "Tiles136vccOuu", "Tiles137KuU74g", "Tiles1387W1hK5", "Tiles139NlRTRH", "Tiles1310Dq1KDt", "Tiles1311NVdrgh", "Tiles1312RyIZdn", "Tiles1313QD4WrG", "Tiles1314xwrFzS", "Tiles1315vVh1EZ", "Tiles1316Ceas8Q", "Tiles131783nQmJ", "Tiles1318vNZgX1", "Tiles1319yY3Cbk", "Tiles1320crSEiQ", "Tiles1321ImDCKI", "Tiles1322glorsN", "Tiles1323Yf3n5R", "Tiles13249kgazf", "Tiles1325Ua90aM", "Tiles1326zPvsT9", "Tiles1327OV9VkE", "Tiles1328dGHjEU", "Tiles13299cSgAa", "Tiles1330PylPtW", "Tiles1331qQ7pd4"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles22stmjVB",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#289"
                },
                "width": 159.80999755859375,
                "height": 159.80999755859375,
                "offsetX": 80.00499878078699,
                "offsetY": 80.00499878078699,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles230DHUNEu",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 30.059999465942383,
                "offsetY": 10.08999977260828,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2310HbO1H",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 70.01000022888184,
                "offsetY": 10.08999977260828,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2324NrfYo",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 109.97000312805176,
                "offsetY": 10.08999977260828,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles233G9wEA3",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 10.08999977260828,
                "offsetY": 30.059999465942383,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles234vlevSv",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 149.92000770568848,
                "offsetY": 10.08999977260828,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles235qFW9rH",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 50.03999900817871,
                "offsetY": 30.059999465942383,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles236M6fxih",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 89.98999977111816,
                "offsetY": 30.059999465942383,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles237HnZRNG",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 129.94000434875488,
                "offsetY": 30.059999465942383,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles238UvvOaU",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 30.059999465942383,
                "offsetY": 50.03999900817871,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles239JjVYZp",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 70.01000022888184,
                "offsetY": 50.03999900817871,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles23102tLpjo",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 109.97000312805176,
                "offsetY": 50.03999900817871,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2311e4R47b",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 149.92000770568848,
                "offsetY": 50.03999900817871,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2312zf28hR",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 10.08999977260828,
                "offsetY": 70.01000022888184,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles23130E1j60",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 50.03999900817871,
                "offsetY": 70.01000022888184,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2314xJQnGN",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 89.98999977111816,
                "offsetY": 70.01000022888184,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2315kNtOrL",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 129.94000434875488,
                "offsetY": 70.01000022888184,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2316E60RtB",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 30.059999465942383,
                "offsetY": 89.98999977111816,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles23172q94Sv",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 70.01000022888184,
                "offsetY": 89.98999977111816,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2318OGZSf7",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 109.97000312805176,
                "offsetY": 89.98999977111816,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2319K6Kpth",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 149.92000770568848,
                "offsetY": 89.98999977111816,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles23202rxWyi",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 10.08999977260828,
                "offsetY": 109.97000312805176,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2321FGBgJa",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 50.03999900817871,
                "offsetY": 109.97000312805176,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2322w6WTmI",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 89.98999977111816,
                "offsetY": 109.97000312805176,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles23239gzTTG",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 129.94000434875488,
                "offsetY": 109.97000312805176,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2324pxH3YP",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 30.059999465942383,
                "offsetY": 129.94000434875488,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2325YZnonY",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 70.01000022888184,
                "offsetY": 129.94000434875488,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2326UsvPTq",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 109.97000312805176,
                "offsetY": 129.94000434875488,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2327bDzXUM",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 149.92000770568848,
                "offsetY": 129.94000434875488,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2328kxdVgb",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 10.08999977260828,
                "offsetY": 149.92000770568848,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles23298te1GM",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 50.03999900817871,
                "offsetY": 149.92000770568848,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2330G4Whs8",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 89.98999977111816,
                "offsetY": 149.92000770568848,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2331QWRFci",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.979999542236328,
                "height": 19.979999542236328,
                "offsetX": 129.94000434875488,
                "offsetY": 149.92000770568848,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles240Whd4Kt",
                "shape": {
                    "type": "Path",
                    "data": "M 20.22 , 139.93 L 20.22 , 159.9"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.970001220703125,
                "offsetX": 20.719999313354492,
                "offsetY": 149.9149932861328,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles241TF9wL6",
                "shape": {
                    "type": "Path",
                    "data": "M 0.1 , 20.07 L 159.9 , 20.07"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 159.79998779296875,
                "height": 1,
                "offsetX": 79.99999389797449,
                "offsetY": 20.56999969482422,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2420zOd8k",
                "shape": {
                    "type": "Path",
                    "data": "M 0.1 , 40.05 L 159.9 , 40.05"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 159.79998779296875,
                "height": 1,
                "offsetX": 79.99999389797449,
                "offsetY": 40.54999923706055,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles243GNbmfh",
                "shape": {
                    "type": "Path",
                    "data": "M 0.1 , 60.02 L 159.9 , 60.02"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 159.79998779296875,
                "height": 1,
                "offsetX": 79.99999389797449,
                "offsetY": 60.52000045776367,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles244DiwnqK",
                "shape": {
                    "type": "Path",
                    "data": "M 0.1 , 80 L 159.9 , 80"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 159.79998779296875,
                "height": 1,
                "offsetX": 79.99999389797449,
                "offsetY": 80.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles245Qx8qHY",
                "shape": {
                    "type": "Path",
                    "data": "M 0.1 , 99.98 L 159.9 , 99.98"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 159.79998779296875,
                "height": 1,
                "offsetX": 79.99999389797449,
                "offsetY": 100.4800033569336,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles246KkwBoE",
                "shape": {
                    "type": "Path",
                    "data": "M 0.1 , 119.95 L 159.9 , 119.95"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 159.79998779296875,
                "height": 1,
                "offsetX": 79.99999389797449,
                "offsetY": 120.44999694824219,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles247QN0vGO",
                "shape": {
                    "type": "Path",
                    "data": "M 0.1 , 139.93 L 159.9 , 139.93"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 159.79998779296875,
                "height": 1,
                "offsetX": 79.99999389797449,
                "offsetY": 140.42999267578125,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles248l4MuIW",
                "shape": {
                    "type": "Path",
                    "data": "M 40.19 , 0.1 L 40.19 , 20.07"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.969999313354492,
                "offsetX": 40.689998626708984,
                "offsetY": 10.084999658167362,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles249ZNWpA2",
                "shape": {
                    "type": "Path",
                    "data": "M 80.15 , 0.1 L 80.15 , 20.07"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.969999313354492,
                "offsetX": 80.6500015258789,
                "offsetY": 10.084999658167362,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2410nkv0rr",
                "shape": {
                    "type": "Path",
                    "data": "M 120.1 , 0.1 L 120.1 , 20.07"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.969999313354492,
                "offsetX": 120.5999984741211,
                "offsetY": 10.084999658167362,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2411oMibcj",
                "shape": {
                    "type": "Path",
                    "data": "M 20.22 , 20.07 L 20.22 , 40.05"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.979999542236328,
                "offsetX": 20.719999313354492,
                "offsetY": 30.059999465942383,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2412hVDu1Q",
                "shape": {
                    "type": "Path",
                    "data": "M 60.17 , 20.07 L 60.17 , 40.05"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.979999542236328,
                "offsetX": 60.66999816894531,
                "offsetY": 30.059999465942383,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2413ZODKnw",
                "shape": {
                    "type": "Path",
                    "data": "M 100.12 , 20.07 L 100.12 , 40.05"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.979999542236328,
                "offsetX": 100.62000274658203,
                "offsetY": 30.059999465942383,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2414D9HUQy",
                "shape": {
                    "type": "Path",
                    "data": "M 140.07 , 20.07 L 140.07 , 40.05"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.979999542236328,
                "offsetX": 140.57000732421875,
                "offsetY": 30.059999465942383,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2415Uyuyb2",
                "shape": {
                    "type": "Path",
                    "data": "M 40.19 , 40.05 L 40.19 , 60.02"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.970001220703125,
                "offsetX": 40.689998626708984,
                "offsetY": 50.03499984741211,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2416FASXWm",
                "shape": {
                    "type": "Path",
                    "data": "M 80.15 , 40.05 L 80.15 , 60.02"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.970001220703125,
                "offsetX": 80.6500015258789,
                "offsetY": 50.03499984741211,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2417Rj1c5q",
                "shape": {
                    "type": "Path",
                    "data": "M 120.1 , 40.05 L 120.1 , 60.02"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.970001220703125,
                "offsetX": 120.5999984741211,
                "offsetY": 50.03499984741211,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2418FWY97o",
                "shape": {
                    "type": "Path",
                    "data": "M 20.22 , 60.02 L 20.22 , 80"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.979999542236328,
                "offsetX": 20.719999313354492,
                "offsetY": 70.01000022888184,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2419MaehOg",
                "shape": {
                    "type": "Path",
                    "data": "M 60.17 , 60.02 L 60.17 , 80"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.979999542236328,
                "offsetX": 60.66999816894531,
                "offsetY": 70.01000022888184,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2420gI66L8",
                "shape": {
                    "type": "Path",
                    "data": "M 100.12 , 60.02 L 100.12 , 80"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.979999542236328,
                "offsetX": 100.62000274658203,
                "offsetY": 70.01000022888184,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles24213917zX",
                "shape": {
                    "type": "Path",
                    "data": "M 140.07 , 60.02 L 140.07 , 80"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.979999542236328,
                "offsetX": 140.57000732421875,
                "offsetY": 70.01000022888184,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles24229dHXve",
                "shape": {
                    "type": "Path",
                    "data": "M 40.19 , 80 L 40.19 , 99.98"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.980003356933594,
                "offsetX": 40.689998626708984,
                "offsetY": 89.9900016784668,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2423KhIWUl",
                "shape": {
                    "type": "Path",
                    "data": "M 80.15 , 80 L 80.15 , 99.98"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.980003356933594,
                "offsetX": 80.6500015258789,
                "offsetY": 89.9900016784668,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2424wg6I7s",
                "shape": {
                    "type": "Path",
                    "data": "M 120.1 , 80 L 120.1 , 99.98"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.980003356933594,
                "offsetX": 120.5999984741211,
                "offsetY": 89.9900016784668,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2425WIIAg1",
                "shape": {
                    "type": "Path",
                    "data": "M 20.22 , 99.98 L 20.22 , 119.95"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.969993591308594,
                "offsetX": 20.719999313354492,
                "offsetY": 109.96500015258789,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles24265jrpPK",
                "shape": {
                    "type": "Path",
                    "data": "M 60.17 , 99.98 L 60.17 , 119.95"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.969993591308594,
                "offsetX": 60.66999816894531,
                "offsetY": 109.96500015258789,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2427P5e9F5",
                "shape": {
                    "type": "Path",
                    "data": "M 100.12 , 99.98 L 100.12 , 119.95"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.969993591308594,
                "offsetX": 100.62000274658203,
                "offsetY": 109.96500015258789,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2428wd8cn3",
                "shape": {
                    "type": "Path",
                    "data": "M 140.07 , 99.98 L 140.07 , 119.95"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.969993591308594,
                "offsetX": 140.57000732421875,
                "offsetY": 109.96500015258789,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2429yJVFr4",
                "shape": {
                    "type": "Path",
                    "data": "M 40.19 , 119.95 L 40.19 , 139.93"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.979995727539062,
                "offsetX": 40.689998626708984,
                "offsetY": 129.93999481201172,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2430muol47",
                "shape": {
                    "type": "Path",
                    "data": "M 80.15 , 119.95 L 80.15 , 139.93"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.979995727539062,
                "offsetX": 80.6500015258789,
                "offsetY": 129.93999481201172,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2431y3lb8s",
                "shape": {
                    "type": "Path",
                    "data": "M 120.1 , 119.95 L 120.1 , 139.93"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.979995727539062,
                "offsetX": 120.5999984741211,
                "offsetY": 129.93999481201172,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2432nTQ3m7",
                "shape": {
                    "type": "Path",
                    "data": "M 60.17 , 139.93 L 60.17 , 159.9"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.970001220703125,
                "offsetX": 60.66999816894531,
                "offsetY": 149.9149932861328,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2433fCg4UQ",
                "shape": {
                    "type": "Path",
                    "data": "M 100.12 , 139.93 L 100.12 , 159.9"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.970001220703125,
                "offsetX": 100.62000274658203,
                "offsetY": 149.9149932861328,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2434zmawQI",
                "shape": {
                    "type": "Path",
                    "data": "M 140.07 , 139.93 L 140.07 , 159.9"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#fff"
                },
                "width": 1,
                "height": 19.970001220703125,
                "offsetX": 140.57000732421875,
                "offsetY": 149.9149932861328,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Tiles2",
                "children": ["Tiles22stmjVB", "Tiles230DHUNEu", "Tiles2310HbO1H", "Tiles2324NrfYo", "Tiles233G9wEA3", "Tiles234vlevSv", "Tiles235qFW9rH", "Tiles236M6fxih", "Tiles237HnZRNG", "Tiles238UvvOaU", "Tiles239JjVYZp", "Tiles23102tLpjo", "Tiles2311e4R47b", "Tiles2312zf28hR", "Tiles23130E1j60", "Tiles2314xJQnGN", "Tiles2315kNtOrL", "Tiles2316E60RtB", "Tiles23172q94Sv", "Tiles2318OGZSf7", "Tiles2319K6Kpth", "Tiles23202rxWyi", "Tiles2321FGBgJa", "Tiles2322w6WTmI", "Tiles23239gzTTG", "Tiles2324pxH3YP", "Tiles2325YZnonY", "Tiles2326UsvPTq", "Tiles2327bDzXUM", "Tiles2328kxdVgb", "Tiles23298te1GM", "Tiles2330G4Whs8", "Tiles2331QWRFci", "Tiles240Whd4Kt", "Tiles241TF9wL6", "Tiles2420zOd8k", "Tiles243GNbmfh", "Tiles244DiwnqK", "Tiles245Qx8qHY", "Tiles246KkwBoE", "Tiles247QN0vGO", "Tiles248l4MuIW", "Tiles249ZNWpA2", "Tiles2410nkv0rr", "Tiles2411oMibcj", "Tiles2412hVDu1Q", "Tiles2413ZODKnw", "Tiles2414D9HUQy", "Tiles2415Uyuyb2", "Tiles2416FASXWm", "Tiles2417Rj1c5q", "Tiles2418FWY97o", "Tiles2419MaehOg", "Tiles2420gI66L8", "Tiles24213917zX", "Tiles24229dHXve", "Tiles2423KhIWUl", "Tiles2424wg6I7s", "Tiles2425WIIAg1", "Tiles24265jrpPK", "Tiles2427P5e9F5", "Tiles2428wd8cn3", "Tiles2429yJVFr4", "Tiles2430muol47", "Tiles2431y3lb8s", "Tiles2432nTQ3m7", "Tiles2433fCg4UQ", "Tiles2434zmawQI"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate2ScJFAL",
                "shape": {
                    "type": "Path",
                    "data": "M53.75,10.45l-40.3,40.3a3,3,0,0,0,0,4.24l62.22,62.23a3,3,0,0,0,4.24,0l12.17-12.17a4,4,0,0,1,6,.34l11.19,14a9.42,9.42,0,0,0,14.17,1h0A9.42,9.42,0,0,0,122.17,106l-14-10.58a4,4,0,0,1-.42-6l12.52-12.53a3,3,0,0,0,0-4.24L58,10.45A3,3,0,0,0,53.75,10.45Z"
                },
                "style": {
                    "fill": "#dda54a",
                    "strokeWidth": 0
                },
                "width": 113.62886047363281,
                "height": 113.56989288330078,
                "offsetX": 69.3870735168457,
                "offsetY": 66.35258197784424,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate300nXGJNh",
                "shape": {
                    "type": "Path",
                    "data": "M59,9.46S75.56,45.62,112.12,62.6"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#af7e38",
                    "strokeWidth": 0
                },
                "width": 53.12000274658203,
                "height": 53.13999938964844,
                "offsetX": 85.56000137329102,
                "offsetY": 36.02999973297119,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate301RC1HwM",
                "shape": {
                    "type": "Path",
                    "data": "M7.53,51.56S54,78.4,81.33,125.37"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#af7e38",
                    "strokeWidth": 0
                },
                "width": 73.80000305175781,
                "height": 73.80999755859375,
                "offsetX": 44.4300012588501,
                "offsetY": 88.46500015258789,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate302FHddZK",
                "shape": {
                    "type": "Path",
                    "data": "M45.11,6.9S72,53.33,118.92,80.71"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#af7e38",
                    "strokeWidth": 0
                },
                "width": 73.80999755859375,
                "height": 73.80999755859375,
                "offsetX": 82.01499938964844,
                "offsetY": 43.80499887466431,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate303Vk0fgE",
                "shape": {
                    "type": "Path",
                    "data": "M37.33,16.1s26.84,46.42,73.81,73.8"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#af7e38",
                    "strokeWidth": 0
                },
                "width": 73.80999755859375,
                "height": 73.80000305175781,
                "offsetX": 74.23500061035156,
                "offsetY": 53.00000190734863,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate304eJAS5U",
                "shape": {
                    "type": "Path",
                    "data": "M13.18,40.25S59.6,67.08,87,114.05"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#af7e38",
                    "strokeWidth": 0
                },
                "width": 73.81999969482422,
                "height": 73.80000305175781,
                "offsetX": 50.09000015258789,
                "offsetY": 77.1500015258789,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate305KvaZLn",
                "shape": {
                    "type": "Path",
                    "data": "M19.62,9.7s40.5,70,109.23,112.05"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#af7e38",
                    "strokeWidth": 0
                },
                "width": 109.2300033569336,
                "height": 112.05000305175781,
                "offsetX": 74.2350025177002,
                "offsetY": 65.72500133514404,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate4sr95s9",
                "shape": {
                    "type": "Path",
                    "data": "M107.7,89.44,117,80.11,13.45,50.75a3,3,0,0,0,0,4.24l62.22,62.23a3,3,0,0,0,4.24,0l12.17-12.17a4,4,0,0,1,6,.34l11.19,14A9.42,9.42,0,1,0,122.17,106l-14-10.58A4,4,0,0,1,107.7,89.44Z"
                },
                "style": {
                    "fill": "#c68f3e",
                    "strokeWidth": 0
                },
                "width": 113.66210174560547,
                "height": 72.41968536376953,
                "offsetX": 69.40369319915771,
                "offsetY": 86.95984268188477,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate56XTnFd",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#ea463d"
                },
                "width": 24,
                "height": 24,
                "offsetX": 40,
                "offsetY": 55,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate6LxT27V",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#ff4729"
                },
                "width": 24,
                "height": 24,
                "offsetX": 40,
                "offsetY": 54,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate7cUHXrH",
                "shape": {
                    "type": "Path",
                    "data": "M48.93,56c.61,0,1.07.42,1,.9-.56,4-4.8,7.1-9.94,7.1s-9.32-3.06-9.93-7c-.08-.52.44-1,1.1-1h1.09A10.93,10.93,0,0,1,37,57.06h0a7.1,7.1,0,0,0,5.66.16l.1,0A16.42,16.42,0,0,1,48.93,56Z"
                },
                "style": {
                    "fill": "#be2c1c",
                    "strokeWidth": 0
                },
                "width": 19.885190963745117,
                "height": 8.000133514404297,
                "offsetX": 39.99445056915283,
                "offsetY": 59.99993324279785,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate8wbLoTv",
                "shape": {
                    "type": "Path",
                    "data": "M48.93,52c.61,0,1.07-.42,1-.9-.56-4-4.8-7.1-9.94-7.1s-9.32,3.06-9.93,7c-.08.52.44,1,1.1,1h1.09A10.93,10.93,0,0,0,37,50.94h0a7.1,7.1,0,0,1,5.66-.16l.1,0A16.42,16.42,0,0,0,48.93,52Z"
                },
                "style": {
                    "fill": "#be2c1c",
                    "strokeWidth": 0
                },
                "width": 19.885190963745117,
                "height": 8.000133514404297,
                "offsetX": 39.99445056915283,
                "offsetY": 48.00006675720215,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate93O2tqG",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1,
                "height": 3,
                "offsetX": 39.5,
                "offsetY": 61.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate10VbZbnh",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1,
                "height": 3,
                "offsetX": 42.5,
                "offsetY": 60.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate11wdUmtZ",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1,
                "height": 3,
                "offsetX": 44.5,
                "offsetY": 59.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate12I72mOF",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1,
                "height": 3,
                "offsetX": 46.5,
                "offsetY": 58.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate13rLVUWQ",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 1.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 3,
                "height": 1,
                "offsetX": 36.709999084472656,
                "offsetY": 60.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate14YGSk47",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 1.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 3,
                "height": 1,
                "offsetX": 34.709999084472656,
                "offsetY": 59.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate15sayvct",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 1.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 3,
                "height": 1,
                "offsetX": 32.709999084472656,
                "offsetY": 58.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate16UL92RY",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1,
                "height": 3,
                "offsetX": 39.5,
                "offsetY": 46.63999938964844,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate177CEKeP",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 1.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 3,
                "height": 1,
                "offsetX": 42.5,
                "offsetY": 47.63999938964844,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate18z2AH5q",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 1.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 3,
                "height": 1,
                "offsetX": 44.5,
                "offsetY": 48.63999938964844,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate19v0BVfm",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 1.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 3,
                "height": 1,
                "offsetX": 46.5,
                "offsetY": 49.63999938964844,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate20GnQ0YG",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1,
                "height": 3,
                "offsetX": 36.709999084472656,
                "offsetY": 47.63999938964844,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate21DSUePI",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1,
                "height": 3,
                "offsetX": 34.709999084472656,
                "offsetY": 48.63999938964844,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate2227Vzgu",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1,
                "height": 3,
                "offsetX": 32.709999084472656,
                "offsetY": 49.63999938964844,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate23hiV6F3",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#ea463d"
                },
                "width": 24,
                "height": 24,
                "offsetX": 54.5,
                "offsetY": 32.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate24onkOiM",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#ff4729"
                },
                "width": 24,
                "height": 24,
                "offsetX": 53.5,
                "offsetY": 32.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate25wEdaTe",
                "shape": {
                    "type": "Path",
                    "data": "M55.5,41.43c0,.61.42,1.07.9,1,4-.56,7.1-4.8,7.1-9.94s-3.06-9.32-7-9.93c-.52-.08-1,.44-1,1.1v1.09a10.93,10.93,0,0,0,1.06,4.73h0a7.1,7.1,0,0,1,.16,5.66l0,.1a16.42,16.42,0,0,0-1.19,6.18Z"
                },
                "style": {
                    "fill": "#be2c1c",
                    "strokeWidth": 0
                },
                "width": 8.000053405761719,
                "height": 19.885190963745117,
                "offsetX": 59.49997329711914,
                "offsetY": 32.49445056915283,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate26pdK43M",
                "shape": {
                    "type": "Path",
                    "data": "M51.5,41.43c0,.61-.42,1.07-.9,1-4-.56-7.1-4.8-7.1-9.94s3.06-9.32,7-9.93c.52-.08,1,.44,1,1.1v1.09a10.93,10.93,0,0,1-1.06,4.73h0a7.1,7.1,0,0,0-.16,5.66l0,.1a16.42,16.42,0,0,1,1.19,6.18Z"
                },
                "style": {
                    "fill": "#be2c1c",
                    "strokeWidth": 0
                },
                "width": 8.000057220458984,
                "height": 19.885190963745117,
                "offsetX": 47.50002861022949,
                "offsetY": 32.49445056915283,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate27x6LTyH",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 1.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 3,
                "height": 1,
                "offsetX": 61,
                "offsetY": 32,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate28DhSpPF",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1,
                "height": 3,
                "offsetX": 60,
                "offsetY": 35,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate29n2c6fX",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1,
                "height": 3,
                "offsetX": 59,
                "offsetY": 37,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate30RHdnHu",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1,
                "height": 3,
                "offsetX": 58,
                "offsetY": 39,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate31yqpGxK",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 1.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 3,
                "height": 1,
                "offsetX": 60,
                "offsetY": 29.209999084472656,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate32YLTO7R",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 1.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 3,
                "height": 1,
                "offsetX": 59,
                "offsetY": 27.209999084472656,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate33NCMEFk",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 1.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 3,
                "height": 1,
                "offsetX": 58,
                "offsetY": 25.209999084472656,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate34kYPmgk",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 1.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 3,
                "height": 1,
                "offsetX": 46.13999938964844,
                "offsetY": 32,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate358aPVWf",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 1.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 3,
                "height": 1,
                "offsetX": 47.13999938964844,
                "offsetY": 35,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate36rylrEt",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 1.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 3,
                "height": 1,
                "offsetX": 48.13999938964844,
                "offsetY": 37,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate37Iazz8S",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 1.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 3,
                "height": 1,
                "offsetX": 49.13999938964844,
                "offsetY": 39,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate38lcPr5w",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1,
                "height": 3,
                "offsetX": 47.13999938964844,
                "offsetY": 29.209999084472656,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate39bqLmdk",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1,
                "height": 3,
                "offsetX": 48.13999938964844,
                "offsetY": 27.209999084472656,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate40lITyMq",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 0.5
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 1,
                "height": 3,
                "offsetX": 49.13999938964844,
                "offsetY": 25.209999084472656,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate41LaAbHw",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#89344d"
                },
                "width": 22,
                "height": 22,
                "offsetX": 73,
                "offsetY": 51,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate42EVqFOe",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 19.80000114440918,
                "height": 19.80000114440918,
                "offsetX": 72.99999904632568,
                "offsetY": 50.999999046325684,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate43NZ2S16",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#89344d"
                },
                "width": 16,
                "height": 16,
                "offsetX": 73,
                "offsetY": 51,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate44SdSsfs",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 14.40000057220459,
                "height": 14.40000057220459,
                "offsetX": 73.00000333786011,
                "offsetY": 50.99999952316284,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate45k2hjhI",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#89344d"
                },
                "width": 12,
                "height": 12,
                "offsetX": 73,
                "offsetY": 51,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate46hsYWsP",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 10.800000190734863,
                "height": 10.800000190734863,
                "offsetX": 72.99999856948853,
                "offsetY": 50.999998569488525,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate47QmHI58",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#89344d"
                },
                "width": 8,
                "height": 8,
                "offsetX": 73,
                "offsetY": 51,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate48hg5K8K",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 7.200000286102295,
                "height": 7.200000286102295,
                "offsetX": 73.00000166893005,
                "offsetY": 51.000001668930054,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate49jWHrMg",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#89344d"
                },
                "width": 4,
                "height": 4,
                "offsetX": 73,
                "offsetY": 51,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate50o4o2uo",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 3.6000001430511475,
                "height": 3.6000001430511475,
                "offsetX": 72.99999701976776,
                "offsetY": 51.00000083446503,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate51bnMMSK",
                "shape": {
                    "type": "Path",
                    "data": "M78.88,46a8.93,8.93,0,1,0,8.92,8.93A8.93,8.93,0,0,0,78.88,46Zm0,16.23a7.31,7.31,0,1,1,7.29-7.3A7.3,7.3,0,0,1,78.88,62.18Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeColor": "#89344d",
                    "strokeWidth": 0
                },
                "width": 17.860000610351562,
                "height": 17.860000610351562,
                "offsetX": 78.86998748779297,
                "offsetY": 54.929996490478516,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate52p7NOXD",
                "shape": {
                    "type": "Path",
                    "data": "M85.35,50.91a7.44,7.44,0,1,0,7.44,7.44A7.44,7.44,0,0,0,85.35,50.91Zm0,13.53a6.09,6.09,0,1,1,6.09-6.09A6.09,6.09,0,0,1,85.35,64.44Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeColor": "#89344d",
                    "strokeWidth": 0
                },
                "width": 14.8800048828125,
                "height": 14.880001068115234,
                "offsetX": 85.35000610351562,
                "offsetY": 58.35000038146973,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate53zin3TC",
                "shape": {
                    "type": "Path",
                    "data": "M41.72,67.19l69.89,28.13-5.41,14.47S48.19,86.58,41.72,67.19Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 69.88999938964844,
                "height": 42.599998474121094,
                "offsetX": 76.66500091552734,
                "offsetY": 88.4900016784668,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate54NTHVeF",
                "shape": {
                    "type": "Path",
                    "data": "M44.68,68.38l-3-1.19c6.47,19.39,64.48,42.6,64.48,42.6l.7-1.88C104.8,107.08,51.1,85.63,44.68,68.38Z"
                },
                "style": {
                    "fill": "#cfcfcf",
                    "strokeWidth": 0
                },
                "width": 65.18000030517578,
                "height": 42.599998474121094,
                "offsetX": 74.27000045776367,
                "offsetY": 88.48999404907227,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate55DlTNu8",
                "shape": {
                    "type": "Path",
                    "data": "M111.61,95.32l31.52,12.88a5.07,5.07,0,0,1,2.93,6.21h0a3,3,0,0,1-3.92,1.88l-33.4-13.18Z"
                },
                "style": {
                    "fill": "#5b3b24",
                    "strokeWidth": 0
                },
                "width": 37.551048278808594,
                "height": 21.165740966796875,
                "offsetX": 127.51552200317383,
                "offsetY": 105.90287017822266,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate56vB3CEW",
                "shape": {
                    "type": "Path",
                    "data": "M110.15,102.43l32.17,12.65a.4.4,0,0,0,.53-.25v0a.41.41,0,0,0-.23-.5l-32.19-12.61a.4.4,0,0,0-.53.26h0A.39.39,0,0,0,110.15,102.43Z"
                },
                "style": {
                    "fill": "#7f502f",
                    "strokeWidth": 0
                },
                "width": 32.977745056152344,
                "height": 13.416351318359375,
                "offsetX": 126.38000869750977,
                "offsetY": 108.40054321289062,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Vegetable_CuttingPlate",
                "children": ["Vegetable_CuttingPlate2ScJFAL", "Vegetable_CuttingPlate300nXGJNh", "Vegetable_CuttingPlate301RC1HwM", "Vegetable_CuttingPlate302FHddZK", "Vegetable_CuttingPlate303Vk0fgE", "Vegetable_CuttingPlate304eJAS5U", "Vegetable_CuttingPlate305KvaZLn", "Vegetable_CuttingPlate4sr95s9", "Vegetable_CuttingPlate56XTnFd", "Vegetable_CuttingPlate6LxT27V", "Vegetable_CuttingPlate7cUHXrH", "Vegetable_CuttingPlate8wbLoTv", "Vegetable_CuttingPlate93O2tqG", "Vegetable_CuttingPlate10VbZbnh", "Vegetable_CuttingPlate11wdUmtZ", "Vegetable_CuttingPlate12I72mOF", "Vegetable_CuttingPlate13rLVUWQ", "Vegetable_CuttingPlate14YGSk47", "Vegetable_CuttingPlate15sayvct", "Vegetable_CuttingPlate16UL92RY", "Vegetable_CuttingPlate177CEKeP", "Vegetable_CuttingPlate18z2AH5q", "Vegetable_CuttingPlate19v0BVfm", "Vegetable_CuttingPlate20GnQ0YG", "Vegetable_CuttingPlate21DSUePI", "Vegetable_CuttingPlate2227Vzgu", "Vegetable_CuttingPlate23hiV6F3", "Vegetable_CuttingPlate24onkOiM", "Vegetable_CuttingPlate25wEdaTe", "Vegetable_CuttingPlate26pdK43M", "Vegetable_CuttingPlate27x6LTyH", "Vegetable_CuttingPlate28DhSpPF", "Vegetable_CuttingPlate29n2c6fX", "Vegetable_CuttingPlate30RHdnHu", "Vegetable_CuttingPlate31yqpGxK", "Vegetable_CuttingPlate32YLTO7R", "Vegetable_CuttingPlate33NCMEFk", "Vegetable_CuttingPlate34kYPmgk", "Vegetable_CuttingPlate358aPVWf", "Vegetable_CuttingPlate36rylrEt", "Vegetable_CuttingPlate37Iazz8S", "Vegetable_CuttingPlate38lcPr5w", "Vegetable_CuttingPlate39bqLmdk", "Vegetable_CuttingPlate40lITyMq", "Vegetable_CuttingPlate41LaAbHw", "Vegetable_CuttingPlate42EVqFOe", "Vegetable_CuttingPlate43NZ2S16", "Vegetable_CuttingPlate44SdSsfs", "Vegetable_CuttingPlate45k2hjhI", "Vegetable_CuttingPlate46hsYWsP", "Vegetable_CuttingPlate47QmHI58", "Vegetable_CuttingPlate48hg5K8K", "Vegetable_CuttingPlate49jWHrMg", "Vegetable_CuttingPlate50o4o2uo", "Vegetable_CuttingPlate51bnMMSK", "Vegetable_CuttingPlate52p7NOXD", "Vegetable_CuttingPlate53zin3TC", "Vegetable_CuttingPlate54NTHVeF", "Vegetable_CuttingPlate55DlTNu8", "Vegetable_CuttingPlate56vB3CEW"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "VerticalWall2DppOoX",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#464747"
                },
                "width": 113,
                "height": 14,
                "offsetX": 81,
                "offsetY": 80.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "VerticalWall",
                "children": ["VerticalWall2DppOoX"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Wardrobe2DkdyWy",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "url(#linear-gradient)"
                },
                "width": 77,
                "height": 4,
                "offsetX": 38.5,
                "offsetY": 100,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Wardrobe3I9qfIw",
                "shape": {
                    "type": "Path",
                    "data": "M160 101.29 83.92 111.29 82.92 107.54 160 97.54 160 101.29"
                },
                "style": {
                    "fill": "url(#linear-gradient-2)"
                },
                "width": 77.08000183105469,
                "height": 13.75,
                "offsetX": 121.45999908447266,
                "offsetY": 104.41500091552734,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Wardrobe41tIQyC",
                "shape": {
                    "type": "Path",
                    "data": "M4,54H156a4,4,0,0,1,4,4V98a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V58A4,4,0,0,1,4,54Z"
                },
                "style": {
                    "fill": "#522c0a",
                    "strokeWidth": 0
                },
                "width": 160,
                "height": 44,
                "offsetX": 80,
                "offsetY": 76,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Wardrobe5Kkgznd",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 0.5
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 3,
                "height": 1,
                "offsetX": 49.5,
                "offsetY": 102.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Wardrobe6o9EXmW",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 0.5
                },
                "style": {
                    "fill": "#522c0a"
                },
                "width": 3,
                "height": 1,
                "offsetX": 115.17000579833984,
                "offsetY": 107.69000244140625,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Wardrobe",
                "children": ["Wardrobe2DkdyWy", "Wardrobe3I9qfIw", "Wardrobe41tIQyC", "Wardrobe5Kkgznd", "Wardrobe6o9EXmW"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Washbasin2xLatbz",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 43.5
                },
                "style": {
                    "fill": "#707070"
                },
                "width": 87,
                "height": 87,
                "offsetX": 82.5,
                "offsetY": 80.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Washbasin30qnQfG",
                "shape": {
                    "type": "Path",
                    "data": "M84,50H81A34,34,0,0,0,47,84h0a34,34,0,0,0,34,34h3a34,34,0,0,0,34-34h0A34,34,0,0,0,84,50ZM82,86a6,6,0,1,1,6-6A6,6,0,0,1,82,86Z"
                },
                "style": {
                    "fill": "#d1d2d3",
                    "strokeWidth": 0
                },
                "width": 71,
                "height": 68,
                "offsetX": 82.5,
                "offsetY": 84,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Washbasin4cmVZFl",
                "shape": {
                    "type": "Path",
                    "data": "M57.21,107.79a33.77,33.77,0,0,1,0-47.75h0C70.45,46.85,93.83,45.83,107,59Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 59.677005767822266,
                "height": 58.17007827758789,
                "offsetX": 77.16149711608887,
                "offsetY": 78.7049617767334,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Washbasin5WpMfbs",
                "shape": {
                    "type": "Path",
                    "data": "M82.3,38.32h0A3.69,3.69,0,0,1,86,42.22l-1.07,19.9A2.63,2.63,0,0,1,82.3,64.6h0a2.62,2.62,0,0,1-2.62-2.48L78.6,42.22A3.71,3.71,0,0,1,82.3,38.32Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 7.410850524902344,
                "height": 26.280040740966797,
                "offsetX": 82.30055618286133,
                "offsetY": 51.45998573303223,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Washbasin",
                "children": ["Washbasin2xLatbz", "Washbasin30qnQfG", "Washbasin4cmVZFl", "Washbasin5WpMfbs"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Washbasin12HCS1Cb",
                "shape": {
                    "type": "Path",
                    "data": "M84.13,112.33h0A50.88,50.88,0,0,1,33.32,64.12,12.87,12.87,0,0,1,34,59.2V51a3.29,3.29,0,0,1,3.29-3.29h92.9a4,4,0,0,1,4,4V59.2a13.06,13.06,0,0,1,.71,4.92A50.89,50.89,0,0,1,84.13,112.33Z"
                },
                "style": {
                    "fill": "#dbdcdd",
                    "strokeWidth": 0
                },
                "width": 101.6159439086914,
                "height": 64.62001037597656,
                "offsetX": 84.1071891784668,
                "offsetY": 80.02000427246094,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Washbasin13fWI7lW",
                "shape": {
                    "type": "Path",
                    "data": "M84.13,106.33h0C62.9,106.33,45.4,93,43,75.87a13.27,13.27,0,0,1,.91-7l.8-1.91c1.14-2.72,4.23-4.55,7.69-4.55h63.51c3.46,0,6.55,1.83,7.69,4.55l.79,1.91a13.18,13.18,0,0,1,.92,7C122.86,93,105.36,106.33,84.13,106.33Z"
                },
                "style": {
                    "fill": "#7f7f7f",
                    "strokeWidth": 0
                },
                "width": 82.56951904296875,
                "height": 43.92000198364258,
                "offsetX": 84.15504455566406,
                "offsetY": 84.3700008392334,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Washbasin14bwxPiq",
                "shape": {
                    "type": "Path",
                    "data": "M55,96.21s28.25-41,58,0C113,96.21,85.16,118.24,55,96.21Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 58,
                "height": 28.013328552246094,
                "offsetX": 84,
                "offsetY": 91.99444961547852,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Washbasin156XUxTC",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 9,
                "height": 9,
                "offsetX": 84.5,
                "offsetY": 84.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Washbasin16SjrokS",
                "shape": {
                    "type": "Path",
                    "data": "M83.38,50.32h0a3.7,3.7,0,0,1,3.7,3.9L86,74.12a2.62,2.62,0,0,1-2.62,2.48h0a2.63,2.63,0,0,1-2.62-2.48l-1.07-19.9A3.69,3.69,0,0,1,83.38,50.32Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 7.401397705078125,
                "height": 26.280014038085938,
                "offsetX": 83.38471221923828,
                "offsetY": 63.459999084472656,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Washbasin1",
                "children": ["Washbasin12HCS1Cb", "Washbasin13fWI7lW", "Washbasin14bwxPiq", "Washbasin156XUxTC", "Washbasin16SjrokS"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Washbasin22mwWtpz",
                "shape": {
                    "type": "Path",
                    "data": "M42,118.5V44.6A5.6,5.6,0,0,1,47.6,39h75.53a5.58,5.58,0,0,1,5.6,5.73c-.42,19-7.58,78.46-81,79.37A5.61,5.61,0,0,1,42,118.5Z"
                },
                "style": {
                    "fill": "#dbdcdd",
                    "strokeWidth": 0
                },
                "width": 86.73202514648438,
                "height": 85.10133361816406,
                "offsetX": 85.36600875854492,
                "offsetY": 81.55062103271484,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Washbasin23RiEEC4",
                "shape": {
                    "type": "Path",
                    "data": "M48,109.94V49.57A4.58,4.58,0,0,1,52.57,45h61.7a4.57,4.57,0,0,1,4.57,4.68c-.34,15.48-6.19,64.13-66.26,64.83A4.55,4.55,0,0,1,48,109.94Z"
                },
                "style": {
                    "fill": "#7f7f7f",
                    "strokeWidth": 0
                },
                "width": 70.84136962890625,
                "height": 69.51010131835938,
                "offsetX": 83.4206428527832,
                "offsetY": 79.75504684448242,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Washbasin24R1ibaH",
                "shape": {
                    "type": "Path",
                    "data": "M48,103V50a5,5,0,0,1,5-5h52S105,89.12,48,103Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 57,
                "height": 58,
                "offsetX": 76.5,
                "offsetY": 74,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Washbasin258VaJeD",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 7,
                "height": 7,
                "offsetX": 65,
                "offsetY": 61,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Washbasin26XjKRF6",
                "shape": {
                    "type": "Path",
                    "data": "M84.34,41.29h0a2.31,2.31,0,0,1,2.3,2.43L86,56.07a1.63,1.63,0,0,1-1.63,1.54h0a1.62,1.62,0,0,1-1.62-1.54l-.67-12.35A2.3,2.3,0,0,1,84.34,41.29Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 4.5668182373046875,
                "height": 16.320003509521484,
                "offsetX": 84.3597183227539,
                "offsetY": 49.450002670288086,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Washbasin2",
                "children": ["Washbasin22mwWtpz", "Washbasin23RiEEC4", "Washbasin24R1ibaH", "Washbasin258VaJeD", "Washbasin26XjKRF6"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WashBasin_Mirror2siLuxk",
                "shape": {
                    "type": "Path",
                    "data": "M0,32H160a0,0,0,0,1,0,0v79a10,10,0,0,1-10,10H10A10,10,0,0,1,0,111V32A0,0,0,0,1,0,32Z"
                },
                "style": {
                    "fill": "#270805",
                    "strokeWidth": 0
                },
                "width": 160,
                "height": 89,
                "offsetX": 80,
                "offsetY": 76.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WashBasin_Mirror3Q9PxVP",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#dbdcdd"
                },
                "width": 160,
                "height": 7.819999694824219,
                "offsetX": 80,
                "offsetY": 35.90999984741211,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WashBasin_Mirror4a4GtBc",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "#c2c3c4"
                },
                "width": 160,
                "height": 7.819999694824219,
                "offsetX": 80,
                "offsetY": 43.72999954223633,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WashBasin_Mirror5Ec581y",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 44.5
                },
                "style": {
                    "fill": "#dbdcdd"
                },
                "width": 89,
                "height": 48,
                "offsetX": 81.5,
                "offsetY": 85,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WashBasin_Mirror6xYjsZx",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse",
                    "cornerRadius": 40.5
                },
                "style": {
                    "fill": "#7f7f7f"
                },
                "width": 81,
                "height": 42,
                "offsetX": 81.5,
                "offsetY": 85,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WashBasin_Mirror7H0IdfR",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fcfcfc"
                },
                "width": 6.420000076293945,
                "height": 6.420000076293945,
                "offsetX": 81.59999942779541,
                "offsetY": 77.32000064849854,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WashBasin_Mirror8JGH6zw",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle",
                    "cornerRadius": 1
                },
                "style": {
                    "fill": "#2080ce"
                },
                "width": 7.4599995613098145,
                "height": 10.529999732971191,
                "offsetX": 146.5499918460846,
                "offsetY": 86.38500261306763,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WashBasin_Mirror9K7WbYf",
                "shape": {
                    "type": "Path",
                    "data": "M81.09,53.8h0a2.18,2.18,0,0,1,2.17,2.29l-.63,11.68a1.55,1.55,0,0,1-1.54,1.46h0a1.55,1.55,0,0,1-1.54-1.46l-.63-11.68A2.17,2.17,0,0,1,81.09,53.8Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 4.346092224121094,
                "height": 15.430004119873047,
                "offsetX": 81.08972549438477,
                "offsetY": 61.51500129699707,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WashBasin_Mirror10UE5NjR",
                "shape": {
                    "type": "Path",
                    "data": "M87.65,56.31h0a2.18,2.18,0,0,1,2.29-2.17l11.68.63a1.54,1.54,0,0,1,1.45,1.54h0a1.54,1.54,0,0,1-1.45,1.54l-11.68.63A2.17,2.17,0,0,1,87.65,56.31Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 15.420013427734375,
                "height": 4.346099853515625,
                "offsetX": 95.36000061035156,
                "offsetY": 56.310272216796875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WashBasin_Mirror116kqZx9",
                "shape": {
                    "type": "Path",
                    "data": "M74.91,56.31h0a2.18,2.18,0,0,0-2.29-2.17l-11.68.63a1.54,1.54,0,0,0-1.45,1.54h0a1.54,1.54,0,0,0,1.45,1.54l11.68.63A2.17,2.17,0,0,0,74.91,56.31Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 15.420013427734375,
                "height": 4.346099853515625,
                "offsetX": 67.20000457763672,
                "offsetY": 56.310272216796875,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WashBasin_Mirror125Y2eYg",
                "shape": {
                    "type": "Path",
                    "data": "M133.54,47.64h18.55a0,0,0,0,1,0,0V49.7a1,1,0,0,1-1,1H134.54a1,1,0,0,1-1-1V47.64A0,0,0,0,1,133.54,47.64Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 18.550003051757812,
                "height": 3.0600013732910156,
                "offsetX": 142.81499481201172,
                "offsetY": 49.170000076293945,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WashBasin_Mirror13dEOJiO",
                "shape": {
                    "type": "Path",
                    "data": "M10.2,47.64H28.75a0,0,0,0,1,0,0V49.7a1,1,0,0,1-1,1H11.2a1,1,0,0,1-1-1V47.64A0,0,0,0,1,10.2,47.64Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 18.549999237060547,
                "height": 3.0600013732910156,
                "offsetX": 19.47499942779541,
                "offsetY": 49.170000076293945,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WashBasin_Mirror14YGyxGd",
                "shape": {
                    "type": "Path",
                    "data": "M143.82,91.65a1,1,0,0,1-1-1V82.12a1,1,0,0,1,1-1h5.45a1,1,0,0,1,1,1Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 7.4499969482421875,
                "height": 10.529998779296875,
                "offsetX": 146.54500579833984,
                "offsetY": 86.38500213623047,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WashBasin_Mirror",
                "children": ["WashBasin_Mirror2siLuxk", "WashBasin_Mirror3Q9PxVP", "WashBasin_Mirror4a4GtBc", "WashBasin_Mirror5Ec581y", "WashBasin_Mirror6xYjsZx", "WashBasin_Mirror7H0IdfR", "WashBasin_Mirror8JGH6zw", "WashBasin_Mirror9K7WbYf", "WashBasin_Mirror10UE5NjR", "WashBasin_Mirror116kqZx9", "WashBasin_Mirror125Y2eYg", "WashBasin_Mirror13dEOJiO", "WashBasin_Mirror14YGyxGd"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WesternToilet2ejhIJI",
                "shape": {
                    "type": "Path",
                    "data": "M104.14,126.31l-3.49.52a99.9,99.9,0,0,1-29.3,0l-3.49-.52a15.15,15.15,0,0,1-12-9.71h0a100,100,0,0,1-4.31-54.43L53,55h66l1.43,7.17a100,100,0,0,1-4.31,54.43h0A15.15,15.15,0,0,1,104.14,126.31Z"
                },
                "style": {
                    "fill": "#7f7f7f",
                    "strokeWidth": 0
                },
                "width": 72.76765441894531,
                "height": 72.91001892089844,
                "offsetX": 85.99000930786133,
                "offsetY": 91.45500946044922,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WesternToilet3KTKBGm",
                "shape": {
                    "type": "Path",
                    "data": "M102.24,66.88a3.76,3.76,0,0,1,7.52,0"
                },
                "style": {
                    "fill": "#aaa",
                    "strokeWidth": 0
                },
                "width": 7.519996643066406,
                "height": 3.759998321533203,
                "offsetX": 105.99999618530273,
                "offsetY": 64.99999809265137,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WesternToilet46UeEKg",
                "shape": {
                    "type": "Path",
                    "data": "M63.34,66.88a3.76,3.76,0,0,1,7.52,0"
                },
                "style": {
                    "fill": "#aaa",
                    "strokeWidth": 0
                },
                "width": 7.520000457763672,
                "height": 3.759998321533203,
                "offsetX": 67.10000038146973,
                "offsetY": 64.99999809265137,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WesternToilet5Qhlt74",
                "shape": {
                    "type": "Path",
                    "data": "M100.37,123.48l-2.76.41a79.25,79.25,0,0,1-23.22,0l-2.76-.41a12,12,0,0,1-9.49-7.69h0a79.18,79.18,0,0,1-3.41-43.11L59.86,67h52.28l1.13,5.68a79.18,79.18,0,0,1-3.41,43.11h0A12,12,0,0,1,100.37,123.48Z"
                },
                "style": {
                    "fill": "#dbdcdd",
                    "strokeWidth": 0
                },
                "width": 57.623321533203125,
                "height": 57.74504089355469,
                "offsetX": 86,
                "offsetY": 95.87252044677734,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WesternToilet62T4DMx",
                "shape": {
                    "type": "Path",
                    "data": "M124.87,56.43h0a195.15,195.15,0,0,1-78.74,0h0a4.75,4.75,0,0,1-3.79-4.66V33.7A4.75,4.75,0,0,1,47.09,29h76.82a4.75,4.75,0,0,1,4.75,4.75V51.77A4.75,4.75,0,0,1,124.87,56.43Z"
                },
                "style": {
                    "fill": "#dbdcdd",
                    "strokeWidth": 0
                },
                "width": 86.32000732421875,
                "height": 31.44255828857422,
                "offsetX": 85.50000381469727,
                "offsetY": 44.72127914428711,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WesternToilet7Efn1WE",
                "shape": {
                    "type": "Path",
                    "data": "M57.84,78.09a79.28,79.28,0,0,0,4.3,37.7,12,12,0,0,0,9.49,7.69l2.76.41a79.25,79.25,0,0,0,23.22,0l2.76-.41a12,12,0,0,0,9.49-7.69,79.22,79.22,0,0,0,4.3-37.69C98.79,75.68,78.34,74.25,57.84,78.09Z"
                },
                "style": {
                    "fill": "#fff",
                    "strokeWidth": 0
                },
                "width": 57.619293212890625,
                "height": 49.02782440185547,
                "offsetX": 86.0002212524414,
                "offsetY": 100.23112869262695,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WesternToilet8xrYXIk",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#fff"
                },
                "width": 13,
                "height": 13,
                "offsetX": 85.5,
                "offsetY": 44.70000076293945,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WesternToilet95jp9aq",
                "shape": {
                    "type": "Basic",
                    "shape": "Ellipse"
                },
                "style": {
                    "fill": "#7f7f7f"
                },
                "width": 9,
                "height": 9,
                "offsetX": 85.5,
                "offsetY": 44.70000076293945,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "WesternToilet",
                "children": ["WesternToilet2ejhIJI", "WesternToilet3KTKBGm", "WesternToilet46UeEKg", "WesternToilet5Qhlt74", "WesternToilet62T4DMx", "WesternToilet7Efn1WE", "WesternToilet8xrYXIk", "WesternToilet95jp9aq"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Window2fCDmck",
                "shape": {
                    "type": "Path",
                    "data": "M 43.5 , 82.5 L 122.5 , 82.5"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 79,
                "height": 1,
                "offsetX": 83,
                "offsetY": 83,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Window3uNXEd7",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 6,
                "height": 6,
                "offsetX": 40.5,
                "offsetY": 82.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Window4bK3fDw",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 6,
                "height": 6,
                "offsetX": 125.5,
                "offsetY": 82.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Window5GxztBi",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 4,
                "height": 14,
                "offsetX": 130.5,
                "offsetY": 82.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Window6EfrhSt",
                "shape": {
                    "type": "Basic",
                    "shape": "Rectangle"
                },
                "style": {
                    "fill": "none",
                    "strokeColor": "#464747"
                },
                "width": 4,
                "height": 14,
                "offsetX": 35.5,
                "offsetY": 82.5,
                "addInfo": {
                    "type": "CustomShapes"
                }
            }, {
                "id": "Window",
                "children": ["Window2fCDmck", "Window3uNXEd7", "Window4bK3fDw", "Window5GxztBi", "Window6EfrhSt"],
                "addInfo": {
                    "type": "CustomShapes"
                }
            }
        ];
          for (let i = 0; i < floorPlanShapes.length; i++) {
            if(!floorPlanShapes[i].children) {
                floorPlanShapes[i].constraints = NodeConstraints.Default & ~NodeConstraints.Select;
            }
        }
        return floorPlanShapes;
    }
}